'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var axios = require('axios');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);

var iotAlertDataMgmt = {
  "iot-alert-data-mgmt.10001": "can not found the event record id = [{0}]"
};

var iotAlertDataMgmtEn = {
  "iot-alert-data-mgmt.10001": "can not found the event record id = [{0}]"
};

var iotAlertMgmt = {
  "iot-alert-mgmt.10001": "\u65E0\u6548\u7684\u544A\u8B66\u89C4\u5219",
  "iot-alert-mgmt.10002": "\u89C4\u5219\u540D\u79F0\u5DF2\u5B58\u5728",
  "iot-alert-mgmt.10003": "\u65E0\u6548\u7684\u544A\u8B66\u89C4\u5219\u72B6\u6001",
  "iot-alert-mgmt.10004": "\u544A\u8B66\u89C4\u5219\u4E0D\u5B58\u5728",
  "iot-alert-mgmt.10005": "Elasticsearch error",
  "iot-alert-mgmt.10006": "\u544A\u8B66\u89C4\u5219\u7684\u89C4\u5219\u7C7B\u578B\u65E0\u6548",
  "iot-alert-mgmt.10007": "\u8FB9\u7F18\u8BA1\u7B97\u89C4\u5219\u540D\u79F0\u91CD\u590D",
  "iot-alert-mgmt.10008": "\u8BE5\u8FB9\u7F18\u8BA1\u7B97\u89C4\u5219\u4E0D\u5B58\u5728",
  "iot-alert-mgmt.10009": "\u8FB9\u7F18\u8BA1\u7B97\u89C4\u5219\u4E0B\u53D1\u5386\u53F2\u4E0D\u5B58\u5728",
  "iot-alert-mgmt.10010": "\u8FB9\u7F18\u8BA1\u7B97\u89C4\u5219\u4E0B\u53D1\u6570\u636E\u4E0D\u5B58\u5728",
  "iot-alert-mgmt.10011": "can not find specification for tenant[id={0}]",
  "iot-alert-mgmt.10012": "\u65B0\u589E\u89C4\u5219\u5931\u8D25\uFF0C\u8D85\u51FA\u89C4\u5219\u6570\u91CF",
  "iot-alert-mgmt.10013": "things forward rule[id={0}] is not exist",
  "iot-alert-mgmt.10014": "things select size is 0",
  "iot-alert-mgmt.10015": "\u4FDD\u5B58\u89C4\u5219\u5931\u8D25\uFF0C\u89C4\u5219\u540D\u79F0\u91CD\u590D",
  "iot-alert-mgmt.10016": "Update alert rule error, alert type cannot be changed.",
  "iot-alert-mgmt.10017": "Twins rule is not exist ",
  "iot-alert-mgmt.10019": "\u4FDD\u5B58\u544A\u8B66\u89C4\u5219\u5931\u8D25\uFF0C\u544A\u8B66\u6761\u4EF6\u6700\u5927\u957F\u5EA6\u4E3A65,535",
  "iot-alert-mgmt.10020": "\u4FDD\u5B58\u544A\u8B66\u89C4\u5219\u5931\u8D25\uFF0C\u544A\u8B66\u6761\u4EF6\u9519\u8BEF\uFF0C\u5B57\u6BB5\u4E0D\u5B58\u5728"
};

var iotAlertMgmtEn = {
  "iot-alert-mgmt.10001": "Save alert rule error, it is invalid",
  "iot-alert-mgmt.10002": "Save alert rule error, it's name is duplicate",
  "iot-alert-mgmt.10003": "Update alert rule status error, it's status is invalid",
  "iot-alert-mgmt.10004": "Alert rule is not exist",
  "iot-alert-mgmt.10005": "Elasticsearch error",
  "iot-alert-mgmt.10006": "Alert rule ruleType is invalid",
  "iot-alert-mgmt.10007": "edge computing rule name is duplicate",
  "iot-alert-mgmt.10008": "edge computing rule is not exist",
  "iot-alert-mgmt.10009": "edge computing rule issuance history is not exist",
  "iot-alert-mgmt.10010": "edge computing rule issuance message is not exist",
  "iot-alert-mgmt.10011": "can not find specification for tenant",
  "iot-alert-mgmt.10012": "rule count exceeds limit",
  "iot-alert-mgmt.10013": "things forward rule is not exist",
  "iot-alert-mgmt.10014": "things select size is 0",
  "iot-alert-mgmt.10015": "Save things forward rule error, name is duplicate",
  "iot-alert-mgmt.10016": "Update alert rule error, alert type cannot be changed.",
  "iot-alert-mgmt.10017": "Twins rule is not exist ",
  "iot-alert-mgmt.10019": "Save alert rule error, trigger_condition is too long",
  "iot-alert-mgmt.10020": "Save alert rule error, trigger_condition error, event can not find."
};

var iotBiz = {
  "iot-biz.100001": "\u66F4\u65B0\u5931\u8D25\u3002",
  "iot-biz.100002": "\u540D\u79F0\u91CD\u590D\u3002",
  "iot-biz.100003": "\u66F4\u65B0\u5F02\u5E38\u3002",
  "iot-biz.100004": "\u66F4\u65B0\u5931\u8D25\uFF0Dsql\u62A5\u9519\uFF0C\u8BF7\u67E5\u8BE2\u65E5\u5FD7\u3002",
  "iot-biz.100010": "\u4E0B\u8F7D\u811A\u672C\u540D\u79F0\u5DF2\u91CD\u590D"
};

var iotBizEn = {
  "iot-biz.100001": "Update failed. ",
  "iot-biz.100002": "Duplicate name ",
  "iot-biz.100003": "Update exception.",
  "iot-biz.100004": "Update failed - SQL error reported, please check the log",
  "iot-biz.100010": "The download script name has been duplicated "
};

var iotCanDtu = {
  "iot-can-dtu.10001": "\u6545\u969C\u7801\u6587\u4EF6\u5DF2\u5B58\u5728",
  "iot-can-dtu.10002": "\u5220\u9664\u914D\u7F6E\u5931\u8D25",
  "iot-can-dtu.10003": "\u914D\u7F6E\u6587\u4EF6\u627E\u4E0D\u5230",
  "iot-can-dtu.10004": "\u4E0A\u4F20\u6587\u4EF6\u4E3A\u7A7A",
  "iot-can-dtu.10005": "dtc \u6587\u4EF6\u4E0D\u5B58\u5728",
  "iot-can-dtu.10006": "ECU\u914D\u7F6E\u4E0D\u5B58\u5728",
  "iot-can-dtu.10007": "dtc \u7ED1\u5B9A\u627E\u4E0D\u5230",
  "iot-can-dtu.10008": "\u6CA1\u6709\u6743\u9650\u64CD\u4F5C\u8BE5\u6587\u4EF6",
  "iot-can-dtu.10009": "\u8BFB\u53D6\u6587\u4EF6\u6A21\u677F\u9519\u8BEF.",
  "iot-can-dtu.10010": "ecu\u540D\u79F0\u4E0D\u80FD\u4E3A\u7A7A",
  "iot-can-dtu.10011": "\u6545\u969C\u7801\u6587\u4EF6\u6B63\u5728\u88AB\u4F7F\u7528",
  "iot-can-dtu.10012": "\u540D\u79F0\u5DF2\u88AB\u4F7F\u7528",
  "iot-can-dtu.10013": "\u8BE5\u6587\u4EF6\u7C7B\u578B\u4E0D\u652F\u6301"
};

var iotCanDtuEn = {
  "iot-can-dtu.10001": "file already exists, please delete old file before creating.",
  "iot-can-dtu.10002": "delete config error.",
  "iot-can-dtu.10003": "configuration is not found",
  "iot-can-dtu.10004": "upload file empty",
  "iot-can-dtu.10005": "dtc file not exist.",
  "iot-can-dtu.10006": "ecu configuration not exist.",
  "iot-can-dtu.10007": "dtc binding not found",
  "iot-can-dtu.10008": "no permission to operate this file",
  "iot-can-dtu.10009": "read template file error.",
  "iot-can-dtu.10010": "ecu name can not be null",
  "iot-can-dtu.10011": "File referenced by [ecu={0}] cannot be deleted.",
  "iot-can-dtu.10012": "dtcCode [code={0}] cannot found.",
  "iot-can-dtu.10013": "file type [type ={0}] not supported."
};

var iotConnection = {
  "iot-connection.10000": "connection name[{0}] already exist",
  "iot-connection.10001": "target name[{0}] already exist",
  "iot-connection.10002": "Label Value is null",
  "iot-connection.20000": "No targets for route, message id: [{0}]",
  "iot-connection.20001": "Connection type not available, type is: [{0}]"
};

var iotConnectionEn = {
  "iot-connection.10000": "connection name[{0}] already exist",
  "iot-connection.10001": "target name[{0}] already exist",
  "iot-connection.10002": "Label Value is null",
  "iot-connection.20000": "No targets for route, message id: [{0}]",
  "iot-connection.20001": "Connection type not available, type is: [{0}]"
};

var iotControl = {
  "iot-control.10001": "tenant is required",
  "iot-control.10002": "build JWT Token failure",
  "iot-control.10003": "unknown authenticate failure",
  "iot-control.10004": "\u89D2\u8272\u540D\u79F0\u91CD\u590D",
  "iot-control.10005": "role[{0}] has been used by {1} user(s)",
  "iot-control.10006": "role[{0}] not found",
  "iot-control.10007": "resource group[{0}] already exist",
  "iot-control.10008": "resource group[{0}] not found",
  "iot-control.10009": "resource group item[{0}] not found",
  "iot-control.10010": "",
  "iot-control.10011": "",
  "iot-control.10012": "",
  "iot-control.10013": "\u7528\u6237\u5BC6\u7801\u9519\u8BEF",
  "iot-control.10014": "get ThirdSupport link failure: {0}",
  "iot-control.10015": "UC check ujwt failure : {0}",
  "iot-control.10016": "\u53D1\u9001\u624B\u673A\u9A8C\u8BC1\u7801\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5",
  "iot-control.10017": "\u53D1\u9001\u90AE\u7BB1\u9A8C\u8BC1\u7801\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5",
  "iot-control.10018": "\u8BE5\u7528\u6237\u4E0D\u5B58\u5728",
  "iot-control.10019": "\u8BE5\u7528\u6237\u6B63\u5728\u5BA1\u6838\u4E2D",
  "iot-control.10020": "\u9A8C\u8BC1\u7801\u9519\u8BEF",
  "iot-control.10021": "\u624B\u673A\u53F7\u9519\u8BEF\u6216\u9A8C\u8BC1\u7801\u8FC7\u671F",
  "iot-control.10022": "\u9A8C\u8BC1\u7801\u9519\u8BEF"
};

var iotControlEn = {
  "iot-control.10001": "tenant is required",
  "iot-control.10002": "build JWT Token failure",
  "iot-control.10003": "unknown authenticate failure",
  "iot-control.10004": "role's name already exist",
  "iot-control.10005": "role[{0}] has been used by {1} user(s)",
  "iot-control.10006": "role[{0}] not found",
  "iot-control.10007": "resource group[{0}] already exist",
  "iot-control.10008": "resource group[{0}] not found",
  "iot-control.10009": "resource group item[{0}] not found",
  "iot-control.10010": "",
  "iot-control.10011": "",
  "iot-control.10012": "",
  "iot-control.10013": "User password error",
  "iot-control.10014": "get ThirdSupport link failure",
  "iot-control.10015": "UC check ujwt failure",
  "iot-control.10016": "UC send sms code failure",
  "iot-control.10017": "UC send email code failure",
  "iot-control.10018": "The user does not exist",
  "iot-control.10019": "user is reviewing",
  "iot-control.10020": "Verification code error",
  "iot-control.10021": "Wrong mobile number or expired verification code",
  "iot-control.10022": "Verification code error"
};

var iotData = {
  "iot-data.10000": "\u521B\u5EFA\u770B\u677F\u9519\u8BEF\uFF0C\u770B\u677F\u540D\u79F0\u4E3A\u7A7A\u6216\u79DF\u6237id\u4E3A\u7A7A\u3002",
  "iot-data.10001": "\u8D85\u8FC7\u4E86\u6700\u5927\u6570\u91CF\uFF0C\u6BCF\u4E2A\u79DF\u6237\u6700\u591A\u53EA\u80FD\u521B\u5EFA\u7279\u5B9A\u6570\u91CF\u770B\u677F\u3002",
  "iot-data.10002": "\u4E0D\u6B63\u786E\u7684 thingsId \u548C tenantId.",
  "iot-data.10003": "\u4E0A\u8F7D\u6587\u4EF6\u4E3A\u7A7A",
  "iot-data.10004": "\u4E0A\u8F7D\u6587\u4EF6\u5927\u5C0F\u8D85\u8FC7\u9650\u5236\u3002",
  "iot-data.10005": "\u5220\u9664\u5931\u8D25\u3002",
  "iot-data.10006": "\u672A\u627E\u5230thingsId",
  "iot-data.10007": "\u627E\u4E0D\u5230\u8BE5id\u7684\u4E0B\u8F7D\u8BB0\u5F55\u3002",
  "iot-data.10008": "\u672A\u627E\u5230\u6570\u636E\u8F6C\u6362\u3002",
  "iot-data.10009": "\u6570\u636E\u8F6C\u6362\u811A\u672C\u65E0\u6CD5\u7F16\u8BD1\u3002",
  "iot-data.10010": "\u6570\u636E\u8F6C\u6362\u7F16\u8BD1\u5931\u8D25\u3002",
  "iot-data.10011": "\u641C\u7D22\u65F6\u95F4\u8DE8\u5EA6\u8D85\u8FC71\u5929",
  "iot-data.10012": "\u672A\u77E5\u805A\u5408\u7C7B\u578B",
  "iot-data.10013": "\u5F00\u59CB\u65F6\u95F4\u5E94\u5C0F\u4E8E\u5F53\u524D\u65F6\u95F4\u3002",
  "iot-data.10014": "\u65E0\u6CD5\u8BA1\u7B97\u79DF\u6237\u4F7F\u7528\u7387",
  "iot-data.10015": "\u627E\u4E0D\u5230\u4FE1\u606F\u6A21\u578B",
  "iot-data.10016": "\u6570\u636E\u67E5\u8BE2\u7ED3\u679C\u6570\u8D85\u8FC710000\uFF0C\u65E0\u6CD5\u8F6C\u6362\u3002",
  "iot-data.10017": "\u6709\u6548\u8F7D\u8377\u4E0D\u80FD\u5305\u542B",
  "iot-data.10018": "\u53C2\u6570 [agg_field] \u7A7A",
  "iot-data.10019": "id \u4E0D\u5B58\u5728",
  "iot-data.10020": "\u6CA1\u6709\u4EFB\u52A1\u7C7B\u578B",
  "iot-data.10021": "\u6CA1\u6709\u5BF9\u8C61id",
  "iot-data.10022": "\u65E0\u6CD5\u4F7F\u7528\u7EDF\u8BA1\u65B9\u6CD5",
  "iot-data.10023": "\u8BBE\u5907\u65E5\u5FD7\u4E3A\u7A7A",
  "iot-data.10024": "\u5904\u7406\u65E5\u5FD7\u5931\u8D25",
  "iot-data.10025": "\u6240\u6709\u6570\u636E\u70B9\u7C7B\u578B\u4E0D\u5E94\u4E3A\u5B57\u7B26\u4E32\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9\u6570\u636E\u70B9",
  "iot-data.10026": "\u6570\u636E\u7EDF\u8BA1\u65B9\u6CD5\u540D\u79F0\u5DF2\u5B58\u5728",
  "iot-data.10027": "\u540D\u79F0\u91CD\u590D\uFF0C\u8BE5\u540D\u79F0\u5DF2\u5B58\u5728",
  "iot-data.10028": "\u6570\u636E\u7EDF\u8BA1\u4EFB\u52A1\u6B63\u5728\u8FD0\u884C\uFF0C\u65E0\u6CD5\u5220\u9664",
  "iot-data.10029": "\u6570\u636E\u7EDF\u8BA1\u4EFB\u52A1\u6B63\u5728\u8FD0\u884C\uFF0C\u65E0\u6CD5\u66F4\u65B0",
  "iot-data.10030": "\u5F53\u4F7F\u7528\u81EA\u52A8cron\u6570\u636E\u7EDF\u8BA1\u4EFB\u52A1\u65F6\uFF0C\u9700\u8981cron\u8868\u8FBE\u5F0F",
  "iot-data.10031": "\u5F53\u4F7F\u7528\u81EA\u52A8cron\u6570\u636E\u7EDF\u8BA1\u4EFB\u52A1\u65F6\uFF0C\u9700\u8981\u6570\u636E\u65F6\u95F4",
  "iot-data.10032": "\u65E0\u6548\u7684cron\u8868\u8FBE\u5F0F",
  "iot-data.10033": "cron\u8868\u8FBE\u5F0F\u7684\u6700\u5C0F\u5468\u671F\u4E3A1\u5206\u949F\u3002",
  "iot-data.10034": "\u627E\u4E0D\u5230\u4EFB\u4F55\u4E1C\u897F\u3002",
  "iot-data.10035": "\u65E0\u6548\u53C2\u6570\u3002",
  "iot-data.10036": "\u5F00\u59CB\u65F6\u95F4\u6216\u7ED3\u675F\u65F6\u95F4\u4E0D\u5E94\u4E3A\u7A7A\u3002",
  "iot-data.20000": "\u5C06\u6570\u636E\u63A8\u9001\u5230oss\u9519\u8BEF",
  "iot-data.10037": "\u5220\u9664\u4EFB\u52A1\u6B63\u5728\u6267\u884C\uFF0C\u8BF7\u7B49\u5F85\u5B83\u5B8C\u6210\u540E\u518D\u63D0\u4EA4\u3002",
  "iot-data.10038": "\u62A5\u8868\u6216\u6A21\u677F\u540D\u79F0\u5DF2\u5B58\u5728",
  "iot-data.10039": "\u6A21\u677F\u540D\u79F0\u548C\u4FE1\u606F\u6A21\u578Bid\u548C\u4E8B\u4EF6\u540D\u79F0\u4E0D\u5F97\u4E3A\u7A7A",
  "iot-data.10040": "\u6B64\u4FE1\u606F\u6A21\u578B\u7684\u6A21\u677F\u540D\u79F0\u5DF2\u5B58\u5728\u3002",
  "iot-data.10041": "\u914D\u7F6E\u5217\u8868\u5305\u542B\u975E\u6CD5\u5C5E\u6027\u3002",
  "iot-data.10042": "\u672A\u627E\u5230\u8BB0\u5F55\u3002",
  "iot-data.10043": "\u5F00\u59CB\u65F6\u95F4\u5E94\u5C0F\u4E8E\u7ED3\u675F\u65F6\u95F4\u3002",
  "iot-data.10044": "\u4E0D\u5141\u8BB8\u7F16\u8F91\u6216\u5220\u9664\u5176\u4ED6\u79DF\u6237\u65B9\u6CD5",
  "iot-data.10045": "\u4EFB\u52A1id\u548C\u4EFB\u52A1\u540D\u79F0\u4E0D\u80FD\u5168\u90E8\u4E3A\u7A7A",
  "iot-data.10046": "\u627E\u4E0D\u5230\u8BE5id\u7684\u4EFB\u52A1",
  "iot-data.10047": "\u627E\u4E0D\u5230\u8BE5\u540D\u79F0\u7684\u4EFB\u52A1",
  "iot-data.10048": "\u6B64\u65B9\u6CD5\u4E0D\u652F\u6301\u4E8B\u4EF6\u540D\u79F0",
  "iot-data.10050": "\u627E\u4E0D\u5230\u5220\u9664\u7D22\u5F15\u3002",
  "iot-data.10051": "\u672C\u5305\u6CA1\u6709\u4E13\u7528\u5B58\u50A8\uFF0C\u8BF7\u8D2D\u4E70\u540E\u518D\u64CD\u4F5C\u3002 ",
  "iot-data.10052": "\u8BE5\u7D22\u5F15\u4E0B\u6CA1\u6709\u6570\u636E",
  "iot-data.30000": "\u627E\u4E0D\u5230\u6570\u636E\u7EDF\u8BA1\u5BFC\u51FA\u8F6C\u6362id\u3002 "
};

var iotDataEn = {
  "iot-data.10000": "Create dashboard error, dashboard name is null or tenant id is null.",
  "iot-data.10001": "Maximum number exceeded, each tenant can only create up to {0} dashboards.",
  "iot-data.10002": "Incorrect thingsId and tenantId.",
  "iot-data.10003": "upload file is empty.",
  "iot-data.10004": "upload file size exceeds limit[{0}].",
  "iot-data.10005": "Delete failed.",
  "iot-data.10006": "Things id=[{0}] is not found.",
  "iot-data.10007": "The download record id=[{0}] is not found.",
  "iot-data.10008": "The data transform id=[{0}] is not found.",
  "iot-data.10009": "The data transform id=[{0}] script can not compile.",
  "iot-data.10010": "The data transform id=[{0}] compile failure.",
  "iot-data.10011": "Search time span of more than 1 day, start date is [{0}], end date [{1}].",
  "iot-data.10012": "Unknown aggregation type [{0}].",
  "iot-data.10013": "The start time should be less than the current time.",
  "iot-data.10014": "Failed to calculate tenant usage, tenant id = [{0}].",
  "iot-data.10015": "Can't found info model by id [{0}].",
  "iot-data.10016": "The number of data query results exceeds 10,000 and cannot be converted.",
  "iot-data.10017": "payload cannot contain ",
  "iot-data.10018": "The parameter [agg_field] is null.",
  "iot-data.10019": "The {0} which id = [{1}] is not exist.",
  "iot-data.10020": "The task [{0}] type is [{1}].",
  "iot-data.10021": "No object id [{0}] in tenant [{1}].",
  "iot-data.10022": "can not user statistic method [{0}];",
  "iot-data.10023": "device log is empty",
  "iot-data.10024": "handle log failed",
  "iot-data.10025": "all data point type should not be string , please reselect data points",
  "iot-data.10026": "Data statistics method name already exists [name={0}]",
  "iot-data.10027": "Data statistics task name already exists",
  "iot-data.10028": "Data statistics task is running,can not delete [id={0}]",
  "iot-data.10029": "Data statistics task is running,can not update [id={0}]",
  "iot-data.10030": "When use auto cron data statistics task,cron expression is needed [cronExpression={0}]",
  "iot-data.10031": "When use auto cron data statistics task,data time is needed [dataStartTime={0},dataEndTime={1}]",
  "iot-data.10032": "invalidate cron expression [cronExpression={0}]",
  "iot-data.10033": "cron expression min period is {0} minutes [cronExpression={1}].",
  "iot-data.10034": "no things found under {0}.",
  "iot-data.10035": "invalid param: {0}.",
  "iot-data.10036": "start time or end time should not be null.",
  "iot-data.20000": "Push Data to oss error",
  "iot-data.10037": "The delete task is executing, wait for it to finish before submitting.",
  "iot-data.10038": "report or template name already exists [name={0}]",
  "iot-data.10039": "template name and info model id and event name must not be null",
  "iot-data.10040": "the template name of this info model is already exists",
  "iot-data.10041": "config list contains illegal property",
  "iot-data.10042": "{0} record not found.",
  "iot-data.10043": "The start time should be less than the end time.",
  "iot-data.10044": "not allow to edit or delete other tenant method",
  "iot-data.10045": "task_id and task name can not all be empty",
  "iot-data.10046": "no task found with id [taskId={0}]",
  "iot-data.10047": "no task found with name [taskName={0}]",
  "iot-data.10048": "this method not support for event name={0}",
  "iot-data.10050": "delete index can't found.",
  "iot-data.10051": "There is no exclusive special storage for the package, please purchase it before operating.",
  "iot-data.10052": "No data under the index.",
  "iot-data.30000": "The data statistics export transform id=[{0}] is not found."
};

var iotFilemanager = {
  "iot-filemanager.10001": "\u5C06\u6587\u4EF6\u4E0A\u4F20\u5230 oss \u5F02\u5E38 ",
  "iot-filemanager.10002": "get oss url error",
  "iot-filemanager.10003": "get oss desc error",
  "iot-filemanager.10004": "remove oss firmware error",
  "iot-filemanager.10005": "\u4E0B\u8F7D\u6587\u4EF6\u5F02\u5E38",
  "iot-filemanager.10006": "\u4E0A\u4F20\u6587\u4EF6\u4E3A\u7A7A",
  "iot-filemanager.10007": "compose subfile failed: [objName={0}]. please re-upload.",
  "iot-filemanager.10008": "totalPartNumber({0}) invalid",
  "iot-filemanager.10009": "curPart({0}) should < totalPartNumber({1})",
  "iot-filemanager.10010": "urPart({0}) invalid: please upload curPart({1}) first or re-upload.",
  "iot-filemanager.10011": "please upload curPart(0) first",
  "iot-filemanager.10012": "totalPartNumber not same with pre value, please re-upload.",
  "iot-filemanager.10013": "\u6CA1\u6709\u6743\u9650",
  "iot-filemanager.10014": "\u6587\u4EF6\u4E0D\u5B58\u5728\uFF0C\u8BF7\u91CD\u8BD5\uFF01",
  "iot-filemanager.10015": "out of data",
  "iot-filemanager.10016": "data plan already exist",
  "iot-filemanager.10017": "only new plan can be cancel",
  "iot-filemanager.10018": "invalid token",
  "iot-filemanager.10019": "download files > 10"
};

var iotFilemanagerEn = {
  "iot-filemanager.10001": "upload file to oss error: [objName={0}]",
  "iot-filemanager.10002": "get oss url error",
  "iot-filemanager.10003": "get oss desc error",
  "iot-filemanager.10004": "remove oss firmware error",
  "iot-filemanager.10005": "DownLoad file error: [objName={0}]",
  "iot-filemanager.10006": "up file is empty",
  "iot-filemanager.10007": "compose subfile failed: [objName={0}]. please re-upload.",
  "iot-filemanager.10008": "totalPartNumber({0}) invalid",
  "iot-filemanager.10009": "curPart({0}) should < totalPartNumber({1})",
  "iot-filemanager.10010": "urPart({0}) invalid: please upload curPart({1}) first or re-upload.",
  "iot-filemanager.10011": "please upload curPart(0) first",
  "iot-filemanager.10012": "totalPartNumber not same with pre value, please re-upload.",
  "iot-filemanager.10013": "No permission",
  "iot-filemanager.10014": "file not exist",
  "iot-filemanager.10015": "out of data",
  "iot-filemanager.10016": "data plan already exist",
  "iot-filemanager.10017": "only new plan can be cancel",
  "iot-filemanager.10018": "invalid token",
  "iot-filemanager.10019": "download files > 10"
};

var iotFirmware = {
  "iot-firmware.10001": "\u4E0A\u8F7D\u6587\u4EF6\u4E3A\u7A7A",
  "iot-firmware.10002": "\u56FA\u4EF6\u7248\u672C\u9519\u8BEF",
  "iot-firmware.10003": "\u751F\u6210\u6587\u4EF6\u9519\u8BEF",
  "iot-firmware.10004": "\u4E0A\u4F20\u6587\u4EF6\u4E3A\u7A7A\uFF0C\u751F\u6210\u5347\u7EA7\u5305\u5931\u8D25",
  "iot-firmware.10005": "\u627E\u4E0D\u5230\u5DE5\u5177",
  "iot-firmware.10006": "\u5C06\u6587\u4EF6\u4F20\u8F93\u5230dist\u9519\u8BEF.",
  "iot-firmware.10007": "\u4E0A\u4F20\u6587\u4EF6\u5230OSS\u9519\u8BEF",
  "iot-firmware.10008": "\u6587\u4EF6\u8FC7\u5927\uFF0C\u65B0\u589E\u5931\u8D25",
  "iot-firmware.10009": "\u5220\u9664\u56FA\u4EF6\u5931\u8D25",
  "iot-firmware.10010": "\u7269\u6A21\u578B\u914D\u7F6E\u9519\u8BEF\uFF0C\u53EA\u6709uis_diff\u652F\u6301\u4F20\u8F93\u5305\uFF0C\u8BF7\u91CD\u505A.",
  "iot-firmware.10011": "\u9519\u8BEF\u7684\u7B7E\u540D",
  "iot-firmware.10012": "\u83B7\u53D6oss\u6587\u4EF6\u8DEF\u5F84\u9519\u8BEF",
  "iot-firmware.10013": "\u83B7\u53D6oss\u9519\u8BEF",
  "iot-firmware.10014": "\u89E3\u7801\u9519\u8BEF",
  "iot-firmware.10015": "\u56FA\u4EF6\u4E0A\u4F20\u5931\u8D25\uFF0C\u540C\u7C7B\u578B\u56FA\u4EF6\u6700\u591A\u53EA\u80FD\u4E0A\u4F2010\u4E2A",
  "iot-firmware.10016": "\u5220\u9664\u56FA\u4EF6\u9519\u8BEF",
  "iot-firmware.10017": "\u56FA\u4EF6\u4E0D\u5B58\u5728",
  "iot-firmware.10018": "\u901A\u77E5\u56FA\u4EF6\u5347\u7EA7\u5931\u8D25,\u6CA1\u6709\u7248\u672C\u9700\u8981\u5347\u7EA7",
  "iot-firmware.10019": "\u6CA1\u6709\u8BBE\u5907\u9700\u8981\u5347\u7EA7",
  "iot-firmware.10020": "\u4ECE oss \u4E0B\u8F7D\u56FA\u4EF6\u5931\u8D25",
  "iot-firmware.10021": "\u901A\u77E5\u5347\u7EA7\u5931\u8D25",
  "iot-firmware.10022": "\u4E00\u6B21\u53EA\u80FD\u6307\u5B9A\u4E00\u79CD\u5347\u7EA7\u65B9\u6CD5",
  "iot-firmware.10023": "\u67E5\u8BE2\u5BF9\u8C61\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u60A8\u7684\u67E5\u8BE2\u53C2\u6570.",
  "iot-firmware.10024": "\u4EE4\u724C\u5DF2\u8FC7\u671F.",
  "iot-firmware.10025": "\u627E\u4E0D\u5230\u56FA\u4EF6.",
  "iot-firmware.10026": "\u6CA1\u6709\u5BF9\u56FA\u4EF6\u7684\u8BBF\u95EE\u6743\u9650.",
  "iot-firmware.10027": "\u4E0B\u8F7D\u56FA\u4EF6\u9519\u8BEF",
  "iot-firmware.10028": "\u6B64\u8BBE\u5907\u7C7B\u578B\u4E0D\u652F\u6301\u5DEE\u5206\u5347\u7EA7.",
  "iot-firmware.10029": "\u83B7\u53D6\u6587\u4EF6\u8F93\u5165\u6D41\u9519\u8BEF.",
  "iot-firmware.10030": "\u7F16\u7801URL\u9519\u8BEF.",
  "iot-firmware.10031": "\u8BF7\u786E\u4FDD\u8BBE\u5907\u7684\u56FA\u4EF6\u5B58\u5728\uFF0C\u6216\u68C0\u67E5\u8BBE\u5907\u5F53\u524D\u7684\u56FA\u4EF6\u7248\u672C",
  "iot-firmware.10032": "\u56FA\u4EF6\u8F6C\u6362\u5347\u7EA7\u7B97\u6CD5\u652F\u6301{'diffAlgorithm':'uis_diff'}",
  "iot-firmware.10033": "\u5347\u7EA7\u7248\u672C\u5FC5\u987B\u9AD8\u4E8E\u5F53\u524D\u7248\u672C",
  "iot-firmware.10034": "\u5DEE\u5206\u56FA\u4EF6\u5305\u6587\u4EF6\u683C\u5F0F\u9519\u8BEF",
  "iot-firmware.10035": "\u53EA\u6709\u652F\u6301\u56FA\u4EF6\u8F6C\u6362\u7684\u914D\u7F6E\u624D\u80FD\u4E0A\u4F20\u5DEE\u5F02\u5305",
  "iot-firmware.10036": "\u6807\u51C6\u56FA\u4EF6\u6216\u81EA\u5B9A\u4E49\u56FA\u4EF6\u5DF2\u5B58\u5728\u8BE5\u7248\u672C\u56FA\u4EF6\uFF0C\u8BF7\u4FEE\u6539\u7248\u672C\u540E\u91CD\u65B0\u4E0A\u4F20"
};

var iotFirmwareEn = {
  "iot-firmware.10001": "upload file empty",
  "iot-firmware.10002": "wrong version",
  "iot-firmware.10003": "gen up file error",
  "iot-firmware.10004": "up file is empty,generate up package fail.",
  "iot-firmware.10005": "can't find tool",
  "iot-firmware.10006": "transfer file to dist error.",
  "iot-firmware.10007": "upload file to oss error",
  "iot-firmware.10008": "version is too long or file size too large",
  "iot-firmware.10009": "remove firmware fail",
  "iot-firmware.10010": "InfoModel config error, only uis_diff support transfer package, please rework it.",
  "iot-firmware.10011": "error sign",
  "iot-firmware.10012": "get oss url error",
  "iot-firmware.10013": "get oss desc error",
  "iot-firmware.10014": "decode desc  error",
  "iot-firmware.10015": "Firmware upload failed, up to 10 firmware of the same type can be uploaded",
  "iot-firmware.10016": "remove oss firmware error",
  "iot-firmware.10017": "firmware not exist",
  "iot-firmware.10018": "no version need to upgrade",
  "iot-firmware.10019": "no device need to upgrade",
  "iot-firmware.10020": "download firmware from oss fail",
  "iot-firmware.10021": "notify upgrade fail",
  "iot-firmware.10022": "Only one upgrade method can be specified at a time",
  "iot-firmware.10023": "query thing error,please check your query params.",
  "iot-firmware.10024": "token is Expired.",
  "iot-firmware.10025": "firmware not found.",
  "iot-firmware.10026": "No access rights to the firmware.",
  "iot-firmware.10027": "DownLoad firmware error",
  "iot-firmware.10028": "This device type does not support differential upgrades.",
  "iot-firmware.10029": "Get file input stream error.",
  "iot-firmware.10030": "Encode URL error.",
  "iot-firmware.10031": "Please ensure that the firmware of the current device exists, or check the firmware version of the current device",
  "iot-firmware.10032": "Firmware conversion and upgrade algorithm support{'diffAlgorithm':'uis_diff'}",
  "iot-firmware.10033": "The upgrade version must be higher than the current version",
  "iot-firmware.10034": "Differential firmware package file format error",
  "iot-firmware.10035": "Only configurations that support firmware conversion can upload differential  packages",
  "iot-firmware.10036": "The version number is already occupied by the standard firmware or custom firmware, please change it."
};

var iotHmi = {
  "iot-hmi.00001": "[id={0}] cannot be found",
  "iot-hmi.00002": "no id exist[id={0}]",
  "iot-hmi.00003": "update [id={0}] error",
  "iot-hmi.00004": "update [id={0}] error, an object has at least one field that is not null",
  "iot-hmi.00005": "create error",
  "iot-hmi.00006": "no permission to operate resources under the tenant[id={0}]",
  "iot-hmi.00007": "no permission to operate resources under the user[id={0}]",
  "iot-hmi.00008": "more relation resource delete failed[id={0}]",
  "iot-hmi.00009": "delete [id={0}] error",
  "iot-hmi.00010": "release app/web [id={0}] error",
  "iot-hmi.00011": "app/web [id={0}] has not been release yet",
  "iot-hmi.00012": "hmi project type error [type={0}]",
  "iot-hmi.00013": "get session error [id={0}]",
  "iot-hmi.11001": "cluster[id={0}] has no project",
  "iot-hmi.11002": "cluster has no work node",
  "iot-hmi.11003": "cluster service temporarily unavailable"
};

var iotHmiEn = {
  "iot-hmi.00001": "[id={0}] cannot be found",
  "iot-hmi.00002": "no id exist[id={0}]",
  "iot-hmi.00003": "update [id={0}] error",
  "iot-hmi.00004": "update [id={0}] error, an object has at least one field that is not null",
  "iot-hmi.00005": "create error",
  "iot-hmi.00006": "no permission to operate resources under the tenant[id={0}]",
  "iot-hmi.00007": "no permission to operate resources under the user[id={0}]",
  "iot-hmi.00008": "more relation resource delete failed[id={0}]",
  "iot-hmi.00009": "delete [id={0}] error",
  "iot-hmi.00010": "release app/web [id={0}] error",
  "iot-hmi.00011": "app/web [id={0}] has not been release yet",
  "iot-hmi.00012": "hmi project type error [type={0}]",
  "iot-hmi.00013": "get session error [id={0}]",
  "iot-hmi.11001": "cluster[id={0}] has no project",
  "iot-hmi.11002": "cluster has no work node",
  "iot-hmi.11003": "cluster service temporarily unavailable"
};

var iotHttp = {
  "iot-http.400": "\u8BF7\u6C42\u5165\u53C2\u9519\u8BEF",
  "iot-http.401": "\u767B\u5F55\u5DF2\u8FC7\u671F\uFF0C\u8BF7\u91CD\u65B0\u767B\u5F55",
  "iot-http.403": "\u8BF7\u6C42\u65E0\u6743\u9650",
  "iot-http.404": "\u670D\u52A1\u5668\u65E0\u54CD\u5E94\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5",
  "iot-http.408": "\u8BF7\u6C42\u8D85\u65F6",
  "iot-http.500": "\u670D\u52A1\u5668\u65E0\u54CD\u5E94\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5"
};

var iotHttpEn = {
  "iot-http.400": "PARAM_WRONG",
  "iot-http.401": "NOT_LOGIN",
  "iot-http.403": "FORBIDDEN",
  "iot-http.404": "SERVER_ERROR",
  "iot-http.408": "REQUEST_TIMEOUT",
  "iot-http.500": "SERVER_ERROR"
};

var iotJob = {
  "iot-job.10001": "handler action[{0}] does not exist",
  "iot-job.10002": "job[id={0}] does not exist under tenant[id={1}].",
  "iot-job.10003": "job_log[id={0}] does not exist under tenant[id={1}], job[{2}].",
  "iot-job.10004": "execute job fail, failed to call the xxl-job-admin service.",
  "iot-job.10005": "handler action[id={0}] does not exist.",
  "iot-job.10006": "handler service [{0}] response status code is [{1}].",
  "iot-job.10007": "job[id={0}] does not exist.",
  "iot-job.10008": "job[id={0}] posting failed, check the log for error details.",
  "iot-job.10009": "job[id={0}] is not the [{1}] job.",
  "iot-job.10010": "http basic userinfo must not null;",
  "iot-job.10011": "http basic userinfo must contain a colon;",
  "iot-job.10012": "unknown service name type[{0}] in action handler[id={1}]",
  "iot-job.10013": "zlgcloud authorization build failed.",
  "iot-job.10014": "zlgcloud authorization token build failed.",
  "iot-job.10015": "handler_custom_param_template is not a json object.",
  "iot-job.10016": "\u4EFB\u52A1\u540D\u79F0\u5DF2\u5B58\u5728",
  "iot-job.10017": "thingsSelectorType [{0}] is duplicated"
};

var iotJobEn = {
  "iot-job.10001": "handler action[{0}] does not exist",
  "iot-job.10002": "job[id={0}] does not exist under tenant[id={1}].",
  "iot-job.10003": "job_log[id={0}] does not exist under tenant[id={1}], job[{2}].",
  "iot-job.10004": "execute job fail, failed to call the xxl-job-admin service.",
  "iot-job.10005": "handler action[id={0}] does not exist.",
  "iot-job.10006": "handler service [{0}] response status code is [{1}].",
  "iot-job.10007": "job[id={0}] does not exist.",
  "iot-job.10008": "job[id={0}] posting failed, check the log for error details.",
  "iot-job.10009": "job[id={0}] is not the [{1}] job.",
  "iot-job.10010": "http basic userinfo must not null;",
  "iot-job.10011": "http basic userinfo must contain a colon;",
  "iot-job.10012": "unknown service name type[{0}] in action handler[id={1}]",
  "iot-job.10013": "zlgcloud authorization build failed.",
  "iot-job.10014": "zlgcloud authorization token build failed.",
  "iot-job.10015": "handler_custom_param_template is not a json object.",
  "iot-job.10016": "job name is existed.",
  "iot-job.10017": "thingsSelectorType [{0}] is duplicated"
};

var iotMapping = {
  "iot-mapping.10001": "IOT\u529F\u80FD\u5757\u65E0\u6548",
  "iot-mapping.10002": "IOT\u529F\u80FD\u5757\u91CD\u590D",
  "iot-mapping.10003": "IOT\u8BBE\u5907\u6A21\u578B\u5DF2\u7ECF\u5F15\u7528\u529F\u80FD\u5757\uFF0C\u4E0D\u80FD\u5220\u9664\u6B64\u529F\u80FD\u5757",
  "iot-mapping.10004": "IOT\u8BBE\u5907\u6A21\u578B\u8BBE\u7F6E\u91CD\u590D",
  "iot-mapping.10005": "IOT\u8BBE\u5907\u6A21\u578B\u5F15\u7528\u529F\u80FD\u5757\u91CD\u590D",
  "iot-mapping.10006": "IOT\u8BBE\u5907\u6A21\u578B\u65E0\u6548",
  "iot-mapping.10007": "IOT\u8BBE\u5907\u6A21\u578B\u6807\u7B7E\u8BBE\u7F6E\u91CD\u590D",
  "iot-mapping.10008": "IOT\u5B9E\u4F53\u8BBE\u7F6E\u91CD\u590D",
  "iot-mapping.10009": "IOT\u5B9E\u4F53\u5F15\u7528\u5DF2\u5B58\u5728",
  "iot-mapping.10010": "IOT\u5B9E\u4F53\u65E0\u6548",
  "iot-mapping.10011": "IOT\u5B9E\u4F53\u8BBE\u7F6E\u65E0\u6548",
  "iot-mapping.10012": "\u6620\u5C04\u914D\u7F6E\u540D\u5B57:{0}\u8BBE\u7F6E\u91CD\u590D",
  "iot-mapping.10013": "\u6620\u5C04\u914D\u7F6E\u65E0\u6548",
  "iot-mapping.10014": "IOT\u8BBE\u5907\u6A21\u578B\u6620\u5C04\u8BBE\u7F6E\u91CD\u590D",
  "iot-mapping.10015": "mapping\u6570\u636E\u4E0D\u5B58\u5728",
  "iot-mapping.10016": "\u5927\u7C7B\u6570\u636E\u65E0\u6548",
  "iot-mapping.10017": "\u5927\u7C7B\u8BBE\u7F6E\u91CD\u590D",
  "iot-mapping.10018": "{0}",
  "iot-mapping.10019": "\u5B9E\u4F53\u7684schema\u53C2\u6570\u65E0\u6548",
  "iot-mapping.10020": "\u4E0A\u4F20\u6587\u4EF6\u5230S3\u670D\u52A1\u5931\u8D25",
  "iot-mapping.10021": "dbc\u8BB0\u5F55\u4E3A\u7A7A",
  "iot-mapping.10022": "\u5B58\u50A8\u7684dbc\u6587\u4EF6\u4E3A\u7A7A",
  "iot-mapping.10023": "\u79DF\u6237\u4E0B\u5DF2\u7ECF\u5B58\u7C7B\u578B{0}\u8F6C\u53D1\u5904\u7406",
  "iot-mapping.10024": "\u79DF\u6237{0}\u4E0B\u7684\u8F6C\u53D1\u5904\u7406{1}\u672A\u5B58\u5728",
  "iot-mapping.10025": "\u6620\u5C04\u89C4\u5219\u5DF2\u7ECF\u4F7F\u7528",
  "iot-mapping.10026": "\u53EA\u80FD\u6DFB\u52A0\u540C\u4E00\u4E2A\u79DF\u6237\u4E0B\u7684\u6620\u5C04\u89C4\u5219",
  "iot-mapping.10027": "\u6620\u5C04\u914D\u7F6E{0}\u65E0\u6548",
  "iot-mapping.10028": "\u529F\u80FD\u5757\u914D\u7F6E\u6570\u636E\u65E0\u6548",
  "iot-mapping.10029": "dbc\u6587\u4EF6\u5DF2\u5173\u8054\u7269\u6A21\u578B",
  "iot-mapping.10030": "\u8F6C\u53D1\u89C4\u5219\u4E0D\u5B58\u5728",
  "iot-mapping.10031": "\u540C\u6B65\u8BBE\u5907\u6A21\u578B\u5230changelog\u5931\u8D25: {0}",
  "iot-mapping.10032": "\u540C\u6B65DBC\u4FE1\u606F\u5230changelog\u5931\u8D25: {0}",
  "iot-mapping.10033": "\u65B0\u589E\u64CD\u4F5C\u8D85\u51FA\u5957\u9910\u9650\u5236",
  "iot-mapping.10034": "DBC\u6587\u4EF6\u6B63\u5728\u88AB\u4F7F\u7528",
  "iot-mapping.10054": "\u5BFC\u5165\u6A21\u677Fsheet\u6570\u4E0D\u5BF9\uFF0C\u8BF7\u4F7F\u7528\u6B63\u786E\u7684\u6A21\u677F",
  "iot-mapping.10056": "DBC\u6587\u4EF6\u540D\u79F0\u5DF2\u5B58\u5728",
  "iot-mapping.999990": "\u5173\u8054\u8FC7\u591A\u529F\u80FD\u5757"
};

var iotMappingEn = {
  "iot-mapping.10001": "Invalid IOT function block",
  "iot-mapping.10002": "Duplicate IOT function block",
  "iot-mapping.10003": " The IOT device model has already referenced a function block and cannot delete this function block ",
  "iot-mapping.10004": " Duplicate IOT device model settings ",
  "iot-mapping.10005": " Duplicate IOT device model reference function block ",
  "iot-mapping.10006": "Invalid IOT device model",
  "iot-mapping.10007": " Duplicate IOT device model label settings ",
  "iot-mapping.10008": " Duplicate IOT entity settings ",
  "iot-mapping.10009": " IOT entity reference already exists ",
  "iot-mapping.10010": "Invalid IOT entity",
  "iot-mapping.10011": "Invalid IOT entity setting",
  "iot-mapping.10012": "Mapping configuration name duplicate settings",
  '"iot-mapping.10013': "Invalid mapping configuration",
  "iot-mapping.10014": " Duplicate IOT device model mapping settings ",
  "iot-mapping.10015": " Mapping data does not exist ",
  '"iot-mapping.10016': "Invalid big category data",
  "iot-mapping.10017": "Duplicate settings for major categories",
  "iot-mapping.10018": "Duplicate IOT entity settings",
  '"iot-mapping.10019': "Invalid schema parameter for entity",
  "iot-mapping.10020": " Failed to upload file to S3 service ",
  "iot-mapping.10021": " Dbc record is empty ",
  "iot-mapping.10022": " The stored dbc file is empty ",
  "iot-mapping.10023": " Tenant already has type  forwarding processing ",
  "iot-mapping.10024": " The forwarding processing  under tenant does not exist ",
  "iot-mapping.10025": " The mapping rule has already been used ",
  "iot-mapping.10056": "The DBC file name already exists",
  "iot-mapping.10026": " Only mapping rules under the same tenant can be added ",
  "iot-mapping.10027": "Invalid mapping configuration {0}",
  "iot-mapping.10028": "Invalid function block configuration data",
  "iot-mapping.10029": " The dbc file has been associated with the object model ",
  "iot-mapping.10030": " The forwarding rule does not exist ",
  "iot-mapping.10031": "Failed to synchronize device model to changelog: {0}",
  "iot-mapping.10032": "Failed to synchronize DBC information to changelog: {0}",
  "iot-mapping.10033": " Adding operation exceeds package limit ",
  "iot-mapping.10034": " DBC file is in use ",
  "iot-mapping.10054": "The number of imported template sheets is incorrect. Please use the correct template",
  "iot-mapping.999990": "Associate too many functional blocks"
};

var iotMinio = {
  "iot-minio.10001": "upload file to oss error",
  "iot-minio.10002": "get oss url error",
  "iot-minio.10003": "get oss desc error",
  "iot-minio.10004": "remove oss file error",
  "iot-minio.10005": "DownLoad file error[objName={0}]"
};

var iotMinioEn = {
  "iot-minio.10001": "upload file to oss error",
  "iot-minio.10002": "get oss url error",
  "iot-minio.10003": "get oss desc error",
  "iot-minio.10004": "remove oss file error",
  "iot-minio.10005": "DownLoad file error[objName={0}]"
};

var iotNotification = {
  "iot-notification.10001": "tenant[{0}] already audited",
  "iot-notification.10002": "phone[{0}] is illegal",
  "iot-notification.10003": "\u53D1\u9001\u77ED\u4FE1\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5",
  "iot-notification.10004": "email[{0}] is illegal",
  "iot-notification.10005": "wrong old email"
};

var iotNotificationEn = {
  "iot-notification.10001": "tenant[{0}] already audited",
  "iot-notification.10002": "phone[{0}] is illegal",
  "iot-notification.10003": "sending SMS failed, please try again later",
  "iot-notification.10004": "email[{0}] is illegal",
  "iot-notification.10005": "wrong old email"
};

var iotOutBilling = {
  "iot-out-billing.10000": "Add CouponSys Error,[tenantId={0}] is not valid",
  "iot-out-billing.20000": "Draw Coupon Error, Not Allow To Draw CouponSys",
  "iot-out-billing.20001": "Coupon Is Not Valid For You;",
  "iot-out-billing.20002": "Amount Is Not Over Coupon's Threshold;",
  "iot-out-billing.20003": "Coupon Is Out Of Usetime;",
  "iot-out-billing.20004": "CouponTenant State Is Not Correct;",
  "iot-out-billing.30000": "Alipay prepare pay error",
  "iot-out-billing.30001": "You Have Not Pay Order,Please Due To It;",
  "iot-out-billing.30002": "Order Can Not Found To Pay;",
  "iot-out-billing.30003": "Order PayType Can Not To Use;",
  "iot-out-billing.30004": "PayBack UUID Is Not Fit For Order;",
  "iot-out-billing.30005": "PayBack Package State Is Not Correct;",
  "iot-out-billing.30006": "PayBack PayType Is Not Matching; PayType:{0};",
  "iot-out-billing.30007": "PayBack ReceiptAmount Not Equal To PayAmount;",
  "iot-out-billing.30008": "PayBack Order Connect Coupon State Error;",
  "iot-out-billing.30009": "Duration Cannot Be 0 or Null When OrderType=1;",
  "iot-out-billing.30010": "Order Type:{0} Is Not Valid;",
  "iot-out-billing.30011": "Order State:{0} Not Paied,Can Not ReFunc Oder;",
  "iot-out-billing.30012": "User Only Can Refund Last Order;",
  "iot-out-billing.40000": "Compute OrderAmount Eroor, nextPackage can not be null;",
  "iot-out-billing.40001": "Order Duration Must Not Be Null When Got Package From BasePackage Or Get A New Package;",
  "iot-out-billing.40002": "Order Duration Must Not Be Null When Got New Package;",
  "iot-out-billing.40003": "Can Not Cancel OrderId:{0}, It is Not Found; ",
  "iot-out-billing.40004": "OrderId{0} State:{1} Not Allow To Cancel;",
  "iot-out-billing.40005": "OrderId:{0} PackageId:{1} PackageState Not Correct;",
  "iot-out-billing.40006": "OrderId{0} CouponId:{1} State Error,Cancel Eroor;",
  "iot-out-billing.40007": "PackageType:{0} State=1 Can Not Have More Than 1;",
  "iot-out-billing.50000": "Get Tenant Package Error; ",
  "iot-out-billing.50001": "Can Not Reduce Package;",
  "iot-out-billing.50002": "You Have Not Pay For Package,Please Due To It;",
  "iot-out-billing.70001": "\u6587\u4EF6\u5927\u5C0F\u5FC5\u987B\u572810M\u4EE5\u5185"
};

var iotOutBillingEn = {
  "iot-out-billing.10000": "Add CouponSys Error,[tenantId={0}] is not valid",
  "iot-out-billing.20000": "Draw Coupon Error, Not Allow To Draw CouponSys",
  "iot-out-billing.20001": "Coupon Is Not Valid For You;",
  "iot-out-billing.20002": "Amount Is Not Over Coupon's Threshold;",
  "iot-out-billing.20003": "Coupon Is Out Of Usetime;",
  "iot-out-billing.20004": "CouponTenant State Is Not Correct;",
  "iot-out-billing.30000": "Alipay prepare pay error",
  "iot-out-billing.30001": "You Have Not Pay Order,Please Due To It;",
  "iot-out-billing.30002": "Order Can Not Found To Pay;",
  "iot-out-billing.30003": "Order PayType Can Not To Use;",
  "iot-out-billing.30004": "PayBack UUID Is Not Fit For Order;",
  "iot-out-billing.30005": "PayBack Package State Is Not Correct;",
  "iot-out-billing.30006": "PayBack PayType Is Not Matching; PayType:{0};",
  "iot-out-billing.30007": "PayBack ReceiptAmount Not Equal To PayAmount;",
  "iot-out-billing.30008": "PayBack Order Connect Coupon State Error;",
  "iot-out-billing.30009": "Duration Cannot Be 0 or Null When OrderType=1;",
  "iot-out-billing.30010": "Order Type:{0} Is Not Valid;",
  "iot-out-billing.30011": "Order State:{0} Not Paied,Can Not ReFunc Oder;",
  "iot-out-billing.30012": "User Only Can Refund Last Order;",
  "iot-out-billing.40000": "Compute OrderAmount Eroor, nextPackage can not be null;",
  "iot-out-billing.40001": "Order Duration Must Not Be Null When Got Package From BasePackage Or Get A New Package;",
  "iot-out-billing.40002": "Order Duration Must Not Be Null When Got New Package;",
  "iot-out-billing.40003": "Can Not Cancel OrderId:{0}, It is Not Found; ",
  "iot-out-billing.40004": "OrderId{0} State:{1} Not Allow To Cancel;",
  "iot-out-billing.40005": "OrderId:{0} PackageId:{1} PackageState Not Correct;",
  "iot-out-billing.40006": "OrderId{0} CouponId:{1} State Error,Cancel Eroor;",
  "iot-out-billing.40007": "PackageType:{0} State=1 Can Not Have More Than 1;",
  "iot-out-billing.50000": "Get Tenant Package Error; ",
  "iot-out-billing.50001": "Can Not Reduce Package;",
  "iot-out-billing.50002": "You Have Not Pay For Package,Please Due To It;",
  "iot-out-billing.70001": "file size must be limited to 10mb"
};

var iotOutGroupMgmt = {
  "iot-out-group-mgmt.00001": "\u8BBE\u5907\u5206\u7EC4\u4E0D\u5B58\u5728",
  "iot-out-group-mgmt.00002": "no id exist[id={0}]",
  "iot-out-group-mgmt.00003": "\u7F16\u8F91\u8BBE\u5907\u5206\u7EC4\u5931\u8D25",
  "iot-out-group-mgmt.00004": "update group[id={0}] error, an object has at least one field that is not null",
  "iot-out-group-mgmt.00005": "create group error",
  "iot-out-group-mgmt.00006": "\u6CA1\u6709\u6743\u9650\u64CD\u4F5C\u8BE5\u8D44\u6E90",
  "iot-out-group-mgmt.00007": "\u6CA1\u6709\u6743\u9650\u64CD\u4F5C\u8BE5\u8D44\u6E90",
  "iot-out-group-mgmt.00008": "\u521B\u5EFA\u5206\u7EC4\u5931\u8D25\uFF0C\u7236\u5206\u7EC4\u4E0D\u5B58\u5728",
  "iot-out-group-mgmt.00009": "\u8BE5\u5206\u7EC4\u5DF2\u6DFB\u52A0\u8BBE\u5907\u8BBE\u5907\uFF0C\u6DFB\u52A0\u5206\u7EC4\u5931\u8D25",
  "iot-out-group-mgmt.00010": "create group error, invalid device type[info model id={0}]",
  "iot-out-group-mgmt.00011": "\u5220\u9664\u5206\u7EC4\u5931\u8D25\uFF0C\u5206\u7EC4\u4E0B\u6709\u5B50\u5206\u7EC4",
  "iot-out-group-mgmt.00012": "\u5220\u9664\u5206\u7EC4\u5931\u8D25\uFF0C\u5206\u7EC4\u4E0B\u6709\u5B50\u8BBE\u5907",
  "iot-out-group-mgmt.00013": "delete group error[id={0}]",
  "iot-out-group-mgmt.00014": "delete group error, group not found[id={0}]",
  "iot-out-group-mgmt.00015": "retrieve things list error with info model id[id={0}]",
  "iot-out-group-mgmt.00016": "unbind all device from group[id={0}] error",
  "iot-out-group-mgmt.00017": "delete all groups under user[id={0}] error",
  "iot-out-group-mgmt.00018": "unbind all device under user[id={0}] error",
  "iot-out-group-mgmt.00019": "\u8BE5\u5206\u7EC4\u4E0B\u8BBE\u5907\u4E3A\u7A7A",
  "iot-out-group-mgmt.00020": "\u5206\u7EC4\u4E0B\u6709\u5B50\u5206\u7EC4\uFF0C\u7ED1\u5B9A\u8BBE\u5907\u5931\u8D25",
  "iot-out-group-mgmt.00021": "groupIds should be a list of group ids [groupIds={0}]",
  "iot-out-group-mgmt.00022": "could not find third things id[{0}] with info model id[{1}]",
  "iot-out-group-mgmt.00023": "deviceIds should be a list of device ids [deviceIds={0}]",
  "iot-out-group-mgmt.00024": "batch post message unavailability",
  "iot-out-group-mgmt.00025": "\u8BE5\u5206\u7EC4\u5DF2\u5B58\u5728\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165",
  "iot-out-group-mgmt.00026": "\u7F16\u8F91\u5206\u7EC4\u5931\u8D25\uFF0C\u5DF2\u5B58\u5728\u540C\u540D\u5206\u7EC4",
  "iot-out-group-mgmt.00027": "invalid ext_info parameter [ext_info={0}]",
  "iot-out-group-mgmt.00028": "invalid op parameter [op={0}]",
  "iot-out-group-mgmt.00029": "auth group things to user error,error info [{0}]",
  "iot-out-group-mgmt.00030": "no auth given to group,auth info [{0}]",
  "iot-out-group-mgmt.00031": "invalid ext_info json string: [{0}]",
  "iot-out-group-mgmt.00032": "group price config not found: [id={0}]",
  "iot-out-group-mgmt.00033": "invalid group price config: [{0}={1}]",
  "iot-out-group-mgmt.00034": "\u5DF2\u5B58\u5728\u540C\u540D\u7684\u7535\u4EF7\u89C4\u5219",
  "iot-out-group-mgmt.00035": "invalid group price config time: [start_time={0},end_time={1}]",
  "iot-out-group-mgmt.00036": "invalid group price config time range: [end_time={0},start_time={1}]",
  "iot-out-group-mgmt.00037": "\u8BE5\u7B56\u7565\u4E0D\u5B58\u5728",
  "iot-out-group-mgmt.00038": "\u4E0D\u5B58\u5728\u8BE5\u7B56\u7565\u6A21\u677F",
  "iot-out-group-mgmt.00039": "group strategy exists: [tenantId={0},groupId={1},thingsId={2}]",
  "iot-out-group-mgmt.00040": "group strategy template exists: [tenantId={0},name={1}]",
  "iot-out-group-mgmt.00041": "invalid group strategy config [config={0}]",
  "iot-out-group-mgmt.00042": "invalid group strategy template config [config={0}]",
  "iot-out-group-mgmt.00043": "you are not the owner of this record"
};

var iotOutGroupMgmtEn = {
  "iot-out-group-mgmt.00001": "group cannot be found",
  "iot-out-group-mgmt.00002": "no id exist",
  "iot-out-group-mgmt.00003": "update group error",
  "iot-out-group-mgmt.00004": "update group error, an object has at least one field that is not null",
  "iot-out-group-mgmt.00005": "create group error",
  "iot-out-group-mgmt.00006": "no permission to operate resources under the tenant",
  "iot-out-group-mgmt.00007": "no permission to operate resources under the user",
  "iot-out-group-mgmt.00008": "create group error, invalid parent",
  "iot-out-group-mgmt.00009": "create group error, parent node already binding device",
  "iot-out-group-mgmt.00010": "create group error, invalid device type",
  "iot-out-group-mgmt.00011": "delete group error, group has sub nodes",
  "iot-out-group-mgmt.00012": "delete group error, group has sub device",
  "iot-out-group-mgmt.00013": "delete group error",
  "iot-out-group-mgmt.00014": "delete group error, group not found",
  "iot-out-group-mgmt.00015": "retrieve things list error with info model id",
  "iot-out-group-mgmt.00016": "unbind all device from group error",
  "iot-out-group-mgmt.00017": "delete all groups under user error",
  "iot-out-group-mgmt.00018": "unbind all device under user error",
  "iot-out-group-mgmt.00019": "empty group",
  "iot-out-group-mgmt.00020": "group has child nodes, binding error",
  "iot-out-group-mgmt.00021": "groupIds should be a list of group ids ",
  "iot-out-group-mgmt.00022": "could not find third things id with info model id",
  "iot-out-group-mgmt.00023": "deviceIds should be a list of device ids ",
  "iot-out-group-mgmt.00024": "batch post message unavailability",
  "iot-out-group-mgmt.00025": "create group error, group name[{0}] already exist",
  "iot-out-group-mgmt.00026": "update group[id={0}] error, group name[{1}] already exist",
  "iot-out-group-mgmt.00027": "invalid ext_info parameter [ext_info={0}]",
  "iot-out-group-mgmt.00028": "invalid op parameter [op={0}]",
  "iot-out-group-mgmt.00029": "auth group things to user error,error info [{0}]",
  "iot-out-group-mgmt.00030": "no auth given to group,auth info [{0}]",
  "iot-out-group-mgmt.00031": "invalid ext_info json string: [{0}]",
  "iot-out-group-mgmt.00032": "group price config not found: [id={0}]",
  "iot-out-group-mgmt.00033": "invalid group price config: [{0}={1}]",
  "iot-out-group-mgmt.00034": "A electricity price rule with the same name already exists",
  "iot-out-group-mgmt.00035": "invalid group price config time: [start_time={0},end_time={1}]",
  "iot-out-group-mgmt.00036": "invalid group price config time range: [end_time={0},start_time={1}]",
  "iot-out-group-mgmt.00037": "group strategy not found",
  "iot-out-group-mgmt.00038": "group strategy template not found",
  "iot-out-group-mgmt.00039": "group strategy exists: [tenantId={0},groupId={1},thingsId={2}]",
  "iot-out-group-mgmt.00040": "group strategy template exists: [tenantId={0},name={1}]",
  "iot-out-group-mgmt.00041": "invalid group strategy config [config={0}]",
  "iot-out-group-mgmt.00042": "invalid group strategy template config [config={0}]",
  "iot-out-group-mgmt.00043": "you are not the owner of this record"
};

var iotOutWeb = {
  "iot-out-web.10000": "\u7528\u6237\u540D\u5DF2\u5B58\u5728\uFF01",
  "iot-out-web.10001": "\u7528\u6237\u6CA1\u6709\u8BBF\u95EE\u6743\u9650\uFF01",
  "iot-out-web.10002": "\u7528\u6237\u4E0D\u5B58\u5728\uFF01",
  "iot-out-web.10003": "\u5BC6\u7801\u9519\u8BEF\uFF01",
  "iot-out-web.10004": "\u89D2\u8272\u9519\u8BEF\uFF01",
  "iot-out-web.10005": "\u7F51\u7AD9\u4E0D\u5B58\u5728\uFF01",
  "iot-out-web.10006": "\u6DFB\u52A0web\u90E8\u7F72\u5931\u8D25\uFF0C\u8BE5\u8D44\u6E90\u8DEF\u5F84\u4E0B\u5DF2\u5B58\u5728\u8BE5\u7248\u672C\u53F7\uFF01"
};

var iotOutWebEn = {
  "iot-out-web.10000": "user is exist",
  "iot-out-web.10001": "user has no permission to access list",
  "iot-out-web.10002": "user is not exist",
  "iot-out-web.10003": "password is error",
  "iot-out-web.10004": "roleId is error",
  "iot-out-web.10005": "web is not exist",
  "iot-out-web.10006": "add deploy fail,deploy is exist"
};

var iotOutWrapper = {
  "iot-out-wrapper.10000": "message blocking,Please wait Previous message returned.",
  "iot-out-wrapper.10001": "query block message error,Please try latter.",
  "iot-out-wrapper.10002": "send block message error,Please try latter.",
  "iot-out-wrapper.20000": "server run error"
};

var iotOutWrapperEn = {
  "iot-out-wrapper.10000": "message blocking,Please wait Previous message returned.",
  "iot-out-wrapper.10001": "query block message error,Please try latter.",
  "iot-out-wrapper.10002": "send block message error,Please try latter.",
  "iot-out-wrapper.20000": "server run error"
};

var iotPackagemanager = {
  "iot-packagemanager.20001": "bad pkgtype or version format!",
  "iot-packagemanager.20002": "pkgtype or version not exist!",
  "iot-packagemanager.20003": "{0}_{1} has removed",
  "iot-packagemanager.20004": "arguments is invalid"
};

var iotPackagemanagerEn = {
  "iot-packagemanager.20001": "bad pkgtype or version format!",
  "iot-packagemanager.20002": "pkgtype or version not exist!",
  "iot-packagemanager.20003": "{0}_{1} has removed",
  "iot-packagemanager.20004": "arguments is invalid"
};

var iotProject = {
  "iot-project.10001": "\u9879\u76EE\u540D\u79F0\u4E0D\u5141\u8BB8\u7A7A",
  "iot-project.10002": "\u66F4\u65B0\u9879\u76EE\u72B6\u6001\u9519\u8BEF\uFF0C\u72B6\u6001\u65E0\u6548",
  "iot-project.10003": "\u9879\u76EE\u5DF2\u5B58\u5728",
  "iot-project.10004": "\u9879\u76EE\u540D\u79F0\u5DF2\u5B58\u5728"
};

var iotProjectEn = {
  "iot-project.10001": "Save project error, name can not empty",
  "iot-project.10002": "Update project status error, status: {0} is invalid",
  "iot-project.10003": "Project is not exist",
  "iot-project.10004": "Project name: {0} already exists"
};

var iotProjectResource = {
  "iot-projectResource.10001": "Save project resource error, projectId can not empty",
  "iot-projectResource.10002": "Save project resource error, resourceId can not empty",
  "iot-projectResource.10003": "Save project resource error, resourceType can not empty",
  "iot-projectResource.10004": "batch get project resource error, projectIds and resourceIds can not all be empty"
};

var iotProjectResourceEn = {
  "iot-projectResource.10001": "Save project resource error, projectId can not empty",
  "iot-projectResource.10002": "Save project resource error, resourceId can not empty",
  "iot-projectResource.10003": "Save project resource error, resourceType can not empty",
  "iot-projectResource.10004": "batch get project resource error, projectIds and resourceIds can not all be empty"
};

var iotSingleLorawan = {
  "iot-single-lorawan.10000": "\u670D\u52A1\u5668\u9519\u8BEF\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  "iot-single-lorawan.10001": "\u6A21\u578B\u5339\u914D\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  "iot-single-lorawan.10002": "Lora\u8BBE\u5907\u521B\u5EFA\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  "iot-single-lorawan.10003": "LoRa\u8BBE\u5907\u5DF2\u5B58\u5728",
  "iot-single-lorawan.10004": "\u53C2\u6570\u9519\u8BEF\uFF0C\u8BF7\u91CD\u8BD5",
  "iot-single-lorawan.10005": "\u53C2\u6570\u9519\u8BEF\uFF0C\u8BF7\u91CD\u8BD5",
  "iot-single-lorawan.10006": "Lora\u7F51\u5173\u521B\u5EFA\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  "iot-single-lorawan.10007": "LoRa\u7F51\u5173\u5DF2\u5B58\u5728",
  "iot-single-lorawan.10100": "\u521B\u5EFA\u64AD\u7EC4\u9519\u8BEF\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  "iot-single-lorawan.10101": "\u5185\u90E8\u9519\u8BEF\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  "iot-single-lorawan.10102": "\u64AD\u7EC4\u540D\u5B57\u5339\u914D\u5931\u8D25\uFF0C\u8BF7\u91CD\u8BD5",
  "iot-single-lorawan.10103": "Update Multicast Group Forbidden",
  "iot-single-lorawan.10104": "Send Msg To Multicast Group Error"
};

var iotSingleLorawanEn = {
  "iot-single-lorawan.10000": "Init NsServer Error, LoraServer Error;",
  "iot-single-lorawan.10001": "InfoModel is Not Matching for LoraServer;",
  "iot-single-lorawan.10002": "Create Lora Device In Loraserver Error,Msg:{0}",
  "iot-single-lorawan.10003": "LoRa Device Object Already Exists",
  "iot-single-lorawan.10004": "Create Lora Device In Loraserver Error,Set Key nwkkey:{0} appkey:{1} Error;",
  "iot-single-lorawan.10005": "Create Lora Device In Loraserver Error,Activate appskey:{0} devaddr:{1} nwksenckey:{2} fnwksintkey:{3} snwksintkey:{4} Error;",
  "iot-single-lorawan.10006": "Create Lora Gateway Device In Loraserver Error",
  "iot-single-lorawan.10007": "LoRa GateWay Object Already Exists",
  "iot-single-lorawan.10100": "Create Multicast Group Error",
  "iot-single-lorawan.10101": "Internal Loraserver Error",
  "iot-single-lorawan.10102": "Create Multicast Group Name Is Not Match[a-zA-Z0-9_/u4e00-/u9fa5]",
  "iot-single-lorawan.10103": "Update Multicast Group Forbidden",
  "iot-single-lorawan.10104": "Send Msg To Multicast Group Error"
};

var iotSingleOpcua = {
  "iot-single-opcua.10000": "\u8BE5\u8BBE\u5907\u7C7B\u578B\u7F3A\u5C11\u5FC5\u8981\u7684\u914D\u7F6E\u9879\uFF0C\u8BF7\u5728\u529F\u80FD\u5757\u4E2D\u5B8C\u5584\u5B83",
  "iot-single-opcua.10001": "\u8BE5\u8BBE\u5907\u7C7B\u578B\u6CA1\u6709\u529F\u80FD\u5757",
  "iot-single-opcua.10002": "\u8BE5\u8BBE\u5907\u7C7B\u578B\u6CA1\u6709\u6570\u636E\u70B9",
  "iot-single-opcua.10003": "this device type has not operations",
  "iot-single-opcua.10004": "\u8BE5\u8BBE\u5907\u7C7B\u578B\u914D\u7F6E\u9879\u4E0D\u5408\u6CD5",
  "iot-single-opcua.10005": "\u8BBE\u5907\u5C1A\u672A\u5EFA\u7ACB\u8FDE\u63A5\uFF0C\u8BF7\u4FEE\u6539\u6B63\u786E\u7684\u9A71\u52A8url\u548C\u8BBE\u5907url",
  "iot-single-opcua.10006": "objectId \u548C methodId\u4E0D\u80FD\u4E3A\u7A7A",
  "iot-single-opcua.10007": "\u6267\u884C\u547D\u4EE4\u5931\u8D25",
  "iot-single-opcua.10008": "\u65E0\u6CD5\u8FDE\u63A5\u9A71\u52A8\uFF0C\u8BF7\u68C0\u67E5\u9A71\u52A8URL",
  "iot-single-opcua.10009": "\u9A71\u52A8url\u548C\u8BBE\u5907url\u4EE5\u53CA\u6536\u96C6\u65F6\u95F4\u4E0D\u80FD\u4E3A\u7A7A"
};

var iotSingleOpcuaEn = {
  "iot-single-opcua.10000": "missing parameter",
  "iot-single-opcua.10001": "this device type has not fnblock",
  "iot-single-opcua.10002": "this device type has not data point",
  "iot-single-opcua.10003": "this device type has not operations",
  "iot-single-opcua.10004": "this device type attributes type is invalid",
  "iot-single-opcua.10005": "device doesn't exist or connection not established yet",
  "iot-single-opcua.10006": "objectId and methodId must not be null",
  "iot-single-opcua.10007": "command execution failure",
  "iot-single-opcua.10008": "can not establish connection with opcua drive,please check drive url",
  "iot-single-opcua.10009": "drive url and device url and collect time must not be null"
};

var iotTenant = {
  "iot-tenant.10001": "label[{0}] already exist",
  "iot-tenant.10002": "illegal parameter: ids",
  "iot-tenant.10003": "no id exist",
  "iot-tenant.10004": "label[id={0}] cannot be found",
  "iot-tenant.10005": "tenant[id={0}] cannot be found",
  "iot-tenant.10006": "tenant specification[id={0}] cannot be found",
  "iot-tenant.10007": "tenant name[{0}] already exist",
  "iot-tenant.10008": "wrong old mobile",
  "iot-tenant.10009": "user[id={0}] cannot be found",
  "iot-tenant.10010": "user[{0}] is disabled",
  "iot-tenant.10011": "tenant namespace[{0}] already exist",
  "iot-tenant.10012": "\u8BE5\u7528\u6237\u4E0D\u5B58\u5728",
  "iot-tenant.10013": "tenant specification[tenantId={0}] cannot be found",
  "iot-tenant.10014": "\u6807\u7B7E\u6570\u5DF2\u8D85\u8FC7\u4E0A\u9650",
  "iot-tenant.10015": "\u8BE5\u7528\u6237\u5DF2\u7981\u6B62\u767B\u5F55",
  "iot-tenant.10016": "\u8BE5\u7528\u6237\u5C1A\u672A\u6FC0\u6D3B\uFF0C\u8BF7\u7B49\u5F85\u7BA1\u7406\u5458\u5BA1\u6838",
  "iot-tenant.10017": "\u8D26\u53F7\u5DF2\u88AB\u7981\u7528\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458",
  "iot-tenant.10018": "\u8BE5\u7528\u6237\u5C1A\u672A\u6FC0\u6D3B\uFF0C\u8BF7\u7B49\u5F85\u7BA1\u7406\u5458\u5BA1\u6838",
  "iot-tenant.10019": "\u5B50\u7528\u6237\u6570\u91CF\u5DF2\u8FBE\u4E0A\u9650",
  "iot-tenant.10020": "user[id={0}] does not exist under tenan[id={1}].",
  "iot-tenant.10021": "\u5B50\u7528\u6237\u540D\u79F0\u5DF2\u5B58\u5728",
  "iot-tenant.10022": "\u5E73\u53F0\u4E2D\u5DF2\u6709\u7528\u6237\u6216\u5B50\u7528\u6237\u4F7F\u7528\u8BE5\u90AE\u7BB1",
  "iot-tenant.10023": "\u5E73\u53F0\u4E2D\u5DF2\u6709\u7528\u6237\u6216\u5B50\u7528\u6237\u4F7F\u7528\u8BE5\u624B\u673A\u53F7\u7801",
  "iot-tenant.10024": "\u64CD\u4F5C\u8FC7\u4E8E\u9891\u7E41\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5",
  "iot-tenant.10025": "illegal parameter[type]",
  "iot-tenant.10026": "\u5BC6\u7801\u9519\u8BEF",
  "iot-tenant.10027": "\u8BE5\u7528\u6237\u4E0D\u5B58\u5728",
  "iot-tenant.10028": "\u90AE\u7BB1\u9A8C\u8BC1\u7801\u9519\u8BEF",
  "iot-tenant.10029": "\u624B\u673A\u9A8C\u8BC1\u7801\u9519\u8BEF\u6216\u5DF2\u8FC7\u671F",
  "iot-tenant.10030": "\u624B\u673A\u53F7\u7801\u672A\u6CE8\u518C",
  "iot-tenant.10031": "tenant[{0}] already audited",
  "iot-tenant.10032": "phone[{0}] is illegal",
  "iot-tenant.10033": "\u53D1\u9001\u9A8C\u8BC1\u7801\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5",
  "iot-tenant.10034": "email[{0}] is illegal",
  "iot-tenant.10035": "wrong old email",
  "iot-tenant.10036": "upload file size exceeds limit[{0}]",
  "iot-tenant.10037": "upload avatar file failure: {0}",
  "iot-tenant.10038": "upload file is empty",
  "iot-tenant.10039": "cannot delete tenan manager",
  "iot-tenant.10040": "cannot update tenan manager",
  "iot-tenant.10041": "\u5B50\u7528\u6237\u767B\u5F55\u9700@\u79DF\u6237\u8D26\u6237\u540D",
  "iot-tenant.10042": "verification code type [0], cannot be found",
  "iot-tenant.10043": "\u5220\u9664\u6807\u7B7E\u5931\u8D25\uFF0C\u8BE5\u6807\u7B7E\u6B63\u5728\u88AB\u4F7F\u7528",
  "iot-tenant.10044": "cannot edit user,current is not user parent",
  "iot-tenant.10045": "current user can not get other's sub user",
  "iot-tenant.10046": "parent user doesn't exist",
  "iot-tenant.10047": "invalid extension code: {0}",
  "iot-tenant.10048": "Resource Limit Exceeded",
  "iot-tenant.10049": " UC service error: {0}",
  "iot-tenant.10050": " \u66F4\u65B0\u7528\u6237\u4FE1\u606F\u5931\u8D25",
  "iot-tenant.10051": " UC update password failure: {0}",
  "iot-tenant.10052": " \u8BE5\u90AE\u7BB1\u5DF2\u7ECF\u5B58\u5728",
  "iot-tenant.10053": " \u7528\u6237\u624B\u673A\u53F7\u5DF2\u5B58\u5728",
  "iot-tenant.10054": "The end time must be greater than the start time",
  "iot-tenant.10060": "\u672A\u67E5\u8BE2\u5230\u8BE5\u6D41\u91CF\u6C60\u4FE1\u606F",
  "iot-tenant.10061": "\u6D41\u91CF\u6C60\u5DF2\u5B58\u5728",
  "iot-tenant.10062": "\u8FD0\u8425\u5546\u62A5\u9519"
};

var iotTenantEn = {
  "iot-tenant.10001": "label already exist",
  "iot-tenant.10002": "illegal parameter: ids",
  "iot-tenant.10003": "no id exist",
  "iot-tenant.10004": "label cannot be found",
  "iot-tenant.10005": "tenant cannot be found",
  "iot-tenant.10006": "tenant specification cannot be found",
  "iot-tenant.10007": "tenant name already exist",
  "iot-tenant.10008": "wrong old mobile",
  "iot-tenant.10009": "user cannot be found",
  "iot-tenant.10010": "user is disabled",
  "iot-tenant.10011": "tenant namespace already exist",
  "iot-tenant.10012": "tenant cannot be found",
  "iot-tenant.10013": "tenant specification[tenantId={0}] cannot be found",
  "iot-tenant.10014": "label count exceeds limit",
  "iot-tenant.10015": "user is disabled",
  "iot-tenant.10016": "user not activated",
  "iot-tenant.10017": "tenant is disabled",
  "iot-tenant.10018": "tenant is unaudited",
  "iot-tenant.10019": "tenant user count exceeds limit",
  "iot-tenant.10020": "user does not exist under tenan.",
  "iot-tenant.10021": "user name already exist",
  "iot-tenant.10022": "user email already exist",
  "iot-tenant.10023": "user mobile already exist",
  "iot-tenant.10024": "The operation is too frequent, please try again later.",
  "iot-tenant.10025": "illegal parameter[type]",
  "iot-tenant.10026": "wrong password",
  "iot-tenant.10027": "user[{0}] cannot be found",
  "iot-tenant.10028": "invalid Email verification code",
  "iot-tenant.10029": "Mobile verification code error or expired",
  "iot-tenant.10030": "phone cannot be found",
  "iot-tenant.10031": "tenant[{0}] already audited",
  "iot-tenant.10032": "phone[{0}] is illegal",
  "iot-tenant.10033": "sending SMS failed, please try again later",
  "iot-tenant.10034": "email[{0}] is illegal",
  "iot-tenant.10035": "wrong old email",
  "iot-tenant.10036": "upload file size exceeds limit[{0}]",
  "iot-tenant.10037": "upload avatar file failure: {0}",
  "iot-tenant.10038": "upload file is empty",
  "iot-tenant.10039": "cannot delete tenan manager",
  "iot-tenant.10040": "cannot update tenan manager",
  "iot-tenant.10041": "Sub user login requires @ tenant account name",
  "iot-tenant.10042": "verification code type [0], cannot be found",
  "iot-tenant.10043": "delete label fail,label was used",
  "iot-tenant.10044": "cannot edit user,current is not user parent",
  "iot-tenant.10045": "current user can not get other's sub user",
  "iot-tenant.10046": "parent user doesn't exist",
  "iot-tenant.10047": "invalid extension code: {0}",
  "iot-tenant.10048": "Resource Limit Exceeded",
  "iot-tenant.10049": " UC service error: {0}",
  "iot-tenant.10050": " UC update user failure",
  "iot-tenant.10051": " UC update password failure: {0}",
  "iot-tenant.10052": " UC update email failure: {0}",
  "iot-tenant.10053": " user mobile already exist",
  "iot-tenant.10054": "The end time must be greater than the start time",
  "iot-tenant.10060": "sim pool info not found",
  "iot-tenant.10061": "sim pool info already exists",
  "iot-tenant.10062": "third part error"
};

var iotThings = {
  "iot-things.10000": "Create things error, info model id is null or tenant id is null",
  "iot-things.10001": "Create things error, can't query things",
  "iot-things.10002": "Create things error, things is null",
  "iot-things.10003": "Create category error, can't query category",
  "iot-things.10004": "The digital twin things missing database data",
  "iot-things.10005": "The things is null",
  "iot-things.10006": "The digital twin things missing status data",
  "iot-things.10007": "Create labels error, can't query label",
  "iot-things.10008": "Create things label error, can't find the things label",
  "iot-things.10009": "Create Things error, check validate exception",
  "iot-things.100010": "Register Things error, current number exceeds things quota",
  "iot-things.100011": "Register Things error, things quota is null",
  "iot-things.100012": "\u627E\u4E0D\u5230\u8BBE\u5907",
  "iot-things.100013": "TenantId and thingsId are incorrect",
  "iot-things.100014": "payload is not json",
  "iot-things.100015": "\u8BBE\u5907ID\u5DF2\u5B58\u5728\uFF0C\u8BF7\u91CD\u8BD5",
  "iot-things.100016": "\u64CD\u4F5C\u5931\u8D25\uFF0C\u4E0D\u80FD\u6DFB\u52A0\u81EA\u8EAB\u8BBE\u5907\u4F5C\u4E3A\u5B50\u8BBE\u5907",
  "iot-things.100017": "\u64CD\u4F5C\u5931\u8D25\uFF0C\u8BF7\u5148\u89E3\u7ED1\u8BE5\u8BBE\u5907\u4E0B\u7684\u5B50\u8BBE\u5907",
  "iot-things.100018": "\u83B7\u53D6\u6D88\u606F\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5",
  "iot-things.100019": "\u4E0D\u80FD\u83B7\u53D6\u5230\u8BBE\u5907",
  "iot-things.100020": "Configuration is not json",
  "iot-things.100021": "Create things error, things type is illegal parameter",
  "iot-things.100022": "Generate JWT token error, the secret password is too short or is null",
  "iot-things.100023": "StatusValue is not a valid json",
  "iot-things.100024": "\u6DFB\u52A0\u5931\u8D25\uFF0C\u9700\u8981key",
  "iot-things.100025": "Failed to send the message, the message type is incorrect",
  "iot-things.100026": "Failed to send the message, the message record is null",
  "iot-things.100027": "Failed to send the message, put to message queue exception",
  "iot-things.100028": "The number of records exceeds 2000",
  "iot-things.100029": "Create things error, third things id is null",
  "iot-things.100030": "Things info model id is illegal",
  "iot-things.100031": "Things connection status is illegal",
  "iot-things.100032": "The message has been sent and cannot be sent repeatedly",
  "iot-things.100033": "Things default configuration get ",
  "iot-things.100034": "Parent Things is null",
  "iot-things.100035": "\u8D85\u8FC7\u8D44\u6E90\u9650\u5236",
  "iot-things.100036": "StatusValue can not be empty",
  "iot-things.100037": "\u64CD\u4F5C\u5931\u8D25\uFF0C\u6807\u7B7E\u540D\u91CD\u590D\uFF01",
  "iot-things.100040": "Things are not exist",
  "iot-things.100041": "Things info model id is null",
  "iot-things.100042": "channel has already been bound",
  "iot-things.100044": "unknow platform in request",
  "iot-things.100043": "device login fail, generateThingsTokens is empty, that could be caused by a wrong password or a banned connection.",
  "iot-things.100045": "unbind device failed, please check thing's authority in role of user.",
  "iot-things.100046": "things key is out of limit, [4,64]",
  "iot-things.100047": "public info model not allow set things secret [infoModelId={0}]",
  "iot-things.100048": "no things found:[infoModelId={0},thirdThingsId={1}]",
  "iot-things.100049": "things already bind:[userId={0},infoModelId={1},thirdThingsId={2}]",
  "iot-things.100050": "things not bind:[userId={0},thingsId={1}]",
  "iot-things.101001": "Things Already Connect To Mqtt, Conflct For Get Connection Info"
};

var iotThingsEn = {
  "iot-things.10000": "Create things error, info model id is null or tenant id is null",
  "iot-things.10001": "Create things error, can't query things",
  "iot-things.10002": "Create things error, things is null",
  "iot-things.10003": "Create category error, can't query category",
  "iot-things.10004": "The digital twin things missing database data",
  "iot-things.10005": "The things is null",
  "iot-things.10006": "The digital twin things missing status data",
  "iot-things.10007": "Create labels error, can't query label",
  "iot-things.10008": "Create things label error, can't find the things label",
  "iot-things.10009": "Create Things error, check validate exception",
  "iot-things.100010": "Register Things error, current number exceeds things quota",
  "iot-things.100011": "Register Things error, things quota is null",
  "iot-things.100012": "Things is not found",
  "iot-things.100013": "TenantId and thingsId are incorrect",
  "iot-things.100014": "payload is not json",
  "iot-things.100015": "Error creating things, there may be duplicate third_things_id",
  "iot-things.100016": "Parent things id has an infinite loop",
  "iot-things.100017": "The things that need to be deleted have child things, please delete child things first",
  "iot-things.100018": "Failed to get messages, please try again later",
  "iot-things.100019": "Can't get things by the given selectors",
  "iot-things.100020": "Configuration is not json",
  "iot-things.100021": "Create things error, things type is illegal parameter",
  "iot-things.100022": "Generate JWT token error, the secret password is too short or is null",
  "iot-things.100023": "StatusValue is not a valid json",
  "iot-things.100024": "Create things error, things key is needed",
  "iot-things.100025": "Failed to send the message, the message type is incorrect",
  "iot-things.100026": "Failed to send the message, the message record is null",
  "iot-things.100027": "Failed to send the message, put to message queue exception",
  "iot-things.100028": "The number of records exceeds 2000",
  "iot-things.100029": "Create things error, third things id is null",
  "iot-things.100030": "Things info model id is illegal",
  "iot-things.100031": "Things connection status is illegal",
  "iot-things.100032": "The message has been sent and cannot be sent repeatedly",
  "iot-things.100033": "Things default configuration get ",
  "iot-things.100034": "Parent Things is null",
  "iot-things.100035": "Resource Limit Exceeded",
  "iot-things.100036": "StatusValue can not be empty",
  "iot-things.100037": "Things add label conflect",
  "iot-things.100040": "Things are not exist",
  "iot-things.100041": "Things info model id is null",
  "iot-things.100042": "channel has already been bound",
  "iot-things.100044": "unknow platform in request",
  "iot-things.100043": "device login fail, generateThingsTokens is empty, that could be caused by a wrong password or a banned connection.",
  "iot-things.100045": "unbind device failed, please check thing's authority in role of user.",
  "iot-things.100046": "things key is out of limit, [4,64]",
  "iot-things.100047": "public info model not allow set things secret [infoModelId={0}]",
  "iot-things.100048": "no things found:[infoModelId={0},thirdThingsId={1}]",
  "iot-things.100049": "things already bind:[userId={0},infoModelId={1},thirdThingsId={2}]",
  "iot-things.100050": "things not bind:[userId={0},thingsId={1}]",
  "iot-things.101001": "Things Already Connect To Mqtt, Conflct For Get Connection Info"
};

var iotZigbee = {
  "iot-zigbee.10001": "Save zigbee group error, {0}: {1} is invalid",
  "iot-zigbee.10002": "Update zigbee group status error, status: {0} is invalid",
  "iot-zigbee.10003": "Zigbee group {0} is not exist",
  "iot-zigbee.10004": "\u5206\u7EC4\u7F16\u53F7\u548C\u6240\u5C5E\u7F51\u5173\u5DF2\u5B58\u5728\uFF0C\u8BF7\u4FEE\u6539\u5176\u4E2D\u81F3\u5C11\u4E00\u9879",
  "iot-zigbee.20001": "Save zigbee member error, {0}: {1} is invalid",
  "iot-zigbee.20002": "\u53D1\u9001\u4FE1\u606F\u5931\u8D25\uFF0C\u8BBE\u5907\u53EF\u80FD\u4E0D\u5728\u7EBF"
};

var iotZigbeeEn = {
  "iot-zigbee.10001": "Save zigbee group error, {0}: {1} is invalid",
  "iot-zigbee.10002": "Update zigbee group status error, status: {0} is invalid",
  "iot-zigbee.10003": "Zigbee group {0} is not exist",
  "iot-zigbee.10004": "Zigbee group gw_info_model_id:{0} gw_things_id:{1} multicast_id:{2} already exists",
  "iot-zigbee.20001": "Save zigbee member error, {0}: {1} is invalid",
  "iot-zigbee.20002": "Save zigbee member error, send message failed,maybe thing is offline"
};

const controllers = {
  "iot-alert-data-mgmt": iotAlertDataMgmt,
  "iot-alert-data-mgmt-en": iotAlertDataMgmtEn,
  "iot-alert-mgmt": iotAlertMgmt,
  "iot-alert-mgmt-en": iotAlertMgmtEn,
  "iot-biz": iotBiz,
  "iot-biz-en": iotBizEn,
  "iot-can-dtu": iotCanDtu,
  "iot-can-dtu-en": iotCanDtuEn,
  "iot-connection": iotConnection,
  "iot-connection-en": iotConnectionEn,
  "iot-control": iotControl,
  "iot-control-en": iotControlEn,
  "iot-data": iotData,
  "iot-data-en": iotDataEn,
  "iot-filemanager": iotFilemanager,
  "iot-filemanager-en": iotFilemanagerEn,
  "iot-firmware": iotFirmware,
  "iot-firmware-en": iotFirmwareEn,
  "iot-hmi": iotHmi,
  "iot-hmi-en": iotHmiEn,
  "iot-http": iotHttp,
  "iot-http-en": iotHttpEn,
  "iot-job": iotJob,
  "iot-job-en": iotJobEn,
  "iot-mapping": iotMapping,
  "iot-mapping-en": iotMappingEn,
  "iot-minio": iotMinio,
  "iot-minio-en": iotMinioEn,
  "iot-notification": iotNotification,
  "iot-notification-en": iotNotificationEn,
  "iot-out-billing": iotOutBilling,
  "iot-out-billing-en": iotOutBillingEn,
  "iot-out-group-mgmt": iotOutGroupMgmt,
  "iot-out-group-mgmt-en": iotOutGroupMgmtEn,
  "iot-out-web": iotOutWeb,
  "iot-out-web-en": iotOutWebEn,
  "iot-out-wrapper": iotOutWrapper,
  "iot-out-wrapper-en": iotOutWrapperEn,
  "iot-packagemanager": iotPackagemanager,
  "iot-packagemanager-en": iotPackagemanagerEn,
  "iot-project": iotProject,
  "iot-project-en": iotProjectEn,
  "iot-projectResource": iotProjectResource,
  "iot-projectResource-en": iotProjectResourceEn,
  "iot-single-lorawan": iotSingleLorawan,
  "iot-single-lorawan-en": iotSingleLorawanEn,
  "iot-single-opcua": iotSingleOpcua,
  "iot-single-opcua-en": iotSingleOpcuaEn,
  "iot-tenant": iotTenant,
  "iot-tenant-en": iotTenantEn,
  "iot-things": iotThings,
  "iot-things-en": iotThingsEn,
  "iot-zigbee": iotZigbee,
  "iot-zigbee-en": iotZigbeeEn
};

const ZWSAPIRoleMap = {
  getBatchAlertEvents: "alert:alert-data-event:query",
  deleteBatchAlertEvents: "alert:alert-data-event:delete",
  getSingleAlertEvents: "alert:alert-data-event:query",
  updateSingleEventsStatus: "alert:alert-data-event:handle",
  deleteAllAlertEvents: "alert:alert-data-event:delete",
  getBatchEdgeComputingRules: "alert:edge-computing-rule:query",
  getSingleEdgeRule: "alert:edge-computing-rule:query",
  addSingleEdgeRule: "alert:edge-computing-rule:create",
  issueSingleEdgeComputingRule: "alert:edge-computing-rule:issuance",
  updateSingleEdgeRule: "alert:edge-computing-rule:update",
  deleteSingleEdgeRule: "alert:edge-computing-rule:delete",
  getBatchEdgeRuleIssuanceHistory: "alert:edge-computing-rule-issuance-history:query",
  deleteEdgeIssuanceHistories: "alert:edge-computing-rule-issuance-history:delete",
  addBatchAlertAction: "alert:rule-action:update",
  addBatchAlertActionRecovery: "alert:rule-action:update",
  updateSingleAlertAction: "alert:rule-action:update",
  updateSingleAlertActionRecovery: "alert:rule-action:update",
  deleteBatchAlertActions: "alert:rule-action:delete",
  deleteBatchAlertActionsRecovery: "alert:rule-action:delete",
  addThingsForwardAction: "alert:things-forward-action:create",
  updateThingsForwardAction: "alert:things-forward-action:update",
  deleteThingsForwardAction: "alert:things-forward-action:delete",
  getBatchThingsForwardRules: "alert:things-forward-rules:query",
  getSingleThingsForwardRule: "alert:things-forward-rules:query",
  getBatchRules: "alert:trigger-rule:query",
  updateRuleStatus: "alert:trigger-rule:update",
  deleteSingleRule: "alert:trigger-rule:delete",
  addSingleAlertRule: "alert:trigger-rule:create",
  updateSingleAlertRule: "alert:trigger-rule:update",
  addSingleDataDashbord: "data-mgmt:dashboard:create",
  updateSingleDataDashbord: "data-mgmt:dashboard:update",
  deleteSingleDataDashbord: "data-mgmt:dashboard:delete",
  getBatchDashbords: "data-mgmt:dashboard:query",
  addSingleDataDashbordPanel: "data-mgmt:dashboard-panel:create",
  deleteSingleDataDashbordPanel: "data-mgmt:dashboard-panel:delete",
  updateSingleDataDashbordPanel: "data-mgmt:dashboard-panel:update",
  getSingleThingsData: "data-mgmt:thing-data:query",
  getSingleThingsDataAggregation: "data-mgmt:thing-data:history-aggregation",
  getBatchGroupDatas: "data-mgmt:thing-data:query",
  issueRequestDownloadDeviceData: "data-mgmt:thing-data:download",
  getQueryDownloadDeviceData: "data-mgmt:thing-data:download",
  getDataDownloadList: "data-mgmt:thing-data:download",
  updateDataDownloadStatus: "data-mgmt:thing-data:download",
  getBindDashbord: "data-mgmt:user-dashboard:query",
  updateBindDashbord: "data-mgmt:user-dashboard:update",
  getBatchJobs: "job-mgmt:job:query",
  addSingleJob: "job-mgmt:job:create",
  updateSingleJob: "job-mgmt:job:edit",
  updateSingleJobStatus: "job-mgmt:job:edit-status",
  getSingleJobDetails: "job-mgmt:job:query",
  deleteSingleJob: "job-mgmt:job:delete",
  getBatchJobLogs: "job-mgmt:job-log:query",
  deleteSingleJobLog: "job-mgmt:job-log:delete",
  deleteBatchJobLogs: "job-mgmt:job-log:delete",
  deleteAllJobLog: "job-mgmt:job-log:delete",
  getDownloadUrl: "firmware:firmware:query",
  getBatchFirmwares: "firmware:firmware:query",
  getPackageInfo: "filemanager:package:query",
  deletePackage: "filemanager:package:delete",
  uploadPackage: "filemanager:package:upload",
  getAllPackages: "filemanager:package:query",
  getLastPackage: "filemanager:package:query",
  addBatchDevicesBindToGroup: "group:device:bind",
  issueGroupDeviceCommand: "group:device:command",
  deleteBatchDevicesOfGroup: "group:device:unbind",
  getBatchGroupList: "group:group:query",
  addSingleGroup: "group:group:create",
  updateSingleGroup: "group:group:update",
  deleteBatchGroups: "group:group:delete",
  getBatchProject: "project:project:query",
  addSingleProject: "project:project:create",
  deleteSingleProjectById: "project:project:delete",
  updateSingleProject: "project:project:update",
  relatedSingleProjectResource: "project:project-resource:update",
  relatedBatchProjectResources: "project:project-resource:update",
  updateProjectResourcesRelation: "project:project-resource:update",
  getSingleProjectResources: "project:project-resource:query",
  getBatchProjectResources: "project:project-resource:query",
  deleteProjectResourcesRelation: "project:project-resource:update",
  addSingleThings: "things:things:create",
  addImportThings: "things:things:import",
  addImportWrapperThings: "things:things:import",
  getOutPutAllThings: "things:things:export",
  getOutPutThings: "things:things:export",
  updateBatchThingsAttr: "things:things:batch-update",
  updateBatchThingsConfiguration: "things:things:batch-update",
  getBatchThings: "things:things:query",
  deleteBatchThings: "things:things:delete",
  updateSingleThings: "things:things:update",
  getSingleUserBindThings: "things:user-things:query",
  updateSingleUserBindThings: "things:user-things:update",
  getBatchRolesList: "control:tenant-role:query",
  addSingleRole: "control:tenant-role:create",
  updateSingleRole: "control:tenant-role:update",
  deleteBatchRoles: "control:tenant-role:delete",
  getSingleRole: "control:tenant-role:query",
  getSingleSubuserMenus: "control:user-menu:query",
  updateSingleUserBindMenus: "control:user-menu:update",
  getBatchSubuserRoles: "control:user-role:query",
  updateSingleBindRoles: "control:user-role:update",
  addSingleSubUser: "tenant:user:create",
  addSingleTenantLabel: "tenant:label:create",
  deleteBatchTenantLabels: "tenant:label:delete",
  modifySingleTenantLabel: "tenant:label:update",
  getUserHmiResourceTree: "out-hmi:user:query",
  getBindHmis: "out-hmi:user:query",
  updateBindHmis: "out-hmi:user:update",
  deleteSingleInfoModel: "mapping:info-model:delete",
  addSingleTenantFunctionBlock: "mapping:info-model:create",
  getSingleFunctionBlockDisplaySchema: "mapping:function-block:update",
  updateSingleFunctionBlockEventProperty: "mapping:function-block:update",
  updateSingleFunctionBlockEvent: "mapping:function-block:update",
  addSingleMappingRuleInfos: "mapping:mapping-rule:create",
  getSingleMappingRuleInfos: "mapping:mapping-rule:query",
  updateSingleMappingRuleInfos: "mapping:mapping-rule:update",
  deleteSingleMappingRuleInfos: "mapping:mapping-rule:delete",
  addInfoModelMappingWithItem: "mapping:info-model-mapping:create",
  updateSingleInfoModelMapping: "mapping:info-model-mapping:create",
  getSingleInfoModelMapping: "mapping:info-model-mapping:query",
  addSingleStatisticsMethod: "data-mgmt:data-statistic-method:create",
  deleteSingleStatisticsMethod: "data-mgmt:data-statistic-method:delete",
  updateSingleStatisticsMethod: "data-mgmt:data-statistic-method:update",
  getSingleStatisticsMethod: "data-mgmt:data-statistic-method:get",
  getBatchTenantStatisticsMethods: "data-mgmt:data-statistic-method:page",
  addSingleStatisticsTimerTask: "data-mgmt:data-statistic-task:create",
  addSingleStatisticsTask: "data-mgmt:data-statistic-task:create",
  deleteSingleStatisticsTask: "data-mgmt:data-statistic-task:delete",
  getBatchTenantStatisticsTasks: "data-mgmt:data-statistic-task:page",
  updateSingleStatisticsTask: "data-mgmt:data-statistic-task:update",
  updateSingleStatisticsTaskStatus: "data-mgmt:data-statistic-task:updateStatus",
  executeSingleStatisticsTask: "data-mgmt:data-statistic-task:execute",
  getTenantBatchStatisticTaskDimensionResult: "data-mgmt:data-statistic-jrnl:page",
  getTenantBatchTaskResult: "data-mgmt:data-statistic-jrnl:page",
  addSingleSingleWorkOrder: "work:work:create",
  getBatchSingleWorkOrders: "work:work:query",
  updateSingleSingleWorkOrder: "work:work:handle",
  deleteSingleSingleWorkOrder: "work:work:delete",
  getSingleSingleWorkOrder: "work:work:query",
  uploadFile: "out-file-manager:file-manager:upload"
};

let errorHandler;
let noHandlerError;
let fetchLocale = "zh";
function setFetchLocale(locale) {
  fetchLocale = locale;
}

function handleError(err) {
  var _a, _b, _c;

  let errDataArr = [];
  let errorArr = [];

  if (Array.isArray((_a = err.data) === null || _a === void 0 ? void 0 : _a.data)) {
    errDataArr = err.data.data;
  } else {
    errDataArr = [err.data];
  }

  errDataArr.forEach(errItem => {
    var _a2;

    let errorItemCode = (errItem === null || errItem === void 0 ? void 0 : errItem.code) || "http." + err.status;
    let errorItemMsg = (errItem === null || errItem === void 0 ? void 0 : errItem.message) || errorItemCode;

    if (errorItemCode && typeof errorItemCode === "string") {
      let errorModule = errorItemCode.split(".")[0];

      if (errorModule.indexOf("iot-") === -1) {
        errorModule = "iot-" + errorModule;
        errorItemCode = "iot-" + errorItemCode;
      }

      const locale = fetchLocale === "zh" ? "" : `-${fetchLocale}`;
      errorItemMsg = ((_a2 = controllers[`${errorModule}${locale}`]) === null || _a2 === void 0 ? void 0 : _a2[errorItemCode]) || errorItemCode;
    }

    errorArr.push({
      errorItemCode,
      errorItemMsg,
      errItem
    });
  });
  const errorCode = (_b = errorArr[0]) === null || _b === void 0 ? void 0 : _b.errorItemCode;
  const errorMsg = (_c = errorArr[0]) === null || _c === void 0 ? void 0 : _c.errorItemMsg;

  let output = () => {
    if (errorHandler) {
      errorHandler(errorCode, err, noHandlerError, errorArr);
    }

    return new Promise((resolve, reject) => {
      reject({
        errorCode,
        errorMsg,
        errorArr,
        err
      });
    });
  };

  return output();
}

function setErrorHandler(handler, noHandlerError2) {
  if (typeof handler === "function") {
    errorHandler = handler;
  } else {
    throw new Error("Error Handler Must Be Function");
  }
}
exports.getStorageCallback = void 0;
function setGetStorage(callback) {
  exports.getStorageCallback = callback;
}

function _getStorage(key) {
  if (exports.getStorageCallback) return exports.getStorageCallback(key);else return;
}

exports.setStorageCallback = void 0;
function setSetStorage(callback) {
  exports.setStorageCallback = callback;
}

function _setStorage(key, value) {
  if (exports.setStorageCallback) exports.setStorageCallback(key, value);
}

exports.removeStorageCallback = void 0;
function setRemoveStorage(callback) {
  exports.removeStorageCallback = callback;
}

function _removeStorage(key) {
  if (exports.removeStorageCallback) exports.removeStorageCallback(key);
}

let _fetchToken;

function setFetchToken(token) {
  _fetchToken = token;
}

function _getFetchToken() {
  if (_fetchToken) return _fetchToken;
  return _getStorage("token");
}

function generateHttpHeader() {
  return {
    "Authorization": "Bearer " + _getFetchToken()
  };
}
function generateHttpAuthorization() {
  return "Bearer " + _getFetchToken();
}
function init(baseURL2, timeout2, header) {}
let baseURL;
function setBaseUrl(baseURLStr) {
  baseURL = baseURLStr;
}
function getBaseUrl() {
  if (baseURL) return baseURL;
  if (window && window.location.host.indexOf("localhost") >= 0) return "/api";
  return "/v1";
}
let timeout = 3e4;
function setGlobalTimeout(globalTimeout) {
  timeout = globalTimeout;
}
function getGlobalTimeout() {
  return timeout;
}
let fetchCallback;
function setFetch(callback) {
  if (typeof callback === "function") {
    fetchCallback = callback;
  } else {
    console.error("Fetch \u5FC5\u987B\u4E3A Function");
  }
}
function setRoles(apis) {
  const userApiRoleListMap = {};
  apis === null || apis === void 0 ? void 0 : apis.forEach(item => {
    userApiRoleListMap[item.name] = true;
  });

  _setStorage("userApiRoleListMap", JSON.stringify(userApiRoleListMap));
}
function removeRoles() {
  _removeStorage("userApiRoleListMap");
}
function hasPermission(apiRoleNames) {
  const userApiRoleListMap = _getStorage("userApiRoleListMap") ? JSON.parse(_getStorage("userApiRoleListMap")) : void 0;

  if (userApiRoleListMap) {
    if (typeof apiRoleNames === "string") {
      return userApiRoleListMap.hasOwnProperty(apiRoleNames);
    } else {
      let flag = true;
      apiRoleNames.forEach(item => {
        if (!userApiRoleListMap.hasOwnProperty(item)) {
          flag = false;
        }
      });
      return flag;
    }
  } else {
    return true;
  }
}
function checkPermissionWithApiNames(apiNames) {
  const userApiRoleListMap = _getStorage("userApiRoleListMap") ? JSON.parse(_getStorage("userApiRoleListMap")) : void 0;

  if (userApiRoleListMap) {
    if (typeof apiNames === "string") {
      if (!ZWSAPIRoleMap.hasOwnProperty(apiNames)) {
        return true;
      }

      return userApiRoleListMap.hasOwnProperty(ZWSAPIRoleMap[apiNames]);
    } else {
      let flag = true;
      apiNames.forEach(item => {
        if (ZWSAPIRoleMap.hasOwnProperty(item) && !userApiRoleListMap.hasOwnProperty(ZWSAPIRoleMap[apiNames])) {
          flag = false;
        }
      });
      return flag;
    }
  } else {
    return true;
  }
}

function checkRole(roleName) {
  if (!roleName) return Promise.resolve();
  const userApiRoleListMap = _getStorage("userApiRoleListMap") ? JSON.parse(_getStorage("userApiRoleListMap")) : void 0;

  if (userApiRoleListMap && !userApiRoleListMap[roleName]) {
    return handleError({
      data: {
        code: "http.403",
        error: "Forbidden",
        message: "\u4E0D\u5141\u8BB8\u8BBF\u95EE",
        status: 403
      }
    });
  }

  return Promise.resolve();
}

function fetch(params, roleName) {
  let abortController = new AbortController();

  let _checkRole = checkRole(roleName).then(() => {
    if (fetchCallback) {
      params.abortController = abortController;
      return fetchCallback(params).catch(err => {
        return handleError(err);
      });
    } else {
      console.error(`\u672A\u8BBE\u7F6E fetch \u56DE\u8C03`);
      return handleError({
        data: {
          code: "error",
          error: "Not set fetch",
          message: "\u672A\u8BBE\u7F6E fetch \u56DE\u8C03",
          status: 404
        }
      });
    }
  });

  _checkRole.abort = abortController.abort.bind(abortController);
  return _checkRole;
}
function registerErrorCode(target) {
  Object.assign(controllers, target);
}
var ZWSBaseModule = {
  init,
  setErrorHandler,
  generateHttpHeader,
  generateHttpAuthorization,
  setBaseUrl,
  getBaseUrl,
  setGlobalTimeout,
  getGlobalTimeout,
  setGetStorage,
  setFetch,
  fetch,
  hasPermission,
  setRoles,
  removeRoles,
  checkPermissionWithApiNames
};

function getBatchAlertEvents({
  tenant_id,
  start_time,
  end_time,
  page_size,
  current_page,
  info_model_id,
  rule_id,
  rule_name,
  things_id,
  third_things_id,
  handler,
  handler_status,
  source_type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-data-mgmt/tenants/${tenant_id}/alert-events`,
    method: "get",
    params: {
      start_time,
      end_time,
      page_size,
      current_page,
      info_model_id,
      rule_id,
      rule_name,
      things_id,
      third_things_id,
      handler,
      handler_status,
      source_type
    }
  }, "alert:alert-data-event:query");
}
function deleteBatchAlertEvents({
  tenant_id,
  end_time,
  event_id,
  info_model_id,
  rule_id,
  start_time,
  things_id,
  third_things_id,
  handler,
  handler_status,
  id_list
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-data-mgmt/tenants/${tenant_id}/alert-events`,
    method: "delete",
    params: {
      end_time,
      info_model_id,
      rule_id,
      event_id,
      start_time,
      things_id,
      third_things_id,
      handler,
      handler_status,
      id_list
    }
  }, "alert:alert-data-event:delete");
}
function getSingleAlertEvents({
  tenant_id,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-data-mgmt/tenants/${tenant_id}/alert-events/${id}`,
    method: "get"
  }, "alert:alert-data-event:query");
}
function getSingleAlertEventsDownloadRecord({
  tenant_id,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-data-mgmt/tenants/${tenant_id}/alert-events/download-record/${id}`,
    method: "get"
  });
}
function updateSingleEventsStatus({
  tenant_id,
  id,
  handler,
  handler_description,
  handler_status
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-data-mgmt/tenants/${tenant_id}/alert-events/${id}/_handle`,
    method: "post",
    data: {
      handler,
      handler_description,
      handler_status
    }
  }, "alert:alert-data-event:handle");
}
function updateBatchEventsStatus({
  tenant_id,
  ids,
  handler,
  handler_description,
  handler_status
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-data-mgmt/tenants/${tenant_id}/alert-events/batch/_handle?ids=` + ids,
    method: "post",
    data: {
      handler,
      handler_description,
      handler_status
    }
  }, "alert:alert-data-event:handle");
}
function deleteAllAlertEvents({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-data-mgmt/tenants/${tenant_id}/alert-events/all`,
    method: "delete"
  }, "alert:alert-data-event:delete");
}
var AlertEvents = {
  getBatchAlertEvents,
  deleteBatchAlertEvents,
  getSingleAlertEvents,
  updateSingleEventsStatus,
  deleteAllAlertEvents
};

function getBatchUserAlertStatistics(fetchParams) {
  return fetch({ ...fetchParams,
    url: "/alert-mgmt/tenants/all/usage-statistics",
    method: "get"
  });
}
function getSingleUserAlertStatistics({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/all/usage-statistics`,
    method: "get"
  });
}
var AlertMgmtTenants = {
  getBatchUserAlertStatistics,
  getSingleUserAlertStatistics
};

function getBatchEdgeComputingRules({
  tenant_id,
  rule_type,
  rule_name,
  page_size,
  current_page
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/edge-computing-rules`,
    method: "get",
    params: {
      rule_type,
      rule_name,
      page_size,
      current_page
    }
  }, "alert:edge-computing-rule:query");
}
function getSingleEdgeRule({
  tenant_id,
  rule_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/edge-computing-rules/${rule_id}`,
    method: "get"
  }, "alert:edge-computing-rule:query");
}
function addSingleEdgeRule({
  tenant_id,
  rule_name,
  rule_type,
  rule_content_off,
  rule_content_on,
  things_filter
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/edge-computing-rules`,
    method: "post",
    data: {
      rule_name,
      rule_type,
      rule_content_off,
      rule_content_on,
      things_filter
    }
  }, "alert:edge-computing-rule:create");
}
function issueSingleEdgeComputingRule({
  tenant_id,
  rule_id,
  issuance_type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/edge-computing-rules/${rule_id}/issuance`,
    method: "post",
    data: {
      issuance_type
    }
  }, "alert:edge-computing-rule:issuance");
}
function updateSingleEdgeRule({
  tenant_id,
  rule_id,
  rule_name,
  rule_type,
  things_filter,
  rule_content_on,
  rule_content_off,
  attachment
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/edge-computing-rules/${rule_id}`,
    method: "put",
    data: {
      rule_name,
      rule_type,
      things_filter,
      rule_content_on,
      rule_content_off,
      attachment
    }
  }, "alert:edge-computing-rule:update");
}
function deleteSingleEdgeRule({
  tenant_id,
  rule_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/edge-computing-rules/${rule_id}`,
    method: "delete"
  }, "alert:edge-computing-rule:delete");
}
function getBatchEdgeRuleIssuanceHistory({
  tenant_id,
  rule_id,
  rule_type,
  page_size,
  current_page
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/edge-computing-rule-issuance-histories`,
    method: "get",
    params: {
      rule_type,
      rule_id,
      page_size,
      current_page
    }
  }, "alert:edge-computing-rule-issuance-history:query");
}
function deleteEdgeIssuanceHistories({
  tenant_id,
  rule_type,
  ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/edge-computing-rule-issuance-histories`,
    method: "delete",
    params: {
      rule_type,
      ids
    }
  }, "alert:edge-computing-rule-issuance-history:delete");
}
var EdgeComputiong = {
  getBatchEdgeComputingRules,
  getSingleEdgeRule,
  addSingleEdgeRule,
  issueSingleEdgeComputingRule,
  updateSingleEdgeRule,
  deleteSingleEdgeRule,
  getBatchEdgeRuleIssuanceHistory,
  deleteEdgeIssuanceHistories
};

function addBatchAlertAction({
  tenant_id,
  rule_id,
  build_payload_param,
  config,
  name,
  payload_script,
  payload_script_engine,
  payload_type,
  status,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/rules/${rule_id}/action`,
    method: "post",
    data: {
      build_payload_param,
      config,
      name,
      payload_script,
      payload_script_engine,
      payload_type,
      status,
      type
    }
  }, "alert:rule-action:update");
}
function updateSingleAlertAction({
  tenant_id,
  rule_id,
  action_id,
  build_payload_param,
  config,
  name,
  payload_script,
  payload_script_engine,
  payload_type,
  status,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/rules/${rule_id}/action/${action_id}`,
    method: "put",
    data: {
      build_payload_param,
      config,
      name,
      payload_script,
      payload_script_engine,
      payload_type,
      status,
      type
    }
  }, "alert:rule-action:update");
}
function getBatchRuleActions({
  tenant_id,
  rule_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/rules/${rule_id}/action`,
    method: "get"
  });
}
function deleteBatchAlertActions({
  tenant_id,
  rule_id,
  action_ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/rules/${rule_id}/action`,
    method: "delete",
    params: {
      idList: action_ids
    }
  }, "alert:rule-action:delete");
}
function addThingsForwardAction({
  tenant_id,
  rule_id,
  build_payload_param,
  config,
  name,
  payload_script,
  payload_script_engine,
  payload_type,
  status,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/things-forward/${rule_id}/action`,
    method: "post",
    data: {
      build_payload_param,
      config,
      name,
      payload_script,
      payload_script_engine,
      payload_type,
      status,
      type
    }
  }, "alert:things-forward-action:create");
}
function updateThingsForwardAction({
  tenant_id,
  action_id,
  rule_id,
  build_payload_param,
  config,
  name,
  payload_script,
  payload_script_engine,
  payload_type,
  status,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/things-forward/${rule_id}/action/${action_id}`,
    method: "put",
    data: {
      build_payload_param,
      config,
      name,
      payload_script,
      payload_script_engine,
      payload_type,
      status,
      type
    }
  }, "alert:things-forward-action:update");
}
function deleteThingsForwardAction({
  tenant_id,
  rule_id,
  action_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/things-forward/${rule_id}/action/${action_id}`,
    method: "delete"
  }, "alert:things-forward-action:delete");
}
function updateThingsForwardActionStatus({
  tenant_id,
  rule_id,
  action_id,
  status
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/things-forward/${rule_id}/action/${action_id}/status/${status}`,
    method: "put"
  }, "alert:things-forward-rules:update-status");
}
var RuleActions = {
  addBatchAlertAction,
  updateSingleAlertAction,
  getBatchRuleActions,
  deleteBatchAlertActions,
  addThingsForwardAction,
  updateThingsForwardAction,
  deleteThingsForwardAction,
  updateThingsForwardActionStatus
};

function addBatchAlertActionRecovery({
  tenant_id,
  rule_id,
  build_payload_param,
  config,
  name,
  payload_script,
  payload_script_engine,
  payload_type,
  status,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/rules/${rule_id}/action-recovery`,
    method: "post",
    data: {
      build_payload_param,
      config,
      name,
      payload_script,
      payload_script_engine,
      payload_type,
      status,
      type
    }
  }, "alert:rule-action:update");
}
function updateSingleAlertActionRecovery({
  tenant_id,
  rule_id,
  action_id,
  build_payload_param,
  config,
  name,
  payload_script,
  payload_script_engine,
  payload_type,
  status,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/rules/${rule_id}/action-recovery/${action_id}`,
    method: "put",
    data: {
      build_payload_param,
      config,
      name,
      payload_script,
      payload_script_engine,
      payload_type,
      status,
      type
    }
  }, "alert:rule-action:update");
}
function getBatchRuleActionRecovery({
  tenant_id,
  rule_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/rules/${rule_id}/action-recovery`,
    method: "get"
  });
}
function deleteBatchAlertActionsRecovery({
  tenant_id,
  rule_id,
  id_list
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/rules/${rule_id}/action-recovery`,
    method: "delete",
    params: {
      idList: id_list
    }
  }, "alert:rule-action:delete");
}
var RuleActionsRecovery = {
  addBatchAlertActionRecovery,
  updateSingleAlertActionRecovery,
  getBatchRuleActionRecovery,
  deleteBatchAlertActionsRecovery
};

function addSingleThingsForwardRule({
  tenant_id,
  custom_fields,
  forward_condition,
  name,
  things_selector,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/things-forward`,
    method: "post",
    data: {
      custom_fields,
      forward_condition,
      name,
      things_selector,
      type
    }
  });
}
function updateSingleThingsForwardRule({
  tenant_id,
  rule_id,
  custom_fields,
  forward_condition,
  name,
  things_selector,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/things-forward/${rule_id}`,
    method: "put",
    data: {
      custom_fields,
      forward_condition,
      name,
      things_selector,
      type
    }
  });
}
function getBatchThingsForwardRules({
  tenant_id,
  status,
  name,
  page_size,
  current_page,
  things_selector_key,
  things_selector_type,
  things_selector_value
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/things-forward`,
    method: "get",
    params: {
      status,
      name,
      page_size,
      current_page,
      things_selector_key,
      things_selector_type,
      things_selector_value
    }
  }, "alert:things-forward-rules:query");
}
function deleteSingleThingsForwardRule({
  tenant_id,
  rule_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/things-forward/${rule_id}`,
    method: "delete"
  });
}
function updateSingleThingsForwardRuleStatus({
  tenant_id,
  rule_id,
  status
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/things-forward/${rule_id}/status/${status}`,
    method: "put"
  });
}
function getSingleThingsForwardRule({
  tenant_id,
  rule_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/things-forward/${rule_id}`,
    method: "get"
  }, "alert:things-forward-rules:query");
}
var ThingsForwardRules = {
  addSingleThingsForwardRule,
  updateSingleThingsForwardRule,
  getBatchThingsForwardRules,
  deleteSingleThingsForwardRule,
  updateSingleThingsForwardRuleStatus,
  getSingleThingsForwardRule
};

function getBatchRules({
  tenant_id,
  page_size,
  current_page,
  name,
  last_update_time,
  rule_type,
  status,
  ids,
  things_selector_key,
  things_selector_value,
  things_selector_type,
  condition_field,
  condition_op,
  condition_value,
  things_ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/rules`,
    method: "get",
    params: {
      page_size,
      current_page,
      name,
      last_update_time,
      rule_type,
      status,
      ids,
      things_selector_key,
      things_selector_value,
      things_selector_type,
      condition_field,
      condition_op,
      condition_value,
      thingsIds: things_ids
    }
  }, "alert:trigger-rule:query");
}
function getSingleAlertRule({
  tenant_id,
  rule_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/rules/${rule_id}`,
    method: "get"
  });
}
function updateRuleStatus({
  tenant_id,
  rule_id,
  status
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/rules/${rule_id}/status/${status}`,
    method: "put"
  }, "alert:trigger-rule:update");
}
function deleteSingleRule({
  tenant_id,
  rule_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/rules/${rule_id}`,
    method: "delete"
  }, "alert:trigger-rule:delete");
}
function addSingleAlertRule({
  alert_description_type,
  custom_alert_description,
  level,
  enable_recovery,
  tenant_id,
  data_type,
  name,
  status,
  time_condition,
  trigger_condition,
  trigger_filter
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/rules`,
    method: "post",
    data: {
      alert_description_type,
      custom_alert_description,
      level,
      enable_recovery,
      data_type,
      name,
      status,
      time_condition,
      trigger_condition,
      trigger_filter
    }
  }, "alert:trigger-rule:create");
}
function updateSingleAlertRule({
  alert_description_type,
  custom_alert_description,
  level,
  enable_recovery,
  tenant_id,
  rule_id,
  data_type,
  name,
  status,
  time_condition,
  trigger_condition,
  trigger_filter
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/rules/${rule_id}`,
    method: "put",
    data: {
      alert_description_type,
      custom_alert_description,
      level,
      enable_recovery,
      data_type,
      name,
      status,
      time_condition,
      trigger_condition,
      trigger_filter
    }
  }, "alert:trigger-rule:update");
}
var TriggerRules = {
  getBatchRules,
  getSingleAlertRule,
  updateRuleStatus,
  deleteSingleRule,
  addSingleAlertRule,
  updateSingleAlertRule
};

function addSingleTwinsRule({
  tenant_id,
  shadow_type,
  name,
  status,
  trigger_condition,
  trigger_filter
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/twins-rules`,
    method: "post",
    data: {
      shadow_type,
      name,
      status,
      trigger_condition,
      trigger_filter
    }
  });
}
function updateSingleTwinsRule({
  tenant_id,
  rule_id,
  shadow_type,
  name,
  status,
  trigger_condition,
  trigger_filter
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/twins-rules/${rule_id}`,
    method: "put",
    data: {
      shadow_type,
      name,
      status,
      trigger_condition,
      trigger_filter
    }
  });
}
function getBatchTwinsRules({
  tenant_id,
  page_size,
  current_page,
  name,
  shadow_type,
  status,
  ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/twins-rules`,
    method: "get",
    params: {
      page_size,
      current_page,
      name,
      shadow_type,
      status,
      ids
    }
  });
}
function getSingleTwinsRule({
  tenant_id,
  rule_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/twins-rules/${rule_id}`,
    method: "get"
  });
}
function deleteSingleTwinsRule({
  tenant_id,
  rule_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/twins-rules/${rule_id}`,
    method: "delete"
  });
}
function getBatchLatestTwinsRules({
  tenant_id,
  shadow_type,
  things_ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/alert-mgmt/tenants/${tenant_id}/twins-rules/latestRules`,
    method: "get",
    params: {
      shadow_type,
      things_ids
    }
  });
}
var TwinsRules = {
  addSingleTwinsRule,
  updateSingleTwinsRule,
  getBatchTwinsRules,
  getSingleTwinsRule,
  deleteSingleTwinsRule,
  getBatchLatestTwinsRules
};

function queryConnectionPage({
  current_page,
  label_id,
  label_value,
  page_size,
  prefix,
  tenant
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/connection/connections`,
    method: "get",
    params: {
      current_page,
      label_id,
      label_value,
      page_size,
      prefix,
      tenant
    }
  });
}
function addConnection({
  cnumber,
  configuration,
  description,
  labels,
  name,
  order,
  tenant_ids,
  type,
  uri
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/connection/connections`,
    method: "post",
    data: {
      cnumber,
      configuration,
      description,
      labels,
      name,
      order,
      tenant_ids,
      type,
      uri
    }
  });
}
function getConnection({
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/connection/connections/${id}`,
    method: "get"
  });
}
function updateConnection({
  dto,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/connection/connections/${id}`,
    method: "post",
    data: dto
  });
}
function deleteConnections({
  ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/connection/connections/${ids}`,
    method: "delete"
  });
}
var ConnectionController = {
  queryConnectionPage,
  addConnection,
  getConnection,
  updateConnection,
  deleteConnections
};

function getConnectionLabels({
  connection_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/connection/connections/${connection_id}/labels`,
    method: "get"
  });
}
function addConnectionLabel({
  connection_id,
  dto,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/connection/connections/${connection_id}/labels/${id}/relations`,
    method: "post",
    data: dto
  });
}
function deleteConnectionLabels({
  connection_id,
  ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/connection/connections/${connection_id}/labels/${ids}`,
    method: "delete"
  });
}
function getConnectionLabel({
  label_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/connection/connections/labels/${label_id}`,
    method: "get"
  });
}
var ConnectionLabelController = {
  getConnectionLabels,
  addConnectionLabel,
  deleteConnectionLabels,
  getConnectionLabel
};

function getTargets({
  connection_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/connection/connections/${connection_id}/targets`,
    method: "get"
  });
}
function addTarget({
  connection_id,
  dto
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/connection/connections/${connection_id}/targets`,
    method: "post",
    data: dto
  });
}
function deleteTargets({
  connection_id,
  ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/connection/connections/${connection_id}/targets/${ids}`,
    method: "delete"
  });
}
function getTarget({
  connection_id,
  target_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/connection/connections/${connection_id}/targets/${target_id}`,
    method: "get"
  });
}
function updateTarget({
  connection_id,
  target,
  target_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/connection/connections/${connection_id}/targets/${target_id}`,
    method: "put",
    data: target
  });
}
var ConnectionTargetController = {
  getTargets,
  addTarget,
  deleteTargets,
  getTarget,
  updateTarget
};

function getMessage({
  correlation_id,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/connection/tenants/${tenant_id}/messages/${correlation_id}`,
    method: "get"
  });
}
function getMessageStatistics({
  begin_time,
  end_time,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/connection/tenants/${tenant_id}/messages/statistics`,
    method: "get",
    params: {
      begin_time,
      end_time
    }
  });
}
var ThingsMessageController = {
  getMessage,
  getMessageStatistics
};

function getPrivilegeSelf({
  platform
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/privileges/self`,
    method: "get",
    params: {
      platform
    }
  });
}
var MyPrivilege = {
  getPrivilegeSelf
};

function getBatchOrganizations({
  tenant_id,
  name,
  parent_organization_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/tenants/${tenant_id}/organization`,
    method: "get",
    params: {
      name,
      parent_organization_id
    }
  });
}
function addSingleOrganization({
  tenant_id,
  name,
  parent_id,
  platform
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/tenants/${tenant_id}/organization`,
    method: "post",
    data: {
      name,
      parent_id,
      platform
    }
  });
}
function updateSingleOrganization({
  tenant_id,
  name,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/tenants/${tenant_id}/organization/${id}`,
    method: "put",
    params: {
      name
    }
  });
}
function deleteSingleOrganization({
  tenant_id,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/tenants/${tenant_id}/organization/${id}`,
    method: "delete"
  });
}
function getBatchOrganizationTree({
  tenant_id,
  platform
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/tenants/${tenant_id}/organization-tree`,
    method: "get",
    params: {
      platform
    }
  });
}
function getBatchOrganizationUsers({
  tenant_id,
  page_size,
  current_page,
  organization_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/tenants/${tenant_id}/organizations/${organization_id}/user-organization`,
    method: "get",
    params: {
      page_size,
      current_page
    }
  });
}
function addSingleOrganizationUser({
  tenant_id,
  organization_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/tenants/${tenant_id}/organizations/${organization_id}/user-organization`,
    method: "post",
    params: {
      userId: user_id
    }
  });
}
function deleteSingleOrganizationUser({
  tenant_id,
  organization_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/tenants/${tenant_id}/organizations/${organization_id}/user-organization`,
    method: "delete",
    params: {
      userId: user_id
    }
  });
}
var Organization = {
  getBatchOrganizations,
  addSingleOrganization,
  updateSingleOrganization,
  deleteSingleOrganization,
  getBatchOrganizationTree,
  getBatchOrganizationUsers,
  addSingleOrganizationUser,
  deleteSingleOrganizationUser
};

function addSessions({
  username,
  password,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/control/sessions",
    method: "post",
    data: {
      password,
      type,
      username
    }
  });
}
function addSessionsForTenantManager({
  password = "",
  type = 1,
  username = "",
  ujwt
}, fetchParams) {
  const ujwtQuery = ujwt ? `?ujwt=${ujwt}` : "";
  return fetch({ ...fetchParams,
    url: `/control/sessions/tenant-manager${ujwtQuery}`,
    method: "post",
    data: {
      password,
      type,
      username
    }
  });
}
function deleteSessions({
  session_id,
  ujwt
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/sessions/${session_id}`,
    method: "delete",
    params: {
      ujwt
    }
  });
}
var Session = {
  addSessions,
  addSessionsForTenantManager,
  deleteSessions
};

function getBatchTenantApis({
  current_page,
  page_size,
  search,
  service
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/tenant-apis`,
    method: "get",
    params: {
      current_page,
      page_size,
      search,
      service
    }
  });
}
var TenantAPI = {
  getBatchTenantApis
};

function getBatchRolesList({
  current_page,
  page_size,
  prefix,
  tenant_id,
  platform,
  type,
  is_owner
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/tenants/${tenant_id}/roles`,
    method: "get",
    params: {
      current_page,
      page_size,
      prefix,
      platform,
      type,
      is_owner
    }
  }, "control:tenant-role:query");
}
function addSingleRole({
  tenant_id,
  name,
  description,
  access,
  menu,
  platform,
  things_access,
  type,
  auth_flag
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/tenants/${tenant_id}/roles`,
    method: "post",
    data: {
      name,
      description,
      access,
      menu,
      platform,
      things_access,
      type,
      auth_flag
    }
  }, "control:tenant-role:create");
}
function updateSingleRole({
  role_id,
  tenant_id,
  name,
  description,
  access,
  menu,
  platform,
  things_access,
  type,
  auth_flag
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/tenants/${tenant_id}/roles/${role_id}`,
    method: "put",
    data: {
      name,
      description,
      access,
      menu,
      platform,
      things_access,
      type,
      auth_flag
    }
  }, "control:tenant-role:update");
}
function deleteBatchRoles({
  tenant_id,
  ids,
  platform
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/tenants/${tenant_id}/roles/${ids}`,
    method: "delete",
    params: {
      platform
    }
  }, "control:tenant-role:delete");
}
function getSingleRole({
  platform,
  role_id,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/tenants/${tenant_id}/roles/${role_id}`,
    method: "get",
    params: {
      platform
    }
  }, "control:tenant-role:query");
}
function getSingleRoleMenu({
  platform,
  role_id,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/tenants/${tenant_id}/roles/${role_id}/menu`,
    method: "get",
    params: {
      platform
    }
  }, "control:tenant-role:query");
}
function getCommonRoles({
  current_page,
  page_size,
  platform,
  prefix,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/control/tenants/common-roles",
    method: "get",
    params: {
      current_page,
      page_size,
      platform,
      prefix,
      type
    }
  });
}
var TenantRole = {
  getBatchRolesList,
  addSingleRole,
  updateSingleRole,
  deleteBatchRoles,
  getSingleRole,
  getSingleRoleMenu,
  getCommonRoles
};

function getBatchThirdSupport({
  backPage
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/control/usercenter/third-support",
    method: "get",
    params: {
      backPage
    }
  });
}
function getUCVerificationCodes({
  destination,
  region,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/control/usercenter/verification-codes",
    method: "post",
    data: {
      destination,
      region,
      type
    }
  });
}
var Usercenter = {
  getBatchThirdSupport,
  getUCVerificationCodes
};

function getSingleSubuserMenus({
  user_id,
  tenant_id,
  platform
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/tenants/${tenant_id}/users/${user_id}/menus`,
    method: "get",
    params: {
      platform
    }
  }, "control:user-menu:query");
}
function updateSingleUserBindMenus({
  tenant_id,
  user_id,
  menu,
  attachment
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/tenants/${tenant_id}/users/${user_id}/menus`,
    method: "put",
    data: [{
      menu,
      attachment
    }]
  }, "control:user-menu:update");
}
function getBatchSubuserRoles({
  user_id,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/tenants/${tenant_id}/users/${user_id}/roles`,
    method: "get"
  }, "control:user-role:query");
}
function updateSingleBindRoles({
  tenant_id,
  user_id,
  role_ids,
  platform
}, fetchParams) {
  const params = platform ? `?platform=${platform}` : "";
  return fetch({ ...fetchParams,
    url: `/control/tenants/${tenant_id}/users/${user_id}/roles${params}`,
    method: "put",
    data: role_ids
  }, "control:user-role:update");
}
function updateBatchBindPrivileges({
  tenant_id,
  role_ids,
  user_ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/control/tenants/${tenant_id}/privileges`,
    method: "put",
    data: {
      role_ids,
      user_ids
    }
  });
}
var UserPrivilege = {
  getSingleSubuserMenus,
  updateSingleUserBindMenus,
  getBatchSubuserRoles,
  updateSingleBindRoles,
  updateBatchBindPrivileges
};

function getCustomDownloadTemplate({
  event_name,
  info_model_id,
  tenant_id,
  current_page,
  page_size
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/custom-download-template`,
    method: "get",
    params: {
      event_name,
      info_model_id,
      tenant_id,
      current_page,
      page_size
    }
  });
}
function addCustomDownloadTemplate({
  config_list,
  event_name,
  file_suffix,
  id,
  info_model_id,
  tenant_id,
  template_name
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/custom-download-template`,
    method: "post",
    data: {
      config_list,
      event_name,
      file_suffix,
      id,
      info_model_id,
      tenant_id,
      template_name
    }
  });
}
function updateCustomDownloadTemplateById({
  config_list,
  event_name,
  file_suffix,
  id,
  info_model_id,
  template_name,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/custom-download-template/${id}`,
    method: "put",
    data: {
      config_list,
      event_name,
      file_suffix,
      id,
      info_model_id,
      template_name,
      tenant_id
    }
  });
}
function deleteCustomDownloadTemplateById({
  id,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/custom-download-template/${id}`,
    method: "delete"
  });
}
var CustomDataDownloadTemplate = {
  getCustomDownloadTemplate,
  addCustomDownloadTemplate,
  updateCustomDownloadTemplateById,
  deleteCustomDownloadTemplateById
};

function addSingleDataDashbord({
  tenant_id,
  name,
  business_type,
  id,
  owner_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/dashboards`,
    method: "post",
    data: {
      name,
      business_type,
      id,
      owner_id
    }
  }, "data-mgmt:dashboard:create");
}
function updateSingleDataDashbord({
  tenant_id,
  id,
  dto
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/dashboards/${id}`,
    method: "put",
    data: dto
  }, "data-mgmt:dashboard:update");
}
function deleteSingleDataDashbord({
  tenant_id,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/dashboards/${id}`,
    method: "delete"
  }, "data-mgmt:dashboard:delete");
}
function getBatchDashbords({
  tenant_id,
  prefix,
  business_type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/dashboards`,
    method: "get",
    params: {
      prefix,
      business_type
    }
  }, "data-mgmt:dashboard:query");
}
function getSingleDashboard({
  tenant_id,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/dashboards/${id}`,
    method: "get",
    params: {}
  });
}
function addSingleDataDashbordPanel({
  tenant_id,
  chart_type,
  dashboard_id,
  name,
  business_type,
  description,
  panel_order,
  x_axis_type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/dashboard-panels`,
    method: "post",
    data: {
      chart_type,
      dashboard_id,
      name,
      business_type,
      description,
      panel_order,
      x_axis_type
    }
  }, "data-mgmt:dashboard-panel:create");
}
function deleteSingleDataDashbordPanel({
  tenant_id,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/dashboard-panels/${id}`,
    method: "delete"
  }, "data-mgmt:dashboard-panel:delete");
}
function updateSingleDataDashbordPanel({
  tenant_id,
  id,
  chart_type,
  dashboard_id,
  name,
  business_type = "",
  description,
  panel_order,
  x_axis_type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/dashboard-panels/${id}`,
    method: "put",
    data: {
      id,
      chart_type,
      dashboard_id,
      name,
      business_type,
      description,
      panel_order,
      x_axis_type
    }
  }, "data-mgmt:dashboard-panel:update");
}
function getSingleDataDashbordPanel({
  tenant_id,
  dashboard_id,
  business_type,
  chart_type,
  prefix
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/dashboard-panels`,
    method: "get",
    params: {
      dashboard_id,
      chart_type,
      business_type,
      prefix
    }
  });
}
function getSingleDataDashbordPanelThingsMetrics({
  tenant_id,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/panels/${id}/panel-thingsmetrics`,
    method: "get"
  });
}
function addSingleDataDashbordPanelThingsMetrics({
  tenant_id,
  id,
  dashboard_panel_metric
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/panels/${id}/panel-thingsmetrics`,
    method: "post",
    data: dashboard_panel_metric
  });
}
function updateSingleDataDashbordPanelThingsMetrics({
  tenant_id,
  id,
  dashboard_panel_metric
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/panel-thingsmetrics/${id}`,
    method: "post",
    data: dashboard_panel_metric
  });
}
function deleteSingleDataDashbordPanelThingsMetrics({
  tenant_id,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/panel-thingsmetrics/${id}`,
    method: "delete"
  });
}
function deleteBatchDataDashbordPanelThingsMetrics({
  tenant_id,
  panel_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/panels/${panel_id}/panel-thingsmetrics`,
    method: "delete"
  });
}
var DashboardController = {
  addSingleDataDashbord,
  updateSingleDataDashbord,
  deleteSingleDataDashbord,
  getBatchDashbords,
  getSingleDashboard,
  addSingleDataDashbordPanel,
  deleteSingleDataDashbordPanel,
  updateSingleDataDashbordPanel,
  getSingleDataDashbordPanel,
  getSingleDataDashbordPanelThingsMetrics,
  addSingleDataDashbordPanelThingsMetrics,
  updateSingleDataDashbordPanelThingsMetrics,
  deleteSingleDataDashbordPanelThingsMetrics,
  deleteBatchDataDashbordPanelThingsMetrics
};

function deleteThingsData({
  tenant_id,
  info_model_id,
  things_id,
  start_date,
  end_date,
  event_name,
  property,
  value,
  op,
  cleanChild,
  limitDeleteMaxDoc
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/info-model/${info_model_id}/things/${things_id}/data`,
    method: "delete",
    params: {
      start_date,
      end_date,
      event_name,
      property,
      value,
      op,
      cleanChild,
      limitDeleteMaxDoc
    }
  });
}
function getSingleCurrentCleanTask({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/current_clean_task`,
    method: "get"
  });
}
function getSingleCurrentCleanTaskDocumentRemaining({
  task_id,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/task/${task_id}/document_remaining`,
    method: "get"
  });
}
function getBatchCleanTaskDocumentRemaining({
  tenant_id,
  task_ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/task/document_remaining`,
    method: "get",
    params: {
      taskIds: task_ids
    }
  });
}
function getBatchToDoCleanTasks({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/todo_clean_task_list`,
    method: "get"
  });
}
function createQuickDeleteTask({
  tenant_id,
  end_timestamp,
  things_id,
  delete_children
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/quick_delete_task`,
    method: "post",
    data: {
      end_timestamp,
      things_id,
      delete_children
    }
  });
}
var DataCleaning = {
  deleteThingsData,
  getSingleCurrentCleanTask,
  getSingleCurrentCleanTaskDocumentRemaining,
  getBatchToDoCleanTasks,
  getBatchCleanTaskDocumentRemaining,
  createQuickDeleteTask
};

function getAllUsageBytesCountStatistics(fetchParams) {
  return fetch({ ...fetchParams,
    url: "/data-mgmt/tenants/all/usage-statistics",
    method: "get"
  });
}
function getAllTenantUsageStatistics({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/data-mgmt/tenants/all/tenant-usage-statistics",
    method: "get",
    params: {
      tenant_id
    }
  });
}
var DataMgmtUsageStatistics = {
  getAllUsageBytesCountStatistics,
  getAllTenantUsageStatistics
};

function getBatchBindDashbord({
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/users/${user_id}/dashboards`,
    method: "get"
  });
}
function updateBatchBindDashbord({
  tenant_id,
  user_id,
  ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/users/${user_id}/dashboards`,
    method: "put",
    data: ids
  });
}
var DataMgmtUserResource = {
  getBatchBindDashbord,
  updateBatchBindDashbord
};

function getPluginsByType({
  tenant_id,
  info_model_id,
  type
}, fetchParams) {
  let infoModelId = info_model_id;
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/data-transform-plugin`,
    method: "get",
    params: {
      infoModelId,
      type
    }
  });
}
function createSinglePlugin({
  tenant_id,
  data_transform
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/data-transform-plugin`,
    method: "post",
    data: data_transform
  });
}
function updateSinglePlugin({
  tenant_id,
  id,
  data_transform
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/data-transform-plugin/${id}`,
    method: "put",
    data: data_transform
  });
}
function deleteSinglePlugin({
  tenant_id,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/data-transform-plugin/${id}`,
    method: "delete"
  });
}
function getBatchPlugins({
  tenant_id,
  info_model_id,
  type,
  name = "",
  current_page,
  page_size
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/data-transform-plugin/page`,
    method: "get",
    params: {
      name,
      info_model_id,
      type,
      current_page,
      page_size
    }
  });
}
var DataTransform = {
  getPluginsByType,
  createSinglePlugin,
  updateSinglePlugin,
  deleteSinglePlugin,
  getBatchPlugins
};

function getBindDashbord({
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/users/${user_id}/dashboards`,
    method: "get"
  }, "data-mgmt:user-dashboard:query");
}
function updateBindDashbord({
  tenant_id,
  user_id,
  data
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/users/${user_id}/dashboards`,
    method: "put",
    data
  }, "data-mgmt:user-dashboard:update");
}
var DataUserResource = {
  getBindDashbord,
  updateBindDashbord
};

function getOpLog({
  tenant_id,
  start_date,
  end_date,
  current_page,
  page_size,
  module_name,
  user_id,
  payload,
  op_code_cn
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/maintenance/op-log`,
    method: "get",
    params: {
      tenant_id,
      start_date,
      end_date,
      current_page,
      page_size,
      moduleName: module_name,
      user_id,
      payload,
      opCodeCn: op_code_cn
    }
  });
}
var OpLog = {
  getOpLog
};

function getHistory({
  begin_time,
  end_time,
  tenant_id,
  third_things_id,
  things_id_list,
  info_model_id,
  interval = 0,
  calendar_interval
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/statistics/history`,
    method: "get",
    params: {
      begin_time,
      end_time,
      tenant_id,
      third_things_id,
      interval,
      info_model_id,
      things_id_list,
      calendar_interval
    }
  });
}
function getOriginHistory({
  begin_time,
  end_time,
  tenant_id,
  third_things_id,
  things_id_list,
  info_model_id,
  interval = 0,
  calendar_interval
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/statistics/origin_history`,
    method: "get",
    params: {
      begin_time,
      end_time,
      tenant_id,
      third_things_id,
      interval,
      info_model_id,
      things_id_list,
      calendar_interval
    }
  });
}
function getTenantFlow({
  begin_time,
  end_time,
  current_page,
  page_size,
  sortField,
  sortType,
  tenant_name
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/statistics/tenant`,
    method: "get",
    params: {
      begin_time,
      end_time,
      current_page,
      page_size,
      sortField,
      sortType,
      tenant_name
    }
  });
}
function getTenantOriginFlow({
  begin_time,
  end_time,
  current_page,
  page_size,
  sortField,
  sortType,
  tenant_name
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/statistics/tenant/origin`,
    method: "get",
    params: {
      begin_time,
      end_time,
      current_page,
      page_size,
      sortField,
      sortType,
      tenant_name
    }
  });
}
function getTenantDeviceRanking({
  begin_time,
  end_time,
  current_page,
  page_size,
  sortField,
  sortType,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/statistics/tenant/${tenant_id}/things`,
    method: "get",
    params: {
      begin_time,
      end_time,
      current_page,
      page_size,
      sortField,
      sortType
    }
  });
}
function getTenantDeviceOriginRanking({
  begin_time,
  end_time,
  current_page,
  page_size,
  sortField,
  sortType,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/statistics/tenant/${tenant_id}/things/origin`,
    method: "get",
    params: {
      begin_time,
      end_time,
      current_page,
      page_size,
      sortField,
      sortType
    }
  });
}
var Statistics = {
  getHistory,
  getTenantFlow,
  getTenantDeviceRanking
};

function getBatchStatisticsResultExportTransformPlugins({
  current_page,
  page_size,
  statistics_method_id,
  tenant_id,
  type,
  name,
  include_public
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/statistics-export-transform-plugin`,
    method: "get",
    params: {
      current_page,
      name,
      page_size,
      statistics_method_id,
      type,
      include_public
    }
  });
}
function deleteSingleStatisticsExportTransformPlugin({
  id,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/statistics-export-transform-plugin/${id}`,
    method: "delete"
  });
}
function getSingleStatisticsExportTransformPlugin({
  id,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/statistics-export-transform-plugin/${id}`,
    method: "get"
  });
}
function updateSingleStatisticsExportTransformPlugin({
  id,
  tenant_id,
  engine_name,
  name,
  script,
  statistics_method_id,
  type,
  file_suffix,
  export_template
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/statistics-export-transform-plugin/${id}`,
    method: "put",
    data: {
      engine_name,
      name,
      script,
      statistics_method_id,
      type,
      file_suffix,
      export_template
    }
  });
}
function addSingleStatisticsExportTransformPlugin({
  tenant_id,
  engine_name,
  name,
  script,
  statistics_method_id,
  type,
  file_suffix,
  export_template
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/statistics-export-transform-plugin`,
    method: "post",
    data: {
      engine_name,
      name,
      script,
      statistics_method_id,
      type,
      file_suffix,
      export_template
    }
  });
}
var StatisticsExportTransform = {
  getBatchStatisticsResultExportTransformPlugins,
  deleteSingleStatisticsExportTransformPlugin,
  getSingleStatisticsExportTransformPlugin,
  updateSingleStatisticsExportTransformPlugin,
  addSingleStatisticsExportTransformPlugin
};

function updateSingleStatisticsMethod({
  tenant_id,
  description,
  id,
  name,
  open_access,
  param_mapping,
  result_mapping,
  script,
  script_type,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenant/${tenant_id}/statistics-methods/${id}`,
    method: "put",
    data: {
      description,
      id,
      name,
      open_access,
      param_mapping,
      result_mapping,
      script,
      script_type,
      tenant_id,
      type
    }
  }, "data-mgmt:data-statistic-method:update");
}
function addSingleStatisticsMethod({
  tenant_id,
  description,
  id,
  name,
  open_access,
  param_mapping,
  result_mapping,
  script,
  script_type,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenant/${tenant_id}/statistics-methods`,
    method: "post",
    data: {
      description,
      id,
      name,
      open_access,
      param_mapping,
      result_mapping,
      script,
      script_type,
      tenant_id,
      type
    }
  }, "data-mgmt:data-statistic-method:create");
}
function deleteSingleStatisticsMethod({
  tenant_id,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenant/${tenant_id}/statistics-methods/${id}`,
    method: "delete",
    params: {
      tenant_id,
      id
    }
  }, "data-mgmt:data-statistic-method:delete");
}
function getSingleStatisticsMethod({
  tenant_id,
  id,
  end_date,
  current_page,
  page_size,
  module_name,
  user_id,
  payload,
  opCodeCn
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenant/${tenant_id}/statistics-methods/${id}`,
    method: "get",
    params: {
      tenant_id,
      id,
      end_date,
      current_page,
      page_size,
      module_name,
      user_id,
      payload,
      opCodeCn
    }
  }, "data-mgmt:data-statistic-method:get");
}
function getBatchTenantStatisticsMethods({
  tenant_id,
  current_page,
  page_size,
  include_public,
  name
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenant/${tenant_id}/statistics-methods/page`,
    method: "get",
    params: {
      tenant_id,
      current_page,
      page_size,
      include_public,
      name
    }
  }, "data-mgmt:data-statistic-method:page");
}
var StatisticsMethods = {
  addSingleStatisticsMethod,
  deleteSingleStatisticsMethod,
  updateSingleStatisticsMethod,
  getSingleStatisticsMethod,
  getBatchTenantStatisticsMethods
};

function addSingleStatisticsTimerTask({
  tenant_id,
  method_id,
  execute_interval,
  param,
  name,
  time_interval,
  task_kind,
  cron_expression,
  delay,
  enable_task,
  is_template
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenant/${tenant_id}/statistics/method/${method_id}/timer-task`,
    method: "post",
    data: {
      execute_interval,
      param,
      name,
      time_interval,
      task_kind,
      cron_expression,
      delay,
      enable_task,
      is_template
    }
  }, "data-mgmt:data-statistic-task:create");
}
function updateSingleStatisticsTaskStatus({
  tenant_id,
  method_id,
  task_id,
  status
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenant/${tenant_id}/statistics/method/${method_id}/tasks/${task_id}/status/${status}`,
    method: "put",
    params: {}
  }, "data-mgmt:data-statistic-task:updateStatus");
}
function executeSingleStatisticsTask({
  tenant_id,
  method_id,
  task_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenant/${tenant_id}/statistics/method/${method_id}/tasks/${task_id}/_execute`,
    method: "post",
    params: {}
  }, "data-mgmt:data-statistic-task:execute");
}
function deleteSingleStatisticsTask({
  tenant_id,
  method_id,
  task_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenant/${tenant_id}/statistics/method/${method_id}/tasks/${task_id}`,
    method: "delete",
    params: {}
  }, "data-mgmt:data-statistic-task:delete");
}
function getBatchTenantStatisticsTasks({
  tenant_id,
  method_id,
  task_type,
  current_page,
  page_size,
  task_kind,
  is_template,
  name
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenant/${tenant_id}/statistics/method/${method_id}/tasks/page`,
    method: "get",
    params: {
      tenant_id,
      method_id,
      task_type,
      current_page,
      page_size,
      task_kind,
      is_template,
      name
    }
  }, "data-mgmt:data-statistic-task:page");
}
function getSingleTenantStatisticsTask({
  tenant_id,
  method_id,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenant/${tenant_id}/statistics/method/${method_id}/tasks/${id}`,
    method: "get"
  }, "data-mgmt:data-statistic-task:get");
}
function addSingleStatisticsTask({
  tenant_id,
  end_time,
  method_id,
  name,
  start_time,
  task_type,
  param,
  period_type,
  cron_expression,
  data_start_time,
  data_end_time,
  data_time_type,
  time_interval
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenant/${tenant_id}/statistics/method/${method_id}/tasks`,
    method: "post",
    data: {
      end_time,
      method_id,
      name,
      start_time,
      task_type,
      param,
      period_type,
      cron_expression,
      data_start_time,
      data_end_time,
      data_time_type,
      time_interval
    }
  }, "data-mgmt:data-statistic-task:create");
}
function updateSingleStatisticsTask({
  is_simple_task,
  execute_interval,
  tenant_id,
  end_time,
  method_id,
  task_id,
  name,
  start_time,
  task_type,
  param,
  period_type,
  cron_expression,
  data_start_time,
  data_end_time,
  data_time_type,
  time_interval
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenant/${tenant_id}/statistics/method/${method_id}/tasks/${task_id}`,
    method: "put",
    data: {
      is_simple_task,
      execute_interval,
      end_time,
      method_id,
      name,
      start_time,
      task_type,
      param,
      period_type,
      cron_expression,
      data_start_time,
      data_end_time,
      data_time_type,
      time_interval
    }
  }, "data-mgmt:data-statistic-task:update");
}
function downloadTenantStatisticsDataResult({
  tenant_id,
  method_id,
  task_id,
  begin_time,
  end_time,
  data_transform_id,
  user_id,
  statistical_dimension,
  dimension_id_list,
  statistical_time_type,
  aggregation_type,
  download_extra_param_str,
  extra_parameter
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/statistics/method/${method_id}/tasks/${task_id}/data/download`,
    method: "post",
    data: {
      method_id,
      tenant_id,
      task_id,
      begin_time,
      end_time,
      data_transform_id,
      user_id,
      statistical_dimension,
      dimension_id_list,
      statistical_time_type,
      aggregation_type,
      download_extra_param_str,
      extra_parameter
    }
  });
}
function getTenantStatisticsDataResultDownloadInfo({
  download_id,
  tenant_id,
  method_id,
  task_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/statistics/method/${method_id}/tasks/${task_id}/data/downloading/${download_id}`,
    method: "get"
  });
}
function addSingleReport({
  tenant_id,
  method_id,
  cron_expression,
  delay,
  enable_task,
  execute_interval,
  is_template,
  name,
  param,
  task_kind,
  time_interval
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenant/${tenant_id}/statistics/method/${method_id}/timer-task`,
    method: "post",
    data: {
      cron_expression,
      delay,
      enable_task,
      execute_interval,
      is_template,
      name,
      param,
      task_kind,
      time_interval
    }
  });
}
function updateBatchTenantStatisticsTasksName({
  tenant_id,
  ids,
  name,
  is_template,
  param
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenant/${tenant_id}/statistics/method/tasks/${ids}`,
    method: "put",
    data: {
      name,
      is_template,
      param
    }
  });
}
var StatisticsTask = {
  addSingleStatisticsTimerTask,
  updateSingleStatisticsTaskStatus,
  executeSingleStatisticsTask,
  deleteSingleStatisticsTask,
  getBatchTenantStatisticsTasks,
  getTenantStatisticsDataResultDownloadInfo,
  addSingleReport
};

function getTenantBatchStatisticTaskDimensionResult({
  tenant_id,
  method_id,
  task_id,
  statistical_time_type,
  current_page,
  page_size,
  start_date,
  end_date,
  statistical_dimension,
  dimension_ids,
  sort,
  aggregation_type,
  extra_parameter
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenant/${tenant_id}/statistics/tasks_jrnl/page-with-dimension`,
    method: "get",
    params: {
      tenant_id,
      method_id,
      task_id,
      statistical_time_type,
      current_page,
      page_size,
      start_date,
      end_date,
      statistical_dimension,
      dimension_ids,
      sort,
      aggregation_type,
      extra_parameter
    }
  }, "data-mgmt:data-statistic-jrnl:page");
}
function getTenantBatchTaskResult({
  tenant_id,
  method_id,
  task_id,
  current_page,
  page_size,
  start_date,
  end_date
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenant/${tenant_id}/statistics/tasks_jrnl/page`,
    method: "get",
    params: {
      tenant_id,
      method_id,
      task_id,
      current_page,
      page_size,
      start_date,
      end_date
    }
  }, "data-mgmt:data-statistic-jrnl:page");
}
function getBatchTaskAggStatisticsByDimension({
  tenant_id,
  agg_fun,
  dimension_id_list,
  end_date,
  group_id_list,
  method_id,
  period,
  start_date,
  statistical_dimension,
  task_id,
  task_name
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenant/${tenant_id}/statistics/tasks_jrnl/agg`,
    method: "post",
    data: {
      agg_fun,
      dimension_id_list,
      end_date,
      group_id_list,
      method_id,
      period,
      start_date,
      statistical_dimension,
      task_id,
      task_name
    }
  });
}
var StatisticsTaskJrnl = {
  getTenantBatchStatisticTaskDimensionResult,
  getTenantBatchTaskResult,
  getBatchTaskAggStatisticsByDimension
};

function getSingleStatisticsSyncData({
  agg_fun,
  compute,
  condition,
  end_time,
  group_id,
  info_model_id,
  period,
  property,
  start_time,
  things_id,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenant/${tenant_id}/statistics/sync`,
    method: "post",
    data: {
      agg_fun,
      compute,
      condition,
      end_time,
      group_id,
      info_model_id,
      period,
      property,
      start_time,
      things_id
    }
  });
}
var StatisticSync = {
  getSingleStatisticsSyncData
};

function getTenantDatamgmtUsageLatest({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/usage/latest`,
    method: "get",
    timeout: 12e4
  });
}
function getTenantUsagePercentage({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/usage/percentage`,
    method: "get"
  });
}
function getBatchTenantUsageByTime({
  tenant_id,
  agg_type,
  end_date,
  start_date,
  page_size,
  current_page
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/usage/jrnl`,
    method: "get",
    params: {
      agg_type,
      end_date,
      start_date,
      page_size,
      current_page
    }
  });
}
var TenantUsage = {
  getTenantDatamgmtUsageLatest,
  getBatchTenantUsageByTime,
  getTenantUsagePercentage
};

function getSingleThingsData({
  tenant_id,
  info_model_id,
  things_id,
  category_id,
  begin_time,
  end_time,
  event_name,
  op,
  page_size,
  property,
  sort,
  value,
  data_type,
  current_page,
  sort_property,
  sort_property_order,
  sort_property_type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/info-model/${info_model_id}/things/${things_id}/data`,
    method: "get",
    params: {
      begin_time,
      end_time,
      event_name,
      op,
      page_size,
      property,
      value,
      data_type,
      sort,
      category_id,
      current_page,
      sort_property,
      sort_property_order,
      sort_property_type
    }
  }, "data-mgmt:thing-data:query");
}
function issueRequestDownloadDeviceData({
  begin_time,
  category_id,
  data_transform_id,
  download_template_id,
  end_time,
  event_name,
  group_id,
  info_model_id,
  op,
  property,
  query_by_group,
  sort_property,
  sort_property_order,
  sort_property_type,
  tenant_id,
  things_id,
  user_id,
  value,
  equals_condition_list,
  not_equals_condition_list,
  internationalization
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/info-model/${info_model_id}/things/${things_id}/data/download`,
    method: "post",
    data: {
      begin_time,
      category_id,
      data_transform_id,
      download_template_id,
      end_time,
      event_name,
      group_id,
      info_model_id,
      op,
      property,
      query_by_group,
      sort_property,
      sort_property_order,
      sort_property_type,
      tenant_id,
      things_id,
      user_id,
      value,
      equals_condition_list,
      not_equals_condition_list,
      internationalization
    }
  }, "data-mgmt:thing-data:download");
}
function getDeviceGpsHistoryData({
  begin_time,
  category_id,
  data_transform_id,
  download_template_id,
  end_time,
  event_name,
  group_id,
  info_model_id,
  op,
  property,
  query_by_group,
  sort_property,
  sort_property_order,
  sort_property_type,
  tenant_id,
  things_id,
  user_id,
  value
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/info-model/${info_model_id}/things/${things_id}/data/gps-history`,
    method: "post",
    data: {
      begin_time,
      category_id,
      data_transform_id,
      download_template_id,
      end_time,
      event_name,
      group_id,
      info_model_id,
      op,
      property,
      query_by_group,
      sort_property,
      sort_property_order,
      sort_property_type,
      tenant_id,
      things_id,
      user_id,
      value
    },
    timeout: 12e4
  });
}
function getQueryDownloadDeviceData({
  tenant_id,
  info_model_id,
  download_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/info-model/${info_model_id}/data/downloading/${download_id}`,
    method: "get"
  }, "data-mgmt:thing-data:download");
}
function getBatchThingsMessageTraces({
  tenant_id,
  info_model_id,
  things_id,
  begin_time,
  end_time,
  message_trace_id,
  current_page,
  page_size
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/datamgmt/tenants/${tenant_id}/info-models/${info_model_id}/things/${things_id}/message-traces`,
    method: "get",
    params: {
      begin_time,
      end_time,
      message_trace_id,
      current_page,
      page_size
    }
  });
}
function getSingleThingsInfoByTimeRange({
  tenant_id,
  info_model_id,
  things_id,
  begin_time,
  category_id,
  end_time,
  event_name,
  data_type,
  agg_type,
  agg_field
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/info-model/${info_model_id}/things/${things_id}/_aggregations`,
    method: "get",
    params: {
      begin_time,
      category_id,
      end_time,
      event_name,
      data_type,
      agg_type,
      agg_field
    }
  });
}
function getSingleThingsDataAggregation({
  tenant_id,
  info_model_id,
  things_id,
  category_id,
  begin_time,
  end_time,
  event_type,
  event_name,
  data_points,
  points_num,
  sort_property,
  sort_property_order,
  sort_property_type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/info-model/${info_model_id}/things/${things_id}/history-aggregation`,
    method: "post",
    data: {
      begin_time,
      end_time,
      category_id,
      data_points,
      event_type,
      event_name,
      points_num,
      sort_property,
      sort_property_order,
      sort_property_type
    }
  }, "data-mgmt:thing-data:history-aggregation");
}
function getSingleSignalPeriod({
  tenant_id,
  info_model_id,
  things_id,
  category_id,
  begin_time,
  end_time,
  event_type,
  event_name,
  data_points,
  points_num
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/info-model/${info_model_id}/things/${things_id}/signal-period`,
    method: "post",
    data: {
      begin_time,
      end_time,
      category_id,
      data_points,
      event_type,
      event_name,
      points_num
    }
  }, "data-mgmt:thing-data:query");
}
function updateSingleDeviceDataStatus({
  info_model_id,
  tenant_id,
  things_id,
  begin_time,
  category_id,
  deal_status,
  deal_time,
  deal_user,
  deal_way,
  end_time,
  event_name,
  event_type,
  id,
  index_prefix,
  tenant_name,
  third_things_id,
  timestamp,
  _id,
  property,
  value,
  op,
  group_id,
  query_by_group,
  batch_es_requests
}, fetchParams) {
  var url = `/data-mgmt/tenants/${tenant_id}/info-model/${info_model_id}/things/${things_id}/log-handle`;

  if (event_name) {
    url = url + "?event_name =  " + event_name;
  }

  return fetch({ ...fetchParams,
    url,
    method: "post",
    data: {
      batch_es_requests,
      event_type,
      id,
      index_prefix,
      tenant_name,
      deal_status,
      deal_time,
      begin_time,
      category_id,
      _id,
      deal_user,
      deal_way,
      timestamp,
      end_time,
      info_model_id,
      event_name,
      tenant_id,
      things_id,
      third_things_id,
      property,
      value,
      op,
      group_id,
      query_by_group
    }
  });
}
function getBatchGroupDatas({
  begin_time,
  category_id,
  current_page,
  data_type,
  end_time,
  event_name,
  group_id,
  info_model_id,
  deal_status,
  query_by_group,
  op,
  page_size,
  property,
  tenant_id,
  value
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/group-data`,
    method: "get",
    params: {
      begin_time,
      category_id,
      current_page,
      data_type,
      end_time,
      event_name,
      group_id,
      op,
      page_size,
      property,
      value,
      info_model_id,
      deal_status,
      query_by_group
    }
  }, "data-mgmt:thing-data:query");
}
function getDataDownloadList({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/data/downloading/list`,
    method: "get"
  }, "data-mgmt:thing-data:download");
}
function updateDataDownloadStatus({
  record_id,
  status,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/data/downloading/status`,
    method: "put",
    params: {
      recordId: record_id,
      status
    }
  }, "data-mgmt:thing-data:download");
}
function deleteSpecialStorage({
  index_name,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/special-storage/${index_name}`,
    method: "delete"
  }, "data-mgmt:thing-data:download");
}
function issueSpecialStorageDataBackup({
  download_template_id,
  index_name,
  tenant_id,
  transform_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/special-storage/data/backup`,
    method: "post",
    params: {
      download_template_id,
      index_name,
      transform_id
    }
  }, "data-mgmt:thing-data:download");
}
function getSpecialStorageIndexList({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/special-storage/index-list`,
    method: "get"
  }, "data-mgmt:thing-data:download");
}
function getBatchGroupDatasWithMultiCondition({
  begin_time,
  category_id,
  current_page,
  data_type,
  end_time,
  event_name,
  group_id,
  info_model_id,
  query_by_group,
  op,
  page_size,
  property,
  tenant_id,
  value,
  equals_condition_list,
  not_equals_condition_list
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/group-data-with-multi-condition`,
    method: "post",
    data: {
      begin_time,
      category_id,
      current_page,
      data_type,
      end_time,
      event_name,
      group_id,
      info_model_id,
      query_by_group,
      op,
      page_size,
      property,
      tenant_id,
      value,
      equals_condition_list,
      not_equals_condition_list
    }
  });
}
function getBatchThingDatasByModel({
  begin_time,
  category_id,
  end_time,
  event_name,
  event_type,
  info_model_id,
  tenant_id,
  things_id,
  top_n
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/data-mgmt/tenants/${tenant_id}/info-model/${info_model_id}/things/${things_id}/aggs/event`,
    method: "get",
    params: {
      begin_time,
      category_id,
      end_time,
      event_name,
      event_type,
      topN: top_n
    }
  });
}
var ThingsDataController = {
  getSingleThingsData,
  issueRequestDownloadDeviceData,
  getQueryDownloadDeviceData,
  getBatchThingsMessageTraces,
  getSingleThingsInfoByTimeRange,
  getSingleThingsDataAggregation,
  updateSingleDeviceDataStatus,
  getBatchGroupDatas,
  getSingleSignalPeriod,
  getDataDownloadList,
  updateDataDownloadStatus,
  getDeviceGpsHistoryData,
  deleteSpecialStorage,
  issueSpecialStorageDataBackup,
  getSpecialStorageIndexList,
  getBatchGroupDatasWithMultiCondition,
  getBatchThingDatasByModel
};

function getBatchHandlerActions({
  name
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/job-mgmt/handler-action`,
    method: "get",
    params: {
      name
    }
  });
}
var HandlerAction = {
  getBatchHandlerActions
};

function getBatchJobs({
  tenant_id,
  page_size,
  current_page,
  name,
  things_selector_key,
  things_selector_type,
  things_selector_value,
  job_kind
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/job-mgmt/tenants/${tenant_id}/jobs`,
    method: "get",
    params: {
      page_size,
      current_page,
      name,
      things_selector_key,
      things_selector_type,
      things_selector_value,
      job_kind
    }
  }, "job-mgmt:job:query");
}
function addSingleJob({
  tenant_id,
  cron_expression,
  end_time,
  handler_action_id,
  handler_custom_param,
  name,
  retry_period,
  retry_times,
  start_time,
  things_selector_list,
  job_kind
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/job-mgmt/tenants/${tenant_id}/jobs`,
    method: "post",
    data: {
      cron_expression,
      end_time,
      handler_action_id,
      handler_custom_param,
      name,
      retry_period,
      retry_times,
      start_time,
      things_selector_list,
      job_kind
    }
  }, "job-mgmt:job:create");
}
function updateSingleJob({
  tenant_id,
  job_id,
  cron_expression,
  end_time,
  handler_action_id,
  handler_custom_param,
  name,
  retry_period,
  retry_times,
  start_time,
  things_selector_list,
  job_kind
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/job-mgmt/tenants/${tenant_id}/jobs/${job_id}`,
    method: "put",
    data: {
      cron_expression,
      end_time,
      handler_action_id,
      handler_custom_param,
      name,
      retry_period,
      retry_times,
      start_time,
      things_selector_list,
      job_kind
    }
  }, "job-mgmt:job:edit");
}
function updateSingleJobStatus({
  tenant_id,
  job_id,
  value
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/job-mgmt/tenants/${tenant_id}/jobs/${job_id}/status`,
    method: "put",
    data: {
      value
    }
  }, "job-mgmt:job:edit-status");
}
function getSingleJobDetails({
  tenant_id,
  job_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/job-mgmt/tenants/${tenant_id}/jobs/${job_id}`,
    method: "get"
  }, "job-mgmt:job:query");
}
function deleteSingleJob({
  tenant_id,
  job_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/job-mgmt/tenants/${tenant_id}/jobs/${job_id}`,
    method: "delete"
  }, "job-mgmt:job:delete");
}
var Job = {
  getBatchJobs,
  addSingleJob,
  updateSingleJob,
  updateSingleJobStatus,
  getSingleJobDetails,
  deleteSingleJob
};

function getBatchJobLogs({
  job_id,
  page_size,
  current_page,
  start_time,
  end_time,
  tenant_id,
  job_name
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/job-mgmt/tenants/${tenant_id}/job-logs`,
    method: "get",
    params: {
      job_id,
      page_size,
      current_page,
      start_time,
      end_time,
      job_name
    }
  }, "job-mgmt:job-log:query");
}
function deleteSingleJobLog({
  job_id,
  tenant_id,
  log_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/job-mgmt/tenants/${tenant_id}/job/${job_id}/logs/${log_id}`,
    method: "delete"
  }, "job-mgmt:job-log:delete");
}
function deleteBatchJobLogs({
  job_id,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/job-mgmt/tenants/${tenant_id}/job/${job_id}/logs`,
    method: "delete"
  }, "job-mgmt:job-log:delete");
}
function deleteAllJobLog({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/job-mgmt/tenants/${tenant_id}/cleanup`,
    method: "delete"
  }, "job-mgmt:job-log:delete");
}
var JobLog = {
  getBatchJobLogs,
  deleteSingleJobLog,
  deleteAllJobLog,
  deleteBatchJobLogs
};

function addSingleDeviceCategory({
  name,
  description,
  templates
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/mapping-mgmt/categories",
    method: "post",
    data: {
      name,
      description,
      templates
    }
  });
}
function getBatchDeviceCategory({
  prefix,
  current_page,
  page_size
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/mapping-mgmt/categories",
    method: "get",
    params: {
      prefix,
      current_page,
      page_size
    }
  });
}
function updateSingleDeviceCategory({
  category_id,
  name,
  description,
  templates
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/categories/${category_id}`,
    method: "put",
    data: {
      name,
      description,
      templates
    }
  });
}
function deleteSingleDeviceCategory({
  ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/categories/${ids}`,
    method: "delete"
  });
}
var Category = {
  addSingleDeviceCategory,
  getBatchDeviceCategory,
  updateSingleDeviceCategory,
  deleteSingleDeviceCategory
};

function getSingleDeviceCategoryTemplate({
  category_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/categories/${category_id}/template`,
    method: "get"
  });
}
function updateSingleDeviceCategoryTemplate({
  category_id,
  templates
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/categories/${category_id}/template`,
    method: "put",
    data: templates
  });
}
function getDeviceGlobalTemplate(fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/categories/global/template`,
    method: "get"
  });
}
function updateDeviceGlobalTemplate({
  templates
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/categories/global/template`,
    method: "put",
    data: templates
  });
}
var CategoryTemplate = {
  getSingleDeviceCategoryTemplate,
  updateSingleDeviceCategoryTemplate,
  getDeviceGlobalTemplate,
  updateDeviceGlobalTemplate
};

function uploadSingleDBCFile({
  tenant_id,
  file,
  protocol = 2
}, fetchParams) {
  let formData = new FormData();
  formData.append("upload_file", file, file.name);
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/dbcs`,
    method: "post",
    params: {
      name: file.name,
      protocol
    },
    data: formData
  });
}
function updateSingleDBCFile({
  tenant_id,
  upload_file,
  dbc_id,
  name
}, fetchParams) {
  let formData = new FormData();
  formData.append("upload_file", upload_file);
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/dbcs/${dbc_id}`,
    method: "post",
    params: {
      name
    },
    data: formData
  });
}
function deleteSingleDBCFile({
  tenant_id,
  dbc_id,
  force
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/dbcs/${dbc_id}`,
    method: "delete",
    params: {
      force
    }
  });
}
function getSingleDBCFile({
  dbc_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/dbcs/${dbc_id}`,
    method: "get"
  });
}
function getBatchDBCFileList({
  tenant_id,
  name = "",
  page_size = 100,
  current_page = 1
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/dbcs`,
    method: "get",
    params: {
      name,
      page_size,
      current_page
    }
  });
}
function getDBCMessageList({
  tenant_id,
  dbc_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/dbcs/${dbc_id}/dbc_message_configs`,
    method: "get"
  });
}
var DBC = {
  uploadSingleDBCFile,
  updateSingleDBCFile,
  deleteSingleDBCFile,
  getSingleDBCFile,
  getBatchDBCFileList,
  getDBCMessageList
};

exports.RuleItemPaddingType = void 0;

(function (RuleItemPaddingType2) {
  RuleItemPaddingType2[RuleItemPaddingType2["None"] = 0] = "None";
  RuleItemPaddingType2[RuleItemPaddingType2["Left"] = 1] = "Left";
  RuleItemPaddingType2[RuleItemPaddingType2["Right"] = 2] = "Right";
})(exports.RuleItemPaddingType || (exports.RuleItemPaddingType = {}));

exports.RuleItemLenEncoding = void 0;

(function (RuleItemLenEncoding2) {
  RuleItemLenEncoding2[RuleItemLenEncoding2["None"] = 0] = "None";
  RuleItemLenEncoding2[RuleItemLenEncoding2["Big"] = 1] = "Big";
  RuleItemLenEncoding2[RuleItemLenEncoding2["Little"] = 2] = "Little";
  RuleItemLenEncoding2[RuleItemLenEncoding2["ASCII"] = 3] = "ASCII";
})(exports.RuleItemLenEncoding || (exports.RuleItemLenEncoding = {}));

exports.TLVRuleItemValueLenEncoding = void 0;

(function (TLVRuleItemValueLenEncoding2) {
  TLVRuleItemValueLenEncoding2[TLVRuleItemValueLenEncoding2["None"] = 0] = "None";
  TLVRuleItemValueLenEncoding2[TLVRuleItemValueLenEncoding2["Big"] = 1] = "Big";
  TLVRuleItemValueLenEncoding2[TLVRuleItemValueLenEncoding2["Little"] = 2] = "Little";
})(exports.TLVRuleItemValueLenEncoding || (exports.TLVRuleItemValueLenEncoding = {}));

exports.RuleItemFormat = void 0;

(function (RuleItemFormat2) {
  RuleItemFormat2[RuleItemFormat2["Default"] = 0] = "Default";
  RuleItemFormat2[RuleItemFormat2["Shadow"] = 9] = "Shadow";
  RuleItemFormat2[RuleItemFormat2["Dynamic"] = 10] = "Dynamic";
})(exports.RuleItemFormat || (exports.RuleItemFormat = {}));

exports.RuleMappingType = void 0;

(function (RuleMappingType2) {
  RuleMappingType2[RuleMappingType2["parse"] = 1] = "parse";
  RuleMappingType2[RuleMappingType2["build"] = 2] = "build";
})(exports.RuleMappingType || (exports.RuleMappingType = {}));

exports.RuleFormat = void 0;

(function (RuleFormat2) {
  RuleFormat2[RuleFormat2["fix"] = 1] = "fix";
  RuleFormat2[RuleFormat2["delimiter"] = 2] = "delimiter";
  RuleFormat2[RuleFormat2["tlv"] = 3] = "tlv";
  RuleFormat2[RuleFormat2["tv"] = 4] = "tv";
  RuleFormat2[RuleFormat2["JavaScript"] = 5] = "JavaScript";
  RuleFormat2[RuleFormat2["DBC"] = 6] = "DBC";
  RuleFormat2[RuleFormat2["kv"] = 7] = "kv";
  RuleFormat2[RuleFormat2["bit"] = 8] = "bit";
})(exports.RuleFormat || (exports.RuleFormat = {}));

exports.RuleObjectType = void 0;

(function (RuleObjectType2) {
  RuleObjectType2[RuleObjectType2["placeholder"] = 0] = "placeholder";
  RuleObjectType2[RuleObjectType2["entity"] = 1] = "entity";
  RuleObjectType2[RuleObjectType2["status"] = 2] = "status";
  RuleObjectType2[RuleObjectType2["event"] = 3] = "event";
  RuleObjectType2[RuleObjectType2["operation"] = 4] = "operation";
})(exports.RuleObjectType || (exports.RuleObjectType = {}));

exports.RuleTextEncoding = void 0;

(function (RuleTextEncoding2) {
  RuleTextEncoding2[RuleTextEncoding2["none"] = 0] = "none";
  RuleTextEncoding2[RuleTextEncoding2["utf8"] = 1] = "utf8";
  RuleTextEncoding2[RuleTextEncoding2["ascii"] = 2] = "ascii";
  RuleTextEncoding2[RuleTextEncoding2["gb18030"] = 3] = "gb18030";
})(exports.RuleTextEncoding || (exports.RuleTextEncoding = {}));

exports.InfoModelMappingUnwrapProcessType = void 0;

(function (InfoModelMappingUnwrapProcessType2) {
  InfoModelMappingUnwrapProcessType2[InfoModelMappingUnwrapProcessType2["none"] = 0] = "none";
  InfoModelMappingUnwrapProcessType2[InfoModelMappingUnwrapProcessType2["bcd"] = 1] = "bcd";
  InfoModelMappingUnwrapProcessType2[InfoModelMappingUnwrapProcessType2["huffman"] = 2] = "huffman";
  InfoModelMappingUnwrapProcessType2[InfoModelMappingUnwrapProcessType2["gzip"] = 3] = "gzip";
  InfoModelMappingUnwrapProcessType2[InfoModelMappingUnwrapProcessType2["zip"] = 4] = "zip";
})(exports.InfoModelMappingUnwrapProcessType || (exports.InfoModelMappingUnwrapProcessType = {}));

function addInfoModelMappingWithItem({
  tenant_id,
  info_model_id,
  mapping
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/info-models/${info_model_id}/mapping-with-item`,
    method: "post",
    data: mapping
  }, "mapping:info-model-mapping:create");
}
function getSingleInfoModelMapping({
  tenant_id,
  info_model_id,
  load_rule_items = 0
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/info-models/${info_model_id}/mapping`,
    method: "get",
    params: {
      load_rule_items
    }
  }, "mapping:info-model-mapping:query");
}
function updateSingleInfoModelMapping({
  tenant_id,
  info_model_id,
  mapping
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/info-models/${info_model_id}/mapping`,
    method: "post",
    data: mapping
  }, "mapping:info-model-mapping:create");
}
var InfoModelMapping = {
  getSingleInfoModelMapping,
  updateSingleInfoModelMapping,
  addInfoModelMappingWithItem
};

function getSingleEntity({
  entity_id,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/entities/${entity_id}`,
    method: "get"
  });
}
function addSingleEntity({
  tenant_id,
  info
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/entities`,
    method: "post",
    data: info
  });
}
function getBatchEntities({
  tenant_id,
  keyword = "",
  obj_type,
  current_page = 1,
  page_size = 100
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/entities`,
    method: "get",
    params: {
      keyword,
      obj_type,
      current_page,
      page_size
    }
  });
}
function getBatchPublicEntities({
  keyword = "",
  obj_type,
  current_page = 1,
  page_size = 100
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/entities/public`,
    method: "get",
    params: {
      keyword,
      obj_type,
      current_page,
      page_size
    }
  });
}
function getSingleEntityInfo({
  tenant_id,
  entity_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/entities/${entity_id}`,
    method: "get"
  });
}
function updateSingleEntity({
  tenant_id,
  entity_id,
  info
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/entities/${entity_id}`,
    method: "put",
    data: info
  });
}
function deleteSingleEntity({
  tenant_id,
  entity_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/entities/${entity_id}`,
    method: "delete"
  });
}
var IotEntity = {
  getSingleEntity,
  addSingleEntity,
  getBatchEntities,
  getBatchPublicEntities,
  getSingleEntityInfo,
  updateSingleEntity,
  deleteSingleEntity
};

function addImportFunctionBlock({
  tenant_id,
  fn_block_id,
  file,
  event_name = "",
  event_type = "",
  schema_type = ""
}, fetchParams) {
  let formData = new FormData();
  formData.append("file", file, file.name);
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/function-blocks/${tenant_id}/${fn_block_id}/import`,
    method: "post",
    params: {
      event_name,
      event_type,
      schema_type
    },
    data: formData
  });
}
function getExportFunctionBlock({
  tenant_id,
  fn_block_id,
  event_name = "",
  event_type = "",
  schema_type = ""
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/function-blocks/${tenant_id}/${fn_block_id}/export`,
    method: "get",
    responseType: "arraybuffer",
    params: {
      event_name,
      event_type,
      schema_type
    }
  });
}
function addSingleFunctionBlock({
  tenant_id,
  fn_block
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/function-blocks`,
    method: "post",
    data: fn_block
  });
}
function getBatchFunctionBlocks({
  tenant_id,
  current_page = 1,
  name,
  page_size = 20,
  to_public
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/function-blocks`,
    method: "get",
    params: {
      current_page,
      name,
      page_size,
      to_public
    }
  });
}
function getSingleFunctionBlock({
  tenant_id,
  fn_block_id,
  simplify_json_schema = false,
  check_duplicate = true
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/function-blocks/${fn_block_id}`,
    method: "get",
    params: {
      simplify_json_schema,
      check_duplicate
    }
  });
}
function deleteSingleFunctionBlock({
  tenant_id,
  fn_block_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/function-blocks/${fn_block_id}`,
    method: "delete"
  });
}
function updateSingleFunctionBlock({
  tenant_id,
  fn_block_id,
  fn_block
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/function-blocks/${fn_block_id}`,
    method: "put",
    data: fn_block
  });
}
function getBatchFunctionBlockEvent({
  tenant_id,
  fn_block_id,
  event_name,
  event_type,
  identify_values,
  names,
  schema_type,
  property,
  property_value,
  current_page,
  page_size
}) {
  return fetch({
    url: `/mapping-mgmt/tenants/${tenant_id}/function-blocks/${fn_block_id}/schema`,
    method: "get",
    params: {
      event_name,
      event_type,
      identify_values,
      names,
      schema_type,
      property,
      property_value,
      current_page,
      page_size
    }
  });
}
function updateBatchFunctionBlockEvent({
  tenant_id,
  fn_block_id,
  info_model_id,
  event_type,
  identify_values,
  name,
  schema_type,
  body
}) {
  return fetch({
    url: `/mapping-mgmt/tenants/${tenant_id}/function-blocks/${fn_block_id}/schema`,
    method: "put",
    params: {
      info_model_id,
      event_type,
      identify_values,
      name,
      schema_type
    },
    data: body
  });
}
function deleteBatchFunctionBlockEvent({
  tenant_id,
  fn_block_id,
  info_model_id,
  event_type,
  identify_value,
  name,
  schema_type
}) {
  return fetch({
    url: `/mapping-mgmt/tenants/${tenant_id}/function-blocks/${fn_block_id}/schema`,
    method: "delete",
    params: {
      info_model_id,
      event_type,
      identify_value,
      name,
      schema_type
    }
  });
}
function patchBatchFunctionBlockEvent({
  tenant_id,
  fn_block_id,
  info_model_id,
  event_type,
  identify_value_source,
  identify_value_target,
  name,
  schema_type,
  order_type,
  body
}) {
  return fetch({
    url: `/mapping-mgmt/tenants/${tenant_id}/function-blocks/${fn_block_id}/schema`,
    method: "patch",
    params: {
      info_model_id,
      event_type,
      identify_value_source,
      identify_value_target,
      name,
      schema_type,
      order_type
    },
    data: body
  });
}
var IotFunctionBlock = {
  addSingleFunctionBlock,
  getBatchFunctionBlocks,
  getSingleFunctionBlock,
  deleteSingleFunctionBlock,
  updateSingleFunctionBlock,
  addImportFunctionBlock,
  getExportFunctionBlock
};

function getBatchInfoModels({
  category_id,
  current_page,
  keyword,
  page_size
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/info-models`,
    method: "get",
    params: {
      category_id,
      current_page,
      keyword,
      page_size
    }
  });
}
function getBatchTenantInfomodels({
  tenant_id,
  clean_type,
  internal,
  keyword,
  label_id,
  name,
  current_page = 1,
  page_size = 20,
  to_public
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/info-models`,
    method: "get",
    params: {
      clean_type,
      internal,
      keyword,
      label_id,
      current_page,
      page_size,
      name,
      to_public
    }
  });
}
function deleteSingleInfoModel({
  tenant_id,
  info_model_id,
  force
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/info-models/${info_model_id}`,
    method: "delete",
    params: {
      force
    }
  }, "mapping:info-model:delete");
}
function getSingleInfoModel({
  tenant_id,
  info_model_id,
  simplify_json_schema
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/info-models/${info_model_id}`,
    method: "get",
    params: {
      simplify_json_schema
    }
  });
}
function getBatchInfoModelByIds({
  tenant_id,
  info_model_ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/info-models/ids/${info_model_ids}`,
    method: "get"
  });
}
function updateSingleInfoModel({
  tenant_id,
  info_model_id,
  info
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/info-models/${info_model_id}`,
    method: "put",
    data: info
  });
}
function getBatchInfoModelByName({
  names
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/info-models/names/${names}`,
    method: "get"
  });
}
function getBatchInfoModelByNameForTenant({
  tenant_id,
  info_model_names
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/info-models/names/${info_model_names}`,
    method: "get"
  });
}
function getSingleInfoModelPassword({
  tenant_Id,
  info_model_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_Id}/info-models/${info_model_id}/password`,
    method: "get"
  });
}
function getSingleInfoModelInfo({
  info_model_id,
  load_ref,
  simplify_json_schema = false
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/info-models/${info_model_id}`,
    method: "get",
    params: {
      load_ref,
      simplify_json_schema
    }
  });
}
function addSingleInfoModel({
  tenant_id,
  info
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/info-models`,
    method: "post",
    data: info
  });
}
function updateSingleInfoModelPassword({
  tenant_id,
  info_model_id,
  pwd,
  pwd_type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/info-models/${info_model_id}/password`,
    method: "put",
    data: {
      pwd,
      pwd_type
    }
  });
}
function addFunctionBlockAndInfoModel({
  tenant_id,
  category_id,
  dbc_id,
  fn_block_description,
  fn_block_display_name,
  fn_block_json_schema,
  fn_block_name,
  info_model_description,
  info_model_display_name,
  info_model_name,
  internal
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/info-models-creating-for-all`,
    method: "post",
    data: {
      category_id,
      dbc_id,
      fn_block_description,
      fn_block_display_name,
      fn_block_json_schema,
      fn_block_name,
      info_model_description,
      info_model_display_name,
      info_model_name,
      internal
    }
  });
}
function updateFunctionBlockAndInfoModel({
  tenant_id,
  info_model_id,
  category_id,
  dbc_id,
  fn_block_id,
  fn_block_description,
  fn_block_display_name,
  fn_block_name,
  fn_block_json_schema,
  info_model_description,
  info_model_display_name,
  info_model_name,
  internal
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/info-models/${info_model_id}/update-for-all`,
    method: "put",
    data: {
      category_id,
      dbc_id,
      fn_block_id,
      fn_block_description,
      fn_block_name,
      fn_block_display_name,
      fn_block_json_schema,
      info_model_description,
      info_model_display_name,
      info_model_name,
      internal
    }
  });
}
var iotInfoModel = {
  getBatchInfoModels,
  getBatchTenantInfomodels,
  deleteSingleInfoModel,
  getSingleInfoModel,
  getBatchInfoModelByIds,
  updateSingleInfoModel,
  getBatchInfoModelByName,
  getBatchInfoModelByNameForTenant,
  getSingleInfoModelPassword,
  getSingleInfoModelInfo,
  addSingleInfoModel,
  updateSingleInfoModelPassword,
  addFunctionBlockAndInfoModel,
  updateFunctionBlockAndInfoModel
};

function addSingleMappingRuleInfos({
  tenant_id,
  info
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/mapping-rule-infos`,
    method: "post",
    data: info
  }, "mapping:mapping-rule:create");
}
function getSingleMappingRuleInfos({
  tenant_id,
  rule_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/mapping-rule-infos/${rule_id}`,
    method: "get"
  }, "mapping:mapping-rule:query");
}
function getSingleMappingRuleInfosByName({
  tenant_id,
  rule_name
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/mapping-rule-infos/name/${rule_name}`,
    method: "get"
  });
}
function getBatchMappingRuleInfos({
  tenant_id,
  current_page = 1,
  page_size = 20
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/mapping-rule-infos`,
    method: "get",
    params: {
      current_page,
      page_size
    }
  });
}
function updateSingleMappingRuleInfos({
  tenant_id,
  rule_id,
  info
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/mapping-rule-infos/${rule_id}`,
    method: "put",
    data: info
  }, "mapping:mapping-rule:update");
}
function deleteSingleMappingRuleInfos({
  tenant_id,
  rule_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/mapping-mgmt/tenants/${tenant_id}/mapping-rule-infos/${rule_id}`,
    method: "delete"
  }, "mapping:mapping-rule:delete");
}
var MappingRuleInfo = {
  addSingleMappingRuleInfos,
  getSingleMappingRuleInfos,
  getSingleMappingRuleInfosByName,
  getBatchMappingRuleInfos,
  deleteSingleMappingRuleInfos
};

function getBatchMyMessages({
  current_page,
  end_date,
  message_type,
  page_size,
  read_status,
  start_date,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/notification/tenants/${tenant_id}/user/${user_id}/my-messages`,
    method: "get",
    params: {
      current_page,
      end_date,
      message_type,
      page_size,
      read_status,
      start_date
    }
  });
}
function updateBatchMyMessagesReadStatus({
  ids,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/notification/tenants/${tenant_id}/user/${user_id}/read-message/${ids}`,
    method: "put"
  });
}
function updateAllMyMessagesReadStatus({
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/notification/tenants/${tenant_id}/user/${user_id}/my-messages`,
    method: "put"
  });
}
var Message = {
  getBatchMyMessages,
  updateBatchMyMessagesReadStatus,
  updateAllMyMessagesReadStatus
};

function getBatchLog({
  action_id,
  info_mode_id,
  start_date,
  end_date,
  rule_id,
  status,
  tenant_id,
  third_things_id,
  current_page = 1,
  page_size = 10
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/notification/tenants/${tenant_id}/push-log/message`,
    method: "get",
    params: {
      action_id,
      info_mode_id,
      rule_id,
      status,
      third_things_id,
      current_page,
      page_size,
      start_date,
      end_date
    }
  });
}
function deleteBatchLog({
  action_id,
  info_mode_id,
  start_date,
  end_date,
  rule_id,
  status,
  tenant_id,
  third_things_id,
  current_page = 1,
  page_size = 10
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/notification/tenants/${tenant_id}/push-log/message`,
    method: "delete",
    params: {
      action_id,
      info_mode_id,
      rule_id,
      status,
      third_things_id,
      current_page,
      page_size,
      start_date,
      end_date
    }
  });
}
var PushLogs = {
  getBatchLog,
  deleteBatchLog
};

function getBatchSms({
  tenant_id,
  start_date,
  end_date,
  current_page,
  page_size,
  template_code
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/notification/tenants/${tenant_id}/sms`,
    method: "get",
    params: {
      start_date,
      end_date,
      current_page,
      page_size,
      template_code
    }
  });
}
var SMS = {
  getBatchSms
};

function addSingleCoupon({
  count,
  desc,
  discount,
  end_time,
  name,
  start_time,
  tenant_ids,
  threshold,
  type,
  usage
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/sys/coupon`,
    method: "post",
    data: {
      count,
      desc,
      discount,
      end_time,
      name,
      start_time,
      tenant_ids,
      threshold,
      type,
      usage
    }
  });
}
function deleteSingleCoupon({
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/sys/coupon`,
    method: "delete",
    params: {
      id
    }
  });
}
function getBatchCoupons({
  current_page,
  page_size
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/sys/coupon`,
    method: "get",
    params: {
      current_page,
      page_size
    }
  });
}
var CouponSys = {
  addSingleCoupon,
  deleteSingleCoupon,
  getBatchCoupons
};

function getBatchTenantCoupons({
  current_page,
  page_size,
  tenant_id,
  usage
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/tenants/${tenant_id}/coupon`,
    method: "get",
    params: {
      current_page,
      page_size,
      usage
    }
  });
}
function getBatchCanReceiveCoupons({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/tenants/${tenant_id}/couponSys`,
    method: "get"
  });
}
function addSingleTenantCoupons({
  tenant_id,
  coupon_sys_ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/tenants/${tenant_id}/coupon`,
    method: "post",
    params: {
      couponSysIds: coupon_sys_ids
    }
  });
}
var CouponTenant = {
  getBatchTenantCoupons,
  getBatchCanReceiveCoupons,
  addSingleTenantCoupons
};

function getBatchOrdersAdmin({
  current_page,
  page_size,
  end_date,
  start_date,
  state,
  tenant_ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/order`,
    method: "get",
    params: {
      current_page,
      page_size,
      end_date,
      start_date,
      state,
      tenant_ids
    }
  });
}
function refundSingleOrder({
  tenant_id,
  order_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/tenants/${tenant_id}/order/${order_id}/refund`,
    method: "post"
  });
}
function getBatchOrdersCloud({
  current_page,
  page_size,
  tenant_id,
  state,
  end_date,
  start_date,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/tenants/${tenant_id}/order`,
    method: "get",
    params: {
      current_page,
      page_size,
      state,
      end_date,
      start_date,
      type
    }
  });
}
function addSingleOrder({
  tenant_id,
  coupon_id,
  duration,
  pattern,
  pay_type,
  to_package_content,
  type,
  from_package_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/tenants/${tenant_id}/order`,
    method: "post",
    data: {
      coupon_id,
      duration,
      pattern,
      pay_type,
      to_package_content,
      type,
      from_package_id
    }
  });
}
function getSingleOrderAmount({
  tenant_id,
  from_package_id,
  duration,
  pattern,
  type,
  api_package_content
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/tenants/${tenant_id}/order/amount?duration=${duration}&pattern=${pattern}&type=${type}&from_package_id=${from_package_id}`,
    method: "post",
    data: api_package_content
  });
}
function paySingleOrder({
  tenant_id,
  order_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/tenants/${tenant_id}/order/${order_id}/pay`,
    method: "post"
  });
}
function cancelSingleOrder({
  tenant_id,
  order_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/tenants/${tenant_id}/order/${order_id}/cancel`,
    method: "delete"
  });
}
function addSingleReceipt({
  tenant_id,
  order_id,
  file
}, fetchParams) {
  let formData = new FormData();
  formData.append("file", file);
  return fetch({ ...fetchParams,
    url: `/out-billing/tenants/${tenant_id}/order/${order_id}/uploadReceipt`,
    method: "post",
    data: formData
  });
}
var Order = {
  getBatchOrdersAdmin,
  refundSingleOrder,
  getBatchOrdersCloud,
  addSingleOrder,
  getSingleOrderAmount,
  paySingleOrder,
  cancelSingleOrder,
  addSingleReceipt
};

function getBatchPackagesAdmin({
  current_page,
  page_size,
  tenant_id,
  type,
  base,
  state
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/packages`,
    method: "get",
    params: {
      current_page,
      page_size,
      tenant_id,
      type,
      base,
      state
    }
  });
}
function getSinglePackageTenant({
  tenant_id,
  type,
  package_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/tenants/${tenant_id}/package`,
    method: "get",
    params: {
      type,
      packageId: package_id
    }
  });
}
function getBatchPackagesCloud({
  current_page,
  page_size,
  tenant_id,
  type,
  base,
  state
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/tenants/${tenant_id}/packages`,
    method: "get",
    params: {
      current_page,
      page_size,
      type,
      base,
      state
    }
  });
}
function getSingleUsageStatistics(fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/all/usage-statistics`,
    method: "get"
  });
}
var Package = {
  getBatchPackagesAdmin,
  getSinglePackageTenant,
  getBatchPackagesCloud,
  getSingleUsageStatistics
};

function getBatchPackageItem({
  current_page,
  page_size,
  platform,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/content/item`,
    method: "get",
    params: {
      current_page,
      page_size,
      platform,
      type
    }
  });
}
function addSinglePackageContentItem({
  apiBasePackageItem
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/content/item`,
    method: "post",
    data: {
      apiBasePackageItem
    }
  });
}
function updateSinglePackageContentItem({
  apiBasePackageItem,
  item_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/content/item/${item_id}`,
    method: "put",
    data: {
      apiBasePackageItem
    }
  });
}
function deleteSinglePackageContentItem({
  item_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/content/item/${item_id}`,
    method: "delete"
  });
}
var PackageItem = {
  getBatchPackageItem,
  addSinglePackageContentItem,
  updateSinglePackageContentItem,
  deleteSinglePackageContentItem
};

function getbBatchStageDiscount({
  current_page,
  page_size
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/out-billing/stage-dicount",
    method: "get",
    params: {
      current_page,
      page_size
    }
  });
}
var StageDiscount = {
  getbBatchStageDiscount
};

function getSingleAssessDeploy({
  database_storage_space,
  number_simultaneous_connections,
  things_num,
  up_down_stream_connections
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/tools/assessDeploy`,
    method: "post",
    data: {
      database_storage_space,
      number_simultaneous_connections,
      things_num,
      up_down_stream_connections
    }
  });
}
function getSingleAssessTps({
  msg_interval,
  msg_size,
  things_num
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-billing/tools/assessTps`,
    method: "post",
    data: {
      msg_interval,
      msg_size,
      things_num
    }
  });
}
var Tools = {
  getSingleAssessDeploy,
  getSingleAssessTps
};

function getBatchComponentConfig({
  category_first,
  component_name,
  current_page,
  is_show,
  page_size,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-filemanager/tenants/${tenant_id}/component/config`,
    method: "get",
    params: {
      category_first,
      component_name,
      current_page,
      is_show,
      page_size
    }
  });
}
function addComponentConfig({
  tenantId,
  category_first,
  category_second,
  component_name,
  icon_url,
  identifier,
  is_show,
  resource_tenant_id,
  resource_group,
  resource_project
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-filemanager/component/config`,
    method: "post",
    params: {
      tenantId
    },
    data: {
      category_first,
      category_second,
      component_name,
      icon_url,
      identifier,
      is_show,
      resource_tenant_id,
      resource_group,
      resource_project
    }
  });
}
function getSingleComponentConfig({
  tenantId,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-filemanager/component/config/${id}`,
    method: "get",
    params: {
      tenantId
    }
  });
}
function updateComponentConfig({
  id,
  tenantId,
  category_first,
  category_second,
  component_name,
  icon_url,
  identifier,
  is_show,
  resource_tenant_id,
  resource_group,
  resource_project
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-filemanager/component/config/${id}`,
    method: "put",
    params: {
      tenantId
    },
    data: {
      category_first,
      category_second,
      component_name,
      icon_url,
      identifier,
      is_show,
      resource_tenant_id,
      resource_group,
      resource_project
    }
  });
}
function deleteComponentConfig({
  id,
  tenantId
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-filemanager/component/config/${id}`,
    params: {
      tenantId
    },
    method: "delete"
  });
}
function getComponentConfigAggregation({
  tenantId,
  category_first
}) {
  return fetch({
    url: `/out-filemanager/component/config/aggregation`,
    method: "get",
    params: {
      category_first,
      tenantId
    }
  });
}
function updateComponentConfigMove({
  id,
  source_index,
  target_category_second,
  target_index,
  tenantId
}) {
  return fetch({
    url: `/out-filemanager/component/config/move`,
    method: "put",
    params: {
      id,
      source_index,
      target_category_second,
      target_index,
      tenantId
    }
  });
}
function getComponentConfigOrder({
  tenantId,
  category_first,
  category_second
}) {
  return fetch({
    url: `/out-filemanager/component/config/order`,
    method: "get",
    params: {
      category_first,
      category_second,
      tenantId
    }
  });
}
function getBatchComponentByAdmin({
  tenantId,
  current_page,
  group,
  identify,
  is_public,
  last_version,
  page_size,
  project,
  version
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-filemanager/tenants/component`,
    method: "get",
    params: {
      current_page,
      group,
      identify,
      is_public,
      page_size,
      project,
      version,
      tenantId,
      last_version
    }
  });
}
function deleteBatchComponentByAdmin({
  tenantId,
  ids
}) {
  return fetch({
    url: `/out-filemanager/tenants/component/ids/${ids}`,
    method: "delete",
    params: {
      tenantId
    }
  });
}
var Component = {
  getBatchComponentConfig,
  addComponentConfig,
  getSingleComponentConfig,
  updateComponentConfig,
  deleteComponentConfig,
  getComponentConfigAggregation,
  updateComponentConfigMove,
  getComponentConfigOrder,
  getBatchComponentByAdmin,
  deleteBatchComponentByAdmin
};

function deviceUploadPart({
  file,
  curPart,
  jwt,
  name,
  tenant_id,
  things_id,
  totalPartNumber
}, fetchParams) {
  let formData = new FormData();
  formData.append("file", file, file.name);
  return fetch({ ...fetchParams,
    url: `/out-filemanager/deviceUploadPart`,
    method: "post",
    params: {
      curPart,
      jwt,
      name,
      tenant_id,
      things_id,
      totalPartNumber
    },
    data: formData
  });
}
function getFiles({
  isPub,
  name,
  tenantId,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-filemanager/tenants/${tenantId}/files`,
    method: "get",
    params: {
      isPub,
      name,
      type
    }
  });
}
function deleteFiles({
  isPub,
  name,
  tenantId,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-filemanager/tenants/${tenantId}/files`,
    method: "delete",
    params: {
      isPub,
      name,
      type
    }
  });
}
function cleanFiles({
  deadline,
  isPub,
  tenantId,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-filemanager/tenants/${tenantId}/files/clean`,
    method: "delete",
    params: {
      deadline,
      isPub,
      type
    }
  });
}
function downloadFile({
  filenames,
  isPub,
  tenantId,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-filemanager/tenants/${tenantId}/files/download`,
    method: "get",
    params: {
      filenames,
      isPub,
      type
    }
  });
}
function getFileList({
  begin_time,
  current_page,
  end_time,
  isDone,
  isPub,
  name,
  page_size,
  tenantId,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-filemanager/tenants/${tenantId}/files/list`,
    method: "get",
    params: {
      begin_time,
      current_page,
      end_time,
      isDone,
      isPub,
      name,
      page_size,
      type
    }
  });
}
function uploadFile({
  file,
  is_pub,
  tenant_id,
  type
}, fetchParams) {
  let formData = new FormData();
  formData.append("file", file, file.name);
  return fetch({ ...fetchParams,
    url: `/out-filemanager/tenants/${tenant_id}/upload`,
    method: "post",
    params: {
      isPub: is_pub,
      type
    },
    data: formData
  }, "out-file-manager:file-manager:upload");
}
function uploadPart({
  file,
  curPart,
  isPub,
  name,
  tenantId,
  totalPartNumber,
  type
}, fetchParams) {
  let formData = new FormData();
  formData.append("file", file, file.name);
  return fetch({ ...fetchParams,
    url: `/out-filemanager/tenants/${tenantId}/uploadPart`,
    method: "post",
    params: {
      curPart,
      isPub,
      name,
      totalPartNumber,
      type
    },
    data: formData
  });
}
var File = {
  deviceUploadPart,
  getFiles,
  deleteFiles,
  cleanFiles,
  downloadFile,
  getFileList,
  uploadFile,
  uploadPart
};

function getPackageInfo({
  pkgtype,
  suffix,
  tenant_id,
  version
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-filemanager/tenants/${tenant_id}/package/${pkgtype}/info`,
    method: "get",
    params: {
      suffix,
      version
    }
  }, "filemanager:package:query");
}
function deletePackage({
  pkgtype,
  suffix,
  tenant_id,
  version
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-filemanager/tenants/${tenant_id}/package/${pkgtype}/remove`,
    method: "delete",
    params: {
      suffix,
      version
    }
  }, "filemanager:package:delete");
}
function uploadPackage({
  file,
  version,
  desc,
  pkgtype,
  tenant_id
}, fetchParams) {
  let formData = new FormData();
  formData.append("file", file, file.name);
  version && formData.append("version", version);
  desc && formData.append("desc", desc);
  return fetch({ ...fetchParams,
    url: `/out-filemanager/tenants/${tenant_id}/package/${pkgtype}/upload`,
    method: "post",
    data: formData
  }, "filemanager:package:upload");
}
function getAllPackages({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-filemanager/tenants/${tenant_id}/package/allPackages`,
    method: "get"
  }, "filemanager:package:query");
}
function getLastPackage({
  pkgtype,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-filemanager/tenants/${tenant_id}/package/lastPackage`,
    method: "get",
    params: {
      pkgtype
    }
  }, "filemanager:package:query");
}
var FileManagerPackage = {
  getPackageInfo,
  deletePackage,
  uploadPackage,
  getAllPackages,
  getLastPackage
};

function getDataLogs({
  begin_time,
  current_page,
  end_time,
  page_size,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-filemanager/datalogs`,
    method: "get",
    params: {
      begin_time,
      current_page,
      end_time,
      page_size,
      tenant_id
    }
  });
}
function deleteDataLogs({
  time
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-filemanager/datalogs`,
    method: "delete",
    params: {
      time
    }
  });
}
function getPlans({
  begin_expiry,
  current_page,
  end_expiry,
  page_size,
  status,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-filemanager/plans`,
    method: "get",
    params: {
      begin_expiry,
      current_page,
      end_expiry,
      page_size,
      status,
      tenant_id
    }
  });
}
function addPlans({
  expiry,
  plan_id,
  size,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-filemanager/plans`,
    method: "post",
    params: {
      expiry,
      plan_id,
      size,
      tenant_id
    }
  });
}
function deletePlans({
  plan_id,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-filemanager/plans`,
    method: "delete",
    params: {
      plan_id,
      tenant_id
    }
  });
}
var Plan = {
  getDataLogs,
  deleteDataLogs,
  getPlans,
  addPlans,
  deletePlans
};

function getDownloadUrl(getDownloadUrlReq, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/out-firmware-mgmt/download/url",
    method: "get",
    params: getDownloadUrlReq
  }, "firmware:firmware:query");
}
var Download = {
  getDownloadUrl
};

function getBatchFirmwares({
  tenant_id,
  model_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-firmware-mgmt/tenants/${tenant_id}/firmwares`,
    method: "get",
    params: {
      model_id
    }
  }, "firmware:firmware:query");
}
function addSingleFirmware({
  tenant_id,
  file,
  version,
  version_num,
  model_id,
  firmware_type,
  to_public,
  desc,
  sub_dev_id
}, fetchParams) {
  let formData = new FormData();
  formData.append("file", file, file.name);
  formData.append("version_num", version_num);
  formData.append("model_id", model_id);
  formData.append("version", version);
  formData.append("firmware_type", firmware_type);
  formData.append("to_public", to_public);
  formData.append("desc", desc);
  sub_dev_id && formData.append("sub_dev_id", sub_dev_id.toString());
  return fetch({ ...fetchParams,
    url: `/out-firmware-mgmt/tenants/${tenant_id}/firmwares`,
    method: "post",
    data: formData
  });
}
function deleteSingleFirmware({
  tenant_id,
  firmware_id,
  model_id,
  version,
  sub_dev_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-firmware-mgmt/tenants/${tenant_id}/firmwares`,
    method: "delete",
    params: {
      firmware_id,
      model_id,
      version,
      sub_dev_id
    }
  });
}
function updateSingleFirmwareToPublic({
  firmware_id,
  tenant_id,
  toPublic
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-firmware-mgmt/tenants/${tenant_id}/firmwares/${firmware_id}/${toPublic}`,
    method: "put"
  });
}
function getSingleFirmwareDescription({
  model_id,
  tenant_id,
  version,
  sub_dev_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-firmware-mgmt/tenants/${tenant_id}/firmwares/${model_id}/${version}/description`,
    method: "get",
    params: {
      sub_dev_id
    }
  });
}
function updateSingleFirmwareVersionByNotify({
  author_id,
  dev_id,
  gw_id,
  is_diff,
  label_id,
  label_value,
  sw_id,
  thing_type,
  upgrade_type,
  version_num,
  version,
  tenant_id,
  model_id,
  sub_dev_id,
  opt
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-firmware-mgmt/tenants/${tenant_id}/firmwares/${model_id}/${version}/notify`,
    method: "post",
    data: {
      author_id,
      dev_id,
      gw_id,
      is_diff,
      label_id,
      label_value,
      sw_id,
      thing_type,
      upgrade_type,
      version_num,
      sub_dev_id,
      opt
    }
  });
}
function getSingleNewFirmwareInfo({
  model_id,
  tenant_id,
  sub_dev_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-firmware-mgmt/tenants/${tenant_id}/firmwares/newest-firmware`,
    params: {
      model_id,
      sub_dev_id
    },
    method: "get"
  });
}
var Firmware = {
  getBatchFirmwares,
  addSingleFirmware,
  deleteSingleFirmware,
  updateSingleFirmwareToPublic,
  getSingleFirmwareDescription,
  updateSingleFirmwareVersionByNotify,
  getSingleNewFirmwareInfo
};

function addBatchDevicesBindToGroup({
  tenant_id,
  user_id,
  group_id,
  device_ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenants/${tenant_id}/users/${user_id}/groups/${group_id}/bind`,
    method: "put",
    data: device_ids
  }, "group:device:bind");
}
function issueGroupDeviceCommand({
  tenant_id,
  user_id,
  group_id,
  description,
  payload
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenants/${tenant_id}/users/${user_id}/groups/${group_id}/command`,
    method: "post",
    data: {
      description,
      payload
    }
  }, "group:device:command");
}
function getBatchGroupBindDevices({
  tenant_id,
  user_id,
  group_id,
  current_page,
  page_size = 100,
  ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenants/${tenant_id}/users/${user_id}/groups/${group_id}/devices`,
    method: "get",
    params: {
      current_page,
      page_size,
      ids
    }
  });
}
function deleteBatchDevicesOfGroup({
  tenant_id,
  user_id,
  group_id,
  dev_ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenants/${tenant_id}/users/${user_id}/groups/${group_id}/unbind`,
    method: "put",
    data: dev_ids
  }, "group:device:unbind");
}
var Device = {
  addBatchDevicesBindToGroup,
  issueGroupDeviceCommand,
  getBatchGroupBindDevices,
  deleteBatchDevicesOfGroup
};

function getBatchGroupList({
  tenant_id,
  user_id,
  current_page,
  info_model_id,
  name,
  name_like,
  page_size,
  parent_id
}, fetchParams) {
  if (!page_size) {
    page_size = 100;
  }

  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenants/${tenant_id}/users/${user_id}/groups`,
    method: "get",
    params: {
      current_page,
      info_model_id,
      name,
      name_like,
      page_size,
      parent_id
    }
  }, "group:group:query");
}
function addSingleGroup({
  tenant_id,
  user_id,
  info_model_id,
  name,
  parent_id,
  ext_info
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenants/${tenant_id}/users/${user_id}/groups`,
    method: "post",
    data: {
      info_model_id,
      name,
      parent_id,
      ext_info
    }
  }, "group:group:create");
}
function getSingleGroupDetails({
  tenant_id,
  user_id,
  group_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenants/${tenant_id}/users/${user_id}/groups/${group_id}`,
    method: "get"
  });
}
function updateSingleGroup({
  tenant_id,
  user_id,
  group_id,
  name,
  ext_info
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenants/${tenant_id}/users/${user_id}/groups/${group_id}`,
    method: "put",
    data: {
      name,
      ext_info
    }
  }, "group:group:update");
}
function deleteBatchGroups({
  tenant_id,
  user_id,
  group_ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenants/${tenant_id}/users/${user_id}/groups/${group_ids}`,
    method: "delete"
  }, "group:group:delete");
}
function getBatchGroupListByIds({
  device_ids,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenants/${tenant_id}/users/${user_id}/groups/device-ids/${device_ids}`,
    method: "get"
  });
}
function getBatchGroupsByGroupIds({
  tenant_id,
  user_id,
  group_ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenants/${tenant_id}/users/${user_id}/groups/ids/${group_ids}`,
    method: "get"
  });
}
function getBatchGroupOrderedListByIds({
  tenant_id,
  user_id,
  device_ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenants/${tenant_id}/users/${user_id}/groups/device-ids-ordered/${device_ids}`,
    method: "get"
  });
}
var Group = {
  getBatchGroupList,
  addSingleGroup,
  getSingleGroupDetails,
  updateSingleGroup,
  deleteBatchGroups,
  getBatchGroupListByIds,
  getBatchGroupOrderedListByIds,
  getBatchGroupsByGroupIds
};

function getBatchGroupPlusList({
  current_page,
  ext_info,
  info_model_id,
  is_collect,
  name,
  name_like,
  order_by,
  page_size,
  parent_id,
  tenant_id,
  things_state,
  online_state,
  warning_state,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenants/${tenant_id}/users/${user_id}/group-plus`,
    method: "get",
    params: {
      current_page,
      ext_info,
      info_model_id,
      is_collect,
      name,
      name_like,
      order_by,
      page_size,
      parent_id,
      things_state,
      online_state,
      warning_state
    }
  });
}
function getSingleGroupPlus({
  group_id,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenants/${tenant_id}/users/${user_id}/group-plus/${group_id}`,
    method: "get"
  });
}
function getBatchGroupOnlineStatusPlus({
  info_model_id,
  tenant_id,
  user_id,
  parent_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenants/${tenant_id}/users/${user_id}/group-plus-online`,
    method: "get",
    params: {
      info_model_id,
      parent_id
    }
  });
}
function updateSingleGroupStatusPlus({
  tenant_id,
  user_id,
  group_id,
  is_debug
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenants/${tenant_id}/users/${user_id}/group-plus/status/${group_id}`,
    method: "put",
    params: {
      is_debug
    }
  });
}
var GroupPlus = {
  getBatchGroupPlusList,
  getSingleGroupPlus,
  getBatchGroupOnlineStatusPlus,
  updateSingleGroupStatusPlus
};

function getBatchGroupPrices({
  current_page,
  type,
  page_size,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenant/${tenant_id}/user/${user_id}/group-price`,
    method: "get",
    params: {
      current_page,
      page_size,
      type
    }
  });
}
function addSingleGroupPrice({
  name,
  remark,
  type,
  config,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenant/${tenant_id}/user/${user_id}/group-price`,
    method: "post",
    data: {
      name,
      remark,
      type,
      config
    }
  });
}
function updateSingleGroupPrice({
  id,
  remark,
  name,
  type,
  config,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenant/${tenant_id}/user/${user_id}/group-price/${id}`,
    method: "put",
    data: {
      name,
      type,
      remark,
      config
    }
  });
}
function getSingleGroupPrice({
  tenant_id,
  user_id,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenant/${tenant_id}/user/${user_id}/group-price/${id}`,
    method: "get"
  });
}
function deleteSingleGroupPrice({
  id,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenant/${tenant_id}/user/${user_id}/group-price/${id}`,
    method: "delete"
  });
}
var GroupPrice = {
  getBatchGroupPrices,
  addSingleGroupPrice,
  updateSingleGroupPrice,
  getSingleGroupPrice,
  deleteSingleGroupPrice
};

function getBatchGroupDeviceStatisticsDatas({
  agg_fun,
  end_time,
  property,
  start_time,
  tenant_id,
  top_number,
  user_id,
  info_model_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/statistics/${tenant_id}/users/${user_id}/data`,
    method: "get",
    params: {
      agg_fun,
      end_time,
      property,
      start_time,
      top_number,
      info_model_id
    }
  });
}
function getSingleGroupFieldData({
  agg_fun,
  property,
  tenant_id,
  user_id,
  info_model_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/statistics/${tenant_id}/users/${user_id}/field`,
    method: "get",
    params: {
      agg_fun,
      property,
      info_model_id
    }
  });
}
var GroupStatistics = {
  getBatchGroupDeviceStatisticsDatas,
  getSingleGroupFieldData
};

function getSingleGroupStrategys({
  tenant_id,
  user_id,
  group_id,
  things_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenant/${tenant_id}/user/${user_id}/group-strategy/${group_id}`,
    method: "get",
    params: {
      things_id
    }
  });
}
function addSingleGroupStrategy({
  config,
  group_id,
  things_id,
  remark,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenant/${tenant_id}/user/${user_id}/group-strategy`,
    method: "post",
    data: {
      config,
      group_id,
      things_id,
      remark
    }
  });
}
function updateSingleGroupStrategy({
  id,
  config,
  remark,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/tenant/${tenant_id}/user/${user_id}/group-strategy/strategy/${id}`,
    method: "put",
    data: {
      remark,
      config
    }
  });
}
var GroupStrategy = {
  getSingleGroupStrategys,
  addSingleGroupStrategy,
  updateSingleGroupStrategy
};

function addSingleGroupCollect({
  group_id,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/resource/${tenant_id}/users/${user_id}/${group_id}/collect`,
    method: "put"
  });
}
function deleteSingleGroupCollect({
  group_id,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/resource/${tenant_id}/users/${user_id}/${group_id}/collect`,
    method: "delete"
  });
}
function getBatchBindGroupIds({
  include_create,
  is_manager,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/resource/${tenant_id}/users/${user_id}/group`,
    method: "get",
    params: {
      include_create,
      is_manager
    }
  });
}
function updateBatchBindGroupIds({
  tenant_id,
  user_id,
  auth_info,
  group_id_list,
  sub_user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/resource/${tenant_id}/users/${user_id}/group`,
    method: "put",
    data: {
      auth_info,
      group_id_list,
      user_id: sub_user_id
    }
  });
}
function getBatchUsersByGroupId({
  current_page,
  group_id,
  page_size,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/resource/${tenant_id}/group/${group_id}/users`,
    method: "get",
    params: {
      current_page,
      page_size
    }
  });
}
function updateSingleUserGroupAuth({
  distribute,
  edit,
  visible,
  group_id,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/resource/${tenant_id}/user/${user_id}/group/${group_id}/auth`,
    method: "put",
    data: {
      distribute,
      edit,
      visible
    }
  });
}
function deleteSingleUserFromGroup({
  group_id,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/resource/${tenant_id}/user/${user_id}/group/${group_id}/unbind`,
    method: "delete"
  });
}
function getBatchUnbindGroupUsers({
  current_page,
  group_ids,
  mobile,
  name,
  page_size,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/resource/${tenant_id}/users`,
    method: "get",
    params: {
      current_page,
      group_ids,
      mobile,
      name,
      page_size
    }
  });
}
function addBatchUsersBindBatchGroups({
  auth_info,
  group_id_list,
  user_id_list,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-group-mgmt/resource/${tenant_id}/users/${user_id}/group`,
    method: "post",
    data: {
      auth_info,
      group_id_list,
      user_id_list
    }
  });
}
var GroupUserResource = {
  addSingleGroupCollect,
  deleteSingleGroupCollect,
  getBatchBindGroupIds,
  updateBatchBindGroupIds,
  getBatchUsersByGroupId,
  updateSingleUserGroupAuth,
  deleteSingleUserFromGroup,
  getBatchUnbindGroupUsers,
  addBatchUsersBindBatchGroups
};

function getBatchHmisByAdmin({
  current_page,
  desc,
  desc_like,
  index,
  name,
  name_like,
  need_auth,
  page_size,
  tenantId,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/out-hmi/hmis",
    method: "get",
    params: {
      current_page,
      desc,
      desc_like,
      index,
      name,
      name_like,
      need_auth,
      page_size,
      tenantId,
      user_id
    }
  });
}
function getBatchHmis({
  current_page,
  page_size,
  desc,
  desc_like,
  index,
  name,
  name_like,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-hmi/tenants/${tenant_id}/users/${user_id}/hmis`,
    method: "get",
    params: {
      current_page,
      page_size,
      desc,
      desc_like,
      index,
      name,
      name_like
    }
  });
}
function createSingleHmis({
  tenant_id,
  user_id,
  body
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-hmi/tenants/${tenant_id}/users/${user_id}/hmis`,
    method: "post",
    data: body
  });
}
var Hmi = {
  getBatchHmis,
  createSingleHmis,
  getBatchHmisByAdmin
};

function getUserHmiResourceTree({
  tenant_id,
  user_id,
  self
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-hmi/tenants/${tenant_id}/users/${user_id}/resource-tree`,
    method: "get",
    params: {
      self
    }
  }, "out-hmi:user:query");
}
function getBindHmis({
  tenant_id,
  user_id,
  kind
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-hmi/tenants/${tenant_id}/users/${user_id}/resource`,
    method: "get",
    params: {
      kind
    }
  }, "out-hmi:user:query");
}
function updateBindHmis({
  tenant_id,
  user_id,
  ids,
  kind
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-hmi/tenants/${tenant_id}/users/${user_id}/resource?kind=${kind}`,
    method: "PUT",
    data: ids
  }, "out-hmi:user:update");
}
var HmiUserResource = {
  getUserHmiResourceTree,
  getBindHmis,
  updateBindHmis
};

function getBatchHmisWebByAdmin({
  hmiId,
  tenantId,
  userId,
  current_page,
  desc,
  desc_like,
  ids,
  index,
  is_all_tenant,
  is_public,
  name,
  name_like,
  nodata,
  page_size,
  status,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-hmi/hmis/${hmiId}/web`,
    method: "get",
    params: {
      tenantId,
      userId,
      current_page,
      desc,
      desc_like,
      ids,
      index,
      is_all_tenant,
      is_public,
      name,
      name_like,
      nodata,
      page_size,
      status,
      type
    }
  });
}
function getBatchHmisWeb({
  hmiId,
  tenantId,
  userId,
  current_page,
  desc,
  desc_like,
  index,
  is_all_tenant,
  is_public,
  name,
  name_like,
  nodata,
  page_size,
  type
}) {
  return fetch({
    url: `/out-hmi/tenants/${tenantId}/users/${userId}/hmis/${hmiId}/web`,
    method: "get",
    params: {
      current_page,
      desc,
      desc_like,
      index,
      is_all_tenant,
      is_public,
      name,
      name_like,
      nodata,
      page_size,
      type
    }
  });
}
function getBatchHmisWebRelease({
  hmiId,
  tenantId,
  userId,
  webId
}) {
  return fetch({
    url: `out-hmi/tenants/${tenantId}/users/${userId}/hmis/${hmiId}/web/${webId}/release`,
    method: "get"
  });
}
var Web = {
  getBatchHmisWeb,
  getBatchHmisWebRelease
};

function getBatchProject({
  current_page,
  name,
  page_size,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-project/tenants/${tenant_id}/project`,
    method: "get",
    params: {
      current_page,
      name,
      page_size
    }
  }, "project:project:query");
}
function getSingleProject({
  tenant_id,
  project_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-project/tenants/${tenant_id}/project/${project_id}`,
    method: "get"
  });
}
function addSingleProject({
  tenant_id,
  name,
  desc
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-project/tenants/${tenant_id}/project`,
    method: "post",
    data: {
      name,
      desc
    }
  }, "project:project:create");
}
function deleteSingleProjectById({
  tenant_id,
  project_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-project/tenants/${tenant_id}/project/${project_id}`,
    method: "delete"
  }, "project:project:delete");
}
function updateSingleProject({
  tenant_id,
  project_id,
  name,
  desc
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-project/tenants/${tenant_id}/project/${project_id}`,
    method: "put",
    data: {
      name,
      desc
    }
  }, "project:project:update");
}
var Project = {
  getBatchProject,
  getSingleProject,
  addSingleProject,
  deleteSingleProjectById,
  updateSingleProject
};

function relatedSingleProjectResource({
  tenant_id,
  body
}, fetchParams) {
  const data = {
    projectId: body.project_id,
    resourceId: body.resource_id,
    resourceType: body.resource_type
  };
  return fetch({ ...fetchParams,
    url: `/out-project/tenants/${tenant_id}/projectResource`,
    method: "post",
    data
  }, "project:project-resource:update");
}
function relatedBatchProjectResources({
  tenant_id,
  body
}, fetchParams) {
  const data = body.map(item => {
    return {
      projectId: item.project_id,
      resourceId: item.resource_id,
      resourceType: item.resource_type
    };
  });
  return fetch({ ...fetchParams,
    url: `/out-project/tenants/${tenant_id}/projectResource/batch`,
    method: "post",
    data
  }, "project:project-resource:update");
}
function updateProjectResourcesRelation({
  tenant_id,
  project_id,
  resource_ids,
  resource_type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-project/tenants/${tenant_id}/projectResource/batch`,
    method: "put",
    data: {
      projectId: project_id,
      resourceIds: resource_ids,
      resourceType: resource_type
    }
  }, "project:project-resource:update");
}
function getSingleProjectResources({
  tenant_id,
  current_page,
  page_size,
  project_id,
  resource_id,
  resource_type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-project/tenants/${tenant_id}/projectResource`,
    method: "get",
    params: {
      current_page,
      page_size,
      projectId: project_id,
      resourceId: resource_id,
      resourceType: resource_type
    }
  }, "project:project-resource:query");
}
function getBatchProjectResources({
  tenant_id,
  current_page,
  page_size,
  resource_ids,
  project_ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-project/tenants/${tenant_id}/projectResource/batch`,
    method: "get",
    params: {
      current_page,
      page_size,
      resourceIds: resource_ids,
      projectIds: project_ids
    }
  }, "project:project-resource:query");
}
function deleteProjectResourcesRelation({
  tenant_id,
  project_id,
  resource_ids,
  resource_type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-project/tenants/${tenant_id}/projectResource`,
    method: "delete",
    params: {
      projectId: project_id,
      resourceIds: resource_ids,
      resourceType: resource_type
    }
  }, "project:project-resource:update");
}
var ProjectResource = {
  relatedSingleProjectResource,
  relatedBatchProjectResources,
  updateProjectResourcesRelation,
  getSingleProjectResources,
  getBatchProjectResources,
  deleteProjectResourcesRelation
};

function getConfigInfo({
  resource_path,
  is_debug
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-web/deploy/config/info`,
    method: "get",
    params: {
      resourcePath: resource_path,
      isDebug: is_debug
    }
  });
}
function updateConfigInfo({
  resource_path,
  is_debug,
  cloudname,
  login_logo,
  homepage_logo,
  menu,
  register_logo,
  link
}, fetchParams) {
  let formData = new FormData();
  login_logo && formData.append("loginLogo", login_logo, login_logo.name);
  homepage_logo && formData.append("homepageLogo", homepage_logo, homepage_logo.name);
  menu && formData.append("menu", menu);
  register_logo && formData.append("registerLogo", register_logo, register_logo.name);
  cloudname && formData.append("cloudname", cloudname);
  link && formData.append("link", link);
  return fetch({ ...fetchParams,
    url: `/out-web/deploy/config/save`,
    method: "post",
    data: formData,
    params: {
      resourcePath: resource_path,
      isDebug: is_debug
    }
  });
}
var Config = {
  getConfigInfo,
  updateConfigInfo
};

function getWebInfo({
  resource_path,
  version
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-web/deploy/web/info`,
    method: "get",
    params: {
      resourcePath: resource_path,
      version
    }
  });
}
function getWebList({
  is_debug,
  resourcePath,
  currentPage,
  pageSize
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-web/deploy/web/list`,
    method: "get",
    params: {
      isDebug: is_debug,
      resourcePath,
      currentPage,
      pageSize
    }
  });
}
function issueWebInfo({
  resource_path,
  version
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-web/deploy/web/release`,
    method: "post",
    params: {
      resourcePath: resource_path,
      version
    }
  });
}
function updateWebInfo({
  is_debug,
  resourcefile,
  resource_path,
  version,
  remark
}, fetchParams) {
  let formData = new FormData();
  formData.append("isDebug", is_debug.toString());
  formData.append("resourcefile", resourcefile, resourcefile.name);
  formData.append("resourcePath", resource_path);
  formData.append("version", version);
  remark && formData.append("remark", remark);
  return fetch({ ...fetchParams,
    url: `/out-web/deploy/web/save`,
    method: "post",
    data: formData
  });
}
function deleteWebInfo({
  resource_path,
  version
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-web/deploy/web/remove`,
    method: "delete",
    params: {
      resourcePath: resource_path,
      version
    }
  });
}
var Deploy = {
  getWebInfo,
  getWebList,
  issueWebInfo,
  updateWebInfo,
  deleteWebInfo
};

function getAdminLogList({
  current_page,
  page_size,
  operation,
  username,
  start_time,
  end_time
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-web/log/list`,
    method: "get",
    params: {
      currentPage: current_page,
      pageSize: page_size,
      operation,
      username,
      startTime: start_time,
      endTime: end_time
    }
  });
}
var Log = {
  getAdminLogList
};

function getBatchNotice({
  current_page,
  currentTime,
  isShow,
  page_size,
  platform,
  title,
  version
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-web/notice`,
    method: "get",
    params: {
      current_page,
      currentTime,
      isShow,
      page_size,
      platform,
      title,
      version
    }
  });
}
function addSingleNotice({
  content,
  endTime,
  isShow,
  platform,
  startTime,
  title,
  version
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-web/notice`,
    method: "post",
    data: {
      content,
      endTime,
      isShow,
      platform,
      startTime,
      title,
      version
    }
  });
}
function getSingleNoticeById({
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-web/notice/${id}`,
    method: "get"
  });
}
function updateUserNotice({
  notice_id,
  user_id,
  noLongerShow
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-web/notice/${notice_id}/user/${user_id}`,
    method: "put",
    params: {
      noLongerShow
    }
  });
}
function getUserNoticeByUser({
  currentTime,
  platform,
  user_id,
  version
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-web/notice/user/${user_id}`,
    method: "get",
    params: {
      currentTime,
      platform,
      version
    }
  });
}
var Notice = {
  getBatchNotice,
  addSingleNotice,
  getSingleNoticeById,
  updateUserNotice,
  getUserNoticeByUser
};

function getServerConfig(fetchParams) {
  return fetch({ ...fetchParams,
    url: "/out-web/server/config",
    method: "get"
  });
}
function addServerConfig({
  each_es_db_size,
  es_db_num
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/out-web/server/config",
    method: "put",
    data: {
      each_es_db_size,
      es_db_num
    }
  });
}
var ServerConfig = {
  getServerConfig,
  addServerConfig
};

function addSingleAdminUser({
  password,
  remark,
  role_id,
  username
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-web/user/create`,
    method: "post",
    params: {
      password,
      remark,
      roleId: role_id,
      username
    }
  });
}
function deleteSingleAdminUser({
  username
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-web/user/delete`,
    method: "delete",
    params: {
      username
    }
  });
}
function getBatchAdminUserList({
  current_page,
  page_size
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-web/user/list`,
    method: "get",
    params: {
      currentPage: current_page,
      pageSize: page_size
    }
  });
}
function updateAdminUserPwd({
  new_password,
  username
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-web/user/password/update`,
    method: "put",
    params: {
      newPassword: new_password,
      username
    }
  });
}
function adminlogin({
  password,
  username
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-web/user/login`,
    method: "post",
    params: {
      password,
      username
    }
  });
}
function adminLogout(fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-web/user/logout`,
    method: "post"
  });
}
var User = {
  addSingleAdminUser,
  deleteSingleAdminUser,
  getBatchAdminUserList,
  updateAdminUserPwd,
  adminlogin,
  adminLogout
};

function getBatchUserBehaviors({
  action,
  current_page,
  end_date,
  module,
  page_size,
  params,
  platform,
  start_date,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/user/behavior`,
    method: "get",
    params: {
      action,
      current_page,
      end_date,
      module,
      page_size,
      params,
      platform,
      start_date,
      tenantId: tenant_id,
      userId: user_id
    }
  });
}
function addSingleUserBehavior(data, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/user/behavior`,
    method: "post",
    data
  });
}
function getBatchUserBehaviorsSortByAction({
  action,
  current_page,
  end_date,
  module,
  page_size,
  params,
  platform,
  start_date,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/user/behavior/sort-by-action`,
    method: "get",
    params: {
      action,
      current_page,
      end_date,
      module,
      page_size,
      params,
      platform,
      start_date,
      tenantId: tenant_id,
      userId: user_id
    }
  });
}
function getBatchUserBehaviorsSortByModule({
  action,
  current_page,
  end_date,
  module,
  page_size,
  params,
  platform,
  start_date,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/user/behavior/sort-by-module`,
    method: "get",
    params: {
      action,
      current_page,
      end_date,
      module,
      page_size,
      params,
      platform,
      start_date,
      tenantId: tenant_id,
      userId: user_id
    }
  });
}
function getBatchUserBehaviorsSortByTenant({
  action,
  current_page,
  end_date,
  module,
  page_size,
  params,
  platform,
  start_date
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/user/behavior/sort-by-module`,
    method: "get",
    params: {
      action,
      current_page,
      end_date,
      module,
      page_size,
      params,
      platform,
      start_date
    }
  });
}
var Behavior = {
  getBatchUserBehaviors,
  addSingleUserBehavior,
  getBatchUserBehaviorsSortByAction,
  getBatchUserBehaviorsSortByModule,
  getBatchUserBehaviorsSortByTenant
};

function getSingleFnDataGroupDisplay({
  group_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/bigscreen/${group_id}/IndustryES/fn-data-group-display`,
    method: "get"
  });
}
var IndustryES = {
  getSingleFnDataGroupDisplay
};

function getSingleRepair({
  repair_id,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/repair/tenant/${tenant_id}/repair/${repair_id}`,
    method: "get"
  });
}
function deleteSingleRepair({
  repair_id,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/repair/tenant/${tenant_id}/repair/${repair_id}`,
    method: "delete"
  });
}
function updateSingleRepair({
  repair_id,
  tenant_id,
  handle_message,
  remark,
  status
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/repair/tenant/${tenant_id}/repair/${repair_id}/handle`,
    method: "put",
    data: {
      handle_message,
      remark,
      status
    }
  });
}
function getBatchRepairs({
  current_page,
  ext_info,
  group_id,
  info_model_id,
  order_id,
  page_size,
  repair_user_id,
  status,
  tenant_id,
  things_id,
  third_things_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/repair/tenant/${tenant_id}/user/${user_id}`,
    method: "get",
    params: {
      current_page,
      ext_info,
      group_id,
      info_model_id,
      order_id,
      page_size,
      repair_user_id,
      status,
      things_id,
      third_things_id
    }
  });
}
function addSingleRepair({
  ext_info,
  group_id,
  handle_user_id,
  info_model_id,
  things_id,
  third_things_id,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/repair/tenant/${tenant_id}/user/${user_id}`,
    method: "post",
    data: {
      ext_info,
      group_id,
      handle_user_id,
      info_model_id,
      things_id,
      third_things_id
    }
  });
}
var Repair = {
  getSingleRepair,
  deleteSingleRepair,
  updateSingleRepair,
  getBatchRepairs,
  addSingleRepair
};

function getSingleWorkOrder({
  work_id,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/work/tenant/${tenant_id}/work/${work_id}`,
    method: "get"
  }, "work:work:query");
}
function deleteSingleWorkOrder({
  work_id,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/work/tenant/${tenant_id}/work/${work_id}`,
    method: "delete"
  }, "work:work:delete");
}
function updateSingleWorkOrder({
  work_id,
  tenant_id,
  ext_info,
  handle_message,
  remark,
  status
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/work/tenant/${tenant_id}/work/${work_id}/handle`,
    method: "put",
    data: {
      ext_info,
      handle_message,
      remark,
      status
    }
  }, "work:work:handle");
}
function getBatchWorkOrders({
  check_user_id,
  current_page,
  handle_user_id,
  name,
  order_id,
  page_size,
  priority,
  repair_id,
  work_user_id,
  status,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/work/tenant/${tenant_id}/user/${user_id}`,
    method: "get",
    params: {
      check_user_id,
      current_page,
      handle_user_id,
      name,
      order_id,
      page_size,
      priority,
      repair_id,
      work_user_id,
      status
    }
  }, "work:work:query");
}
function addSingleWorkOrder({
  tenant_id,
  user_id,
  check_user_id,
  end_time,
  ext_info,
  handle_user_id,
  name,
  priority,
  repair_id,
  start_time
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/work/tenant/${tenant_id}/user/${user_id}`,
    method: "post",
    data: {
      check_user_id,
      end_time,
      ext_info,
      handle_user_id,
      name,
      priority,
      repair_id,
      start_time
    }
  }, "work:work:create");
}
var WorkOrder = {
  getSingleWorkOrder,
  deleteSingleWorkOrder,
  updateSingleWorkOrder,
  getBatchWorkOrders,
  addSingleWorkOrder
};

function getSingleUserGroupOnlineStatus({
  tenant_id,
  user_id,
  info_model_id,
  parent_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/group/${tenant_id}/${user_id}/count/online-status`,
    method: "get",
    params: {
      info_model_id,
      parent_id
    }
  });
}
function getSingleUserTopGroups({
  tenant_id,
  user_id,
  info_model_id,
  parent_id,
  top_number
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/group/${tenant_id}/${user_id}/count/top-groups`,
    method: "get",
    params: {
      info_model_id,
      parent_id,
      top_number
    }
  });
}
function getBatchGroupWithDevDatas({
  currentPage,
  ext_info,
  include_devices,
  info_model_id,
  is_collect,
  name,
  name_like,
  order_by,
  pageSize,
  parent_id,
  tenant_id,
  things_state,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/group/${tenant_id}/${user_id}/count/group-list`,
    method: "get",
    params: {
      currentPage,
      ext_info,
      include_devices,
      info_model_id,
      is_collect,
      name,
      name_like,
      order_by,
      pageSize,
      parent_id,
      things_state
    }
  });
}
function getSingleUserIndustryEsStatisticsCount({
  properties,
  info_model_id,
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/group/${tenant_id}/${user_id}/count/group/IndustryES?info_model_id=${info_model_id}`,
    method: "post",
    data: {
      properties
    }
  });
}
function getSingleUserTopIndustryGroups({
  tenant_id,
  info_model_id,
  parent_id,
  top_number,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/group/${tenant_id}/${user_id}/count/top-groups/IndustryES`,
    method: "get",
    params: {
      info_model_id,
      parent_id,
      top_number
    }
  });
}
function getSingleStationOverviewData({
  group_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/bigscreen/${group_id}/IndustryES/running`,
    method: "get"
  });
}
function getSingleIndustryESStationStatisticsCount({
  group_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/bigscreen/${group_id}/IndustryES/count`,
    method: "get"
  });
}
function getSingleTenantBmsWithBcuMapping({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/bigscreen/tenant/${tenant_id}/IndustryES/bms-bcu-mapping`,
    method: "get"
  });
}
function getSingleIncomePrediction({
  group_id,
  tenant_id,
  things_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/group/tenant/${tenant_id}/user/${user_id}/group/${group_id}/IndustryES/income-prediction`,
    method: "get",
    params: {
      things_id
    }
  });
}
function getBatchTenantAlertEventData({
  tenant_id,
  info_model_id,
  user_id,
  group_id,
  level,
  start_time,
  end_time,
  current_page,
  page_size,
  rule_id,
  rule_name,
  things_id,
  third_things_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/group/tenants/${tenant_id}/user/${user_id}/alert-event-data`,
    method: "get",
    params: {
      group_id,
      level,
      start_time,
      end_time,
      pageSize: page_size,
      currentPage: current_page,
      info_model_id,
      rule_id,
      rule_name,
      things_id,
      third_things_id
    }
  });
}
function downloadBatchTenantAlertEventData({
  tenant_id,
  group_id,
  level,
  data_begin_time,
  data_end_time,
  rule_id,
  info_model_id,
  internationalization
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/group/tenants/${tenant_id}/alert-event-data/download`,
    method: "post",
    data: {
      group_id,
      level,
      data_begin_time,
      data_end_time,
      info_model_id,
      rule_id,
      internationalization
    }
  });
}
function getTenantBatchStatisticReportSummary({
  tenant_id,
  info_model_id,
  user_id,
  method_id,
  statistical_time_type,
  current_page,
  page_size,
  start_date,
  end_date,
  dimension_ids,
  sort,
  extra_parameter
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/group/${tenant_id}/${user_id}/IndustryES/statistic-report-summary`,
    method: "get",
    params: {
      tenant_id,
      info_model_id,
      method_id,
      statistical_time_type,
      current_page,
      page_size,
      start_date,
      end_date,
      dimension_ids,
      sort,
      extra_parameter
    }
  });
}
var WrapperGroup = {
  getSingleUserGroupOnlineStatus,
  getSingleUserTopGroups,
  getSingleUserIndustryEsStatisticsCount,
  getSingleUserTopIndustryGroups,
  getSingleStationOverviewData,
  getSingleIndustryESStationStatisticsCount,
  getSingleIncomePrediction,
  getTenantBatchStatisticReportSummary
};

function issueAsyncMessage({
  tenant_id,
  things_id,
  timeout,
  body,
  save_log
}, fetchParams) {
  let params = save_log ? "&save_log=true" : "";
  return fetch({ ...fetchParams,
    url: `/out-wrapper/tenants/${tenant_id}/things/${things_id}/sync-message?timeout=${timeout}${params}`,
    method: "post",
    data: body
  });
}
function getSingleCurrentSystemTimestamp(fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/timestamp`,
    method: "get"
  });
}
var WrapperMessages = {
  issueAsyncMessage,
  getSingleCurrentSystemTimestamp
};

function addSingleWrapperThings({
  tenant_id,
  things
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/tenants/${tenant_id}/things`,
    method: "post",
    data: things
  });
}
function addImportWrapperThings({
  tenant_id,
  file
}, fetchParams) {
  let formData = new FormData();
  formData.append("file", file, file.name);
  return fetch({ ...fetchParams,
    url: `/out-wrapper/tenants/${tenant_id}/import-things`,
    method: "post",
    data: formData
  });
}
function getBatchThingsByIds({
  ids,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/out-wrapper/tenants/${tenant_id}/things/batch/${ids}`,
    method: "get"
  });
}
var WrapperThings = {
  addImportWrapperThings,
  addSingleWrapperThings,
  getBatchThingsByIds
};

function addSingleCandtuECUBinding({
  tenant_id,
  binding
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-candtu/tenants/${tenant_id}/ecu/binding`,
    method: "post",
    data: binding
  });
}
var binding = {
  addSingleCandtuECUBinding
};

function addSingleCandtuThings({
  tenant_id,
  things
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-candtu/tenants/${tenant_id}/things`,
    method: "post",
    data: things
  });
}
var CandtuThings = {
  addSingleCandtuThings
};

function downloadCandtuDTCTemplate({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-candtu/tenants/${tenant_id}/dtc/template-file`,
    method: "get",
    header: {
      "Accept": "application/xlsx",
      "Authorization": `Bearer ${localStorage.getItem("token")}`
    },
    responseType: "blob"
  });
}
function addSingleCandtuDTCConfig({
  tenant_id,
  config
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-candtu/tenants/${tenant_id}/dtc/file`,
    method: "post",
    data: config
  });
}
function deleteSingleCandtuDTCConfig({
  tenant_id,
  file_name
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-candtu/tenants/${tenant_id}/dtc/file`,
    method: "delete",
    params: {
      file_name
    }
  });
}
function updateSingleCandtuDTCConfig({
  tenant_id,
  config
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-candtu/tenants/${tenant_id}/dtc/file`,
    method: "put",
    data: config
  });
}
function getSingleCandtuDTCConfig({
  tenant_id,
  file_name
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-candtu/tenants/${tenant_id}/dtc/file`,
    method: "get",
    params: {
      file_name
    }
  });
}
function getBatchCandtuDTCConfig({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-candtu/tenants/${tenant_id}/dtc/file-list`,
    method: "get"
  });
}
var dtc = {
  downloadCandtuDTCTemplate,
  addSingleCandtuDTCConfig,
  deleteSingleCandtuDTCConfig,
  updateSingleCandtuDTCConfig,
  getBatchCandtuDTCConfig
};

exports.CandtuECUFrameTypeCom = void 0;

(function (CandtuECUFrameTypeCom2) {
  CandtuECUFrameTypeCom2[CandtuECUFrameTypeCom2["standard"] = 0] = "standard";
  CandtuECUFrameTypeCom2[CandtuECUFrameTypeCom2["extension"] = 1] = "extension";
})(exports.CandtuECUFrameTypeCom || (exports.CandtuECUFrameTypeCom = {}));

function addSingleCandtuECU({
  tenant_id,
  ecu
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-candtu/tenants/${tenant_id}/ecu/configuration`,
    method: "post",
    data: ecu
  });
}
function updateSingleCandtuECU({
  tenant_id,
  ecu
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-candtu/tenants/${tenant_id}/ecu/configuration`,
    method: "put",
    data: ecu
  });
}
function deleteSingleCandtuECU({
  tenant_id,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-candtu/tenants/${tenant_id}/ecu/configuration`,
    method: "delete",
    params: {
      id
    }
  });
}
function getBatchCandtuECU({
  tenant_id,
  current_page,
  page_size
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-candtu/tenants/${tenant_id}/ecu/configuration-list`,
    method: "get",
    params: {
      current_page,
      page_size
    }
  });
}
exports.CandtuECUFileTypeCom = void 0;

(function (CandtuECUFileTypeCom2) {
  CandtuECUFileTypeCom2[CandtuECUFileTypeCom2["UpgradePatch"] = 0] = "UpgradePatch";
  CandtuECUFileTypeCom2[CandtuECUFileTypeCom2["DeblockingPatch"] = 1] = "DeblockingPatch";
})(exports.CandtuECUFileTypeCom || (exports.CandtuECUFileTypeCom = {}));

function getSingleCandtuECUFirmwareUrl({
  tenant_id,
  channel_id,
  dev_id,
  file_type,
  model_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-candtu/tenants/${tenant_id}/ecu/file`,
    method: "get",
    params: {
      channel_id,
      dev_id,
      file_type,
      model_id
    }
  });
}
function uploadSingleCandtuECUUpgradePatch({
  tenant_id,
  ecu_id,
  file,
  file_type,
  md5
}, fetchParams) {
  let formData = new FormData();
  formData.append("ecu_id", `${ecu_id}`);
  formData.append("file", file, file.name);
  formData.append("file_type", `${file_type}`);
  formData.append("md5", `${md5}`);
  return fetch({ ...fetchParams,
    url: `/single-candtu/tenants/${tenant_id}/ecu/file`,
    method: "post",
    data: formData
  });
}
var ecu = {
  addSingleCandtuECU,
  updateSingleCandtuECU,
  deleteSingleCandtuECU,
  getBatchCandtuECU,
  getSingleCandtuECUFirmwareUrl,
  uploadSingleCandtuECUUpgradePatch
};

function addSingleLorawanThings({
  tenant_id,
  body
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-lorawan/tenants/${tenant_id}/things`,
    method: "post",
    data: body
  });
}
var LorawanThings = {
  addSingleLorawanThings
};

function getBatchMulticastGroups({
  tenant_id,
  name,
  third_things_id,
  page_size,
  current_page
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-lorawan/tenants/${tenant_id}/multicast-group`,
    method: "get",
    params: {
      name,
      third_things_id,
      page_size,
      current_page
    }
  });
}
function addSingleMulticastGroup({
  tenant_id,
  body
}, fetchParams) {
  const data = {
    id: body.id,
    createdAt: body.created_at,
    dr: body.dr,
    fCnt: body.f_cnt,
    fcnt: body.fcnt,
    frequency: body.frequency,
    groupType: body.group_type,
    mcAddr: body.mc_addr,
    mcAppSKey: body.mc_apps_key,
    mcNwkSKey: body.mc_nwks_key,
    name: body.name,
    pingSlotPeriod: body.ping_slot_period,
    updateAt: body.update_at
  };
  return fetch({ ...fetchParams,
    url: `/single-lorawan/tenants/${tenant_id}/multicast-group`,
    method: "post",
    data
  });
}
function updateSingleMulticastGroup({
  id,
  tenant_id,
  body
}, fetchParams) {
  const data = {
    dr: body.dr,
    fCnt: body.f_cnt,
    frequency: body.frequency,
    groupType: body.group_type,
    mcAddr: body.mc_addr,
    mcAppSKey: body.mc_apps_key,
    mcNwkSKey: body.mc_nwks_key,
    name: body.name,
    pingSlotPeriod: body.ping_slot_period
  };
  return fetch({ ...fetchParams,
    url: `/single-lorawan/tenants/${tenant_id}/multicast-group/${id}`,
    method: "put",
    data
  });
}
function getBatchMulticastGroupIds({
  tenant_id,
  ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-lorawan/tenants/${tenant_id}/multicast-group/${ids}`,
    method: "get"
  });
}
function deleteBatchMulticastGroupIds({
  tenant_id,
  ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-lorawan/tenants/${tenant_id}/multicast-group/${ids}`,
    method: "delete"
  });
}
function getBatchMulticastGroupDevices({
  tenant_id,
  multicast_group_id,
  page_size,
  current_page
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-lorawan/tenants/${tenant_id}/multicast-group/${multicast_group_id}/devices`,
    method: "get",
    params: {
      page_size,
      current_page
    }
  });
}
function addBatchMulticastGroupDevices({
  tenant_id,
  multicast_group_id,
  body
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-lorawan/tenants/${tenant_id}/multicast-group/${multicast_group_id}/devices`,
    method: "post",
    data: body
  });
}
function deleteBatchMulticastGroupDevices({
  tenant_id,
  multicast_group_id,
  body
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-lorawan/tenants/${tenant_id}/multicast-group/${multicast_group_id}/devices`,
    method: "delete",
    data: body
  });
}
function issueSingleMulticastGroupMessage({
  tenant_id,
  multicast_group_id,
  data,
  data_type,
  f_cnt,
  f_port
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-lorawan/tenants/${tenant_id}/multicast-group/${multicast_group_id}/message`,
    method: "post",
    data: {
      data,
      data_type,
      fCnt: f_cnt,
      fPort: f_port
    }
  });
}
var MulticastGroup = {
  getBatchMulticastGroups,
  addSingleMulticastGroup,
  updateSingleMulticastGroup,
  getBatchMulticastGroupIds,
  deleteBatchMulticastGroupIds,
  getBatchMulticastGroupDevices,
  addBatchMulticastGroupDevices,
  deleteBatchMulticastGroupDevices,
  issueSingleMulticastGroupMessage
};

function addSingleOpcuaThings({
  tenant_id,
  body
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-opcua/tenants/${tenant_id}/things`,
    method: "post",
    data: body
  });
}
var OpcuaThings = {
  addSingleOpcuaThings
};

function getBatchZigbeeGroups({
  tenant_id,
  gw_info_model_id,
  gw_things_id,
  name,
  sub_info_model_id,
  page_size,
  current_page
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-zigbee/tenants/${tenant_id}/multicast/zigbee_group`,
    method: "get",
    params: {
      gw_info_model_id,
      gw_things_id,
      name,
      sub_info_model_id,
      page_size,
      current_page
    }
  });
}
function addSingleZigbeeGroup({
  tenant_id,
  name,
  gw_info_model_id,
  gw_things_id,
  multicast_id,
  sub_info_model_id,
  desc
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-zigbee/tenants/${tenant_id}/multicast/zigbee_group`,
    method: "post",
    data: {
      name,
      gw_info_model_id,
      gw_things_id,
      multicast_id,
      sub_info_model_id,
      desc
    }
  });
}
function getSingleZigbeeGroup({
  tenant_id,
  multicast_zigbee_group_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-zigbee/tenants/${tenant_id}/multicast/zigbee_group/${multicast_zigbee_group_id}`,
    method: "get"
  });
}
function updateSingleZigbeeGroup({
  tenant_id,
  multicast_zigbee_group_id,
  name,
  gw_info_model_id,
  gw_things_id,
  multicast_id,
  sub_info_model_id,
  desc
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-zigbee/tenants/${tenant_id}/multicast/zigbee_group/${multicast_zigbee_group_id}`,
    method: "put",
    data: {
      name,
      gw_info_model_id,
      gw_things_id,
      multicast_id,
      sub_info_model_id,
      desc
    }
  });
}
function deleteSingleZigbeeGroup({
  tenant_id,
  multicast_zigbee_group_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-zigbee/tenants/${tenant_id}/multicast/zigbee_group/${multicast_zigbee_group_id}`,
    method: "delete"
  });
}
function issueSingleZigbeeGroupMessage({
  tenant_id,
  multicast_zigbee_group_id,
  payload
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-zigbee/tenants/${tenant_id}/multicast/zigbee_group/${multicast_zigbee_group_id}/messages`,
    method: "put",
    data: payload
  });
}
var ZigbeeGroup = {
  getBatchZigbeeGroups,
  addSingleZigbeeGroup,
  updateSingleZigbeeGroup,
  deleteSingleZigbeeGroup,
  issueSingleZigbeeGroupMessage
};

function getBatchZigbeeMembers({
  tenant_id,
  sub_things_id,
  zigbee_group_id,
  page_size,
  current_page
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-zigbee/tenants/${tenant_id}/multicast/zigbee_member`,
    method: "get",
    params: {
      sub_things_id,
      zigbee_group_id,
      page_size,
      current_page
    }
  });
}
function addSingleZigbeeMember({
  tenant_id,
  sub_things_id,
  zigbee_group_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-zigbee/tenants/${tenant_id}/multicast/zigbee_member`,
    method: "post",
    data: {
      sub_things_id,
      zigbee_group_id
    }
  });
}
function deleteSingleZigbeeMember({
  tenant_id,
  sub_things_id,
  zigbee_group_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single-zigbee/tenants/${tenant_id}/multicast/zigbee_member`,
    method: "delete",
    params: {
      sub_things_id,
      zigbee_group_id
    }
  });
}
var ZigbeeMember = {
  getBatchZigbeeMembers,
  addSingleZigbeeMember,
  deleteSingleZigbeeMember
};

function addSingleECUBinding({
  tenant_id,
  binding
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/tenants/${tenant_id}/ecu/binding`,
    method: "post",
    data: binding
  });
}
var Binding = {
  addSingleECUBinding
};

function downloadDTCTemplate({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/tenants/${tenant_id}/dtc/template-file`,
    method: "get",
    header: {
      "Accept": "application/xlsx",
      "Authorization": `Bearer ${localStorage.getItem("token")}`
    },
    responseType: "blob"
  });
}
function addSingleDTCConfig({
  tenant_id,
  config
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/tenants/${tenant_id}/dtc/file`,
    method: "post",
    data: config
  });
}
function deleteSingleDTCConfig({
  tenant_id,
  file_name
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/tenants/${tenant_id}/dtc/file`,
    method: "delete",
    params: {
      file_name
    }
  });
}
function updateSingleDTCConfig({
  tenant_id,
  config
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/tenants/${tenant_id}/dtc/file`,
    method: "put",
    data: config
  });
}
function getSingleDTCConfig({
  tenant_id,
  file_name
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/tenants/${tenant_id}/dtc/file`,
    method: "get",
    params: {
      file_name
    }
  });
}
function getBatchDTCConfig({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/tenants/${tenant_id}/dtc/file-list`,
    method: "get"
  });
}
var Dtc = {
  downloadDTCTemplate,
  addSingleDTCConfig,
  deleteSingleDTCConfig,
  updateSingleDTCConfig,
  getBatchDTCConfig
};

exports.ECUFrameTypeCom = void 0;

(function (ECUFrameTypeCom2) {
  ECUFrameTypeCom2[ECUFrameTypeCom2["standard"] = 0] = "standard";
  ECUFrameTypeCom2[ECUFrameTypeCom2["extension"] = 1] = "extension";
})(exports.ECUFrameTypeCom || (exports.ECUFrameTypeCom = {}));

function addSingleECU({
  tenant_id,
  ecu
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/tenants/${tenant_id}/ecu/configuration`,
    method: "post",
    data: ecu
  });
}
function updateSingleECU({
  tenant_id,
  ecu
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/tenants/${tenant_id}/ecu/configuration`,
    method: "put",
    data: ecu
  });
}
function deleteSingleECU({
  tenant_id,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/tenants/${tenant_id}/ecu/configuration`,
    method: "delete",
    params: {
      id
    }
  });
}
function getBatchECU({
  tenant_id,
  current_page,
  page_size
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/tenants/${tenant_id}/ecu/configuration-list`,
    method: "get",
    params: {
      current_page,
      page_size
    }
  });
}
exports.ECUFileTypeCom = void 0;

(function (ECUFileTypeCom2) {
  ECUFileTypeCom2[ECUFileTypeCom2["UpgradePatch"] = 0] = "UpgradePatch";
  ECUFileTypeCom2[ECUFileTypeCom2["DeblockingPatch"] = 1] = "DeblockingPatch";
})(exports.ECUFileTypeCom || (exports.ECUFileTypeCom = {}));

function getSingleECUFirmwareUrl({
  tenant_id,
  channel_id,
  dev_id,
  file_type,
  model_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/tenants/${tenant_id}/ecu/file`,
    method: "get",
    params: {
      channel_id,
      dev_id,
      file_type,
      model_id
    }
  });
}
function uploadSingleECUUpgradePatch({
  tenant_id,
  ecu_id,
  file,
  file_type,
  md5
}, fetchParams) {
  let formData = new FormData();
  formData.append("ecu_id", `${ecu_id}`);
  formData.append("file", file, file.name);
  formData.append("file_type", `${file_type}`);
  formData.append("md5", `${md5}`);
  return fetch({ ...fetchParams,
    url: `/single/tenants/${tenant_id}/ecu/file`,
    method: "post",
    data: formData
  });
}
var Ecu = {
  addSingleECU,
  updateSingleECU,
  deleteSingleECU,
  getBatchECU,
  getSingleECUFirmwareUrl,
  uploadSingleECUUpgradePatch
};

function getSingleBatchMulticastGroups({
  tenant_id,
  name,
  third_things_id,
  page_size,
  current_page
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/lorawan/tenants/${tenant_id}/multicast-group`,
    method: "get",
    params: {
      name,
      third_things_id,
      page_size,
      current_page
    }
  });
}
function getSingleBatchMulticastGroupIds({
  tenant_id,
  ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/lorawan/tenants/${tenant_id}/multicast-group/${ids}`,
    method: "get"
  });
}
function addSingleSingleMulticastGroup({
  tenant_id,
  dr,
  f_cnt,
  frequency,
  group_type,
  mc_addr,
  mc_apps_key,
  mc_nwks_key,
  name,
  ping_slot_period
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/lorawan/tenants/${tenant_id}/multicast-group`,
    method: "post",
    data: {
      dr,
      fcnt: f_cnt,
      frequency,
      groupType: group_type,
      mcAddr: mc_addr,
      mcAppSKey: mc_apps_key,
      mcNwkSKey: mc_nwks_key,
      name,
      pingSlotPeriod: ping_slot_period
    }
  });
}
function updateSingleSingleMulticastGroup({
  ids,
  tenant_id,
  dr,
  f_cnt,
  frequency,
  group_type,
  mc_addr,
  mc_apps_key,
  mc_nwks_key,
  name,
  ping_slot_period
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/lorawan/tenants/${tenant_id}/multicast-group/${ids}`,
    method: "put",
    data: {
      dr,
      fcnt: f_cnt,
      frequency,
      groupType: group_type,
      mcAddr: mc_addr,
      mcAppSKey: mc_apps_key,
      mcNwkSKey: mc_nwks_key,
      name,
      pingSlotPeriod: ping_slot_period
    }
  });
}
function deleteSingleBatchMulticastGroupIds({
  tenant_id,
  ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/lorawan/tenants/${tenant_id}/multicast-group/${ids}`,
    method: "delete"
  });
}
function getSingleBatchMulticastGroupDevices({
  tenant_id,
  multicast_group_id,
  page_size,
  current_page
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/lorawan/tenants/${tenant_id}/multicast-group/${multicast_group_id}/devices`,
    method: "get",
    params: {
      page_size,
      current_page
    }
  });
}
function addSingleBatchMulticastGroupDevices({
  tenant_id,
  multicast_group_id,
  body
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/lorawan/tenants/${tenant_id}/multicast-group/${multicast_group_id}/devices`,
    method: "post",
    data: body
  });
}
function deleteSingleBatchMulticastGroupDevices({
  tenant_id,
  multicast_group_id,
  body
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/lorawan/tenants/${tenant_id}/multicast-group/${multicast_group_id}/devices`,
    method: "delete",
    data: body
  });
}
function issueSingleSingleMulticastGroupMessage({
  tenant_id,
  multicast_group_id,
  data,
  data_type,
  f_cnt,
  f_port
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/lorawan/tenants/${tenant_id}/multicast-group/${multicast_group_id}/message`,
    method: "post",
    data: {
      data,
      data_type,
      fCnt: f_cnt,
      fPort: f_port
    }
  });
}
function addSingleSingleLorawanThings({
  tenant_id,
  body
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/lorawan/tenants/${tenant_id}/things`,
    method: "post",
    data: body
  });
}
var Lorawan = {
  getSingleBatchMulticastGroups,
  getSingleBatchMulticastGroupIds,
  addSingleSingleMulticastGroup,
  updateSingleSingleMulticastGroup,
  deleteSingleBatchMulticastGroupIds,
  getSingleBatchMulticastGroupDevices,
  addSingleBatchMulticastGroupDevices,
  deleteSingleBatchMulticastGroupDevices,
  issueSingleSingleMulticastGroupMessage,
  addSingleSingleLorawanThings
};

function addSingleSingleOpcuaThings({
  tenant_id,
  attributes,
  configuration,
  description,
  desired_properties,
  desired_status,
  full_things_id,
  gw_things_id,
  id,
  info_model_id,
  info_model_name,
  maximum_duration_online,
  name,
  parent_things_id,
  revsion,
  status,
  tenant_name,
  thing_type,
  things_key,
  third_things_id,
  twin_things_status,
  vendor_tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/opcua/tenants/${tenant_id}/things`,
    method: "post",
    data: {
      attributes,
      configuration,
      description,
      desired_properties,
      desired_status,
      full_things_id,
      gw_things_id,
      id,
      info_model_id,
      info_model_name,
      maximum_duration_online,
      name,
      parent_things_id,
      revsion,
      status,
      tenant_name,
      thing_type,
      things_key,
      third_things_id,
      twin_things_status,
      vendor_tenant_id
    }
  });
}
var Opcua = {
  addSingleSingleOpcuaThings
};

function getSingleSingleWorkOrder({
  work_id,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/work/tenant/${tenant_id}/work/${work_id}`,
    method: "get"
  }, "work:work:query");
}
function deleteSingleSingleWorkOrder({
  work_id,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/work/tenant/${tenant_id}/work/${work_id}`,
    method: "delete"
  }, "work:work:delete");
}
function updateSingleSingleWorkOrder({
  work_id,
  tenant_id,
  auto_commit,
  check_user_id,
  end_time,
  ext_info,
  handle_user_id,
  name,
  priority,
  remark,
  start_time
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/work/tenant/${tenant_id}/work/${work_id}?auto_commit=` + auto_commit,
    method: "put",
    data: {
      auto_commit,
      check_user_id,
      end_time,
      ext_info,
      handle_user_id,
      name,
      priority,
      remark,
      start_time
    }
  }, "work:work:handle");
}
function handleSingleSingleWorkOrder({
  work_id,
  tenant_id,
  ext_info,
  handle_message,
  remark,
  status
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/work/tenant/${tenant_id}/work/${work_id}/handle`,
    method: "put",
    data: {
      ext_info,
      handle_message,
      remark,
      status
    }
  }, "work:work:handle");
}
function getBatchSingleWorkOrders({
  check_user_id,
  current_page,
  ext_info,
  handle_user_id,
  name,
  order_id,
  page_size,
  priority,
  status,
  tenant_id,
  type,
  user_id,
  work_user_ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/work/tenant/${tenant_id}/user/${user_id}`,
    method: "get",
    params: {
      check_user_id,
      current_page,
      ext_info,
      handle_user_id,
      name,
      order_id,
      page_size,
      priority,
      type,
      work_user_ids,
      status
    }
  }, "work:work:query");
}
function addSingleSingleWorkOrder({
  tenant_id,
  user_id,
  check_user_id,
  end_time,
  ext_info,
  handle_user_id,
  name,
  priority,
  remark,
  start_time,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/work/tenant/${tenant_id}/user/${user_id}`,
    method: "post",
    data: {
      check_user_id,
      end_time,
      ext_info,
      handle_user_id,
      name,
      priority,
      remark,
      start_time,
      type
    }
  }, "work:work:create");
}
var Work = {
  getSingleSingleWorkOrder,
  deleteSingleSingleWorkOrder,
  updateSingleSingleWorkOrder,
  handleSingleSingleWorkOrder,
  getBatchSingleWorkOrders,
  addSingleSingleWorkOrder
};

function getSingleBatchZigbeeGroups({
  tenant_id,
  gw_info_model_id,
  gw_things_id,
  name,
  sub_info_model_id,
  page_size,
  current_page
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/zigbee/tenants/${tenant_id}/multicast/group`,
    method: "get",
    params: {
      gw_info_model_id,
      gw_things_id,
      name,
      sub_info_model_id,
      page_size,
      current_page
    }
  });
}
function addSingleSingleZigbeeGroup({
  tenant_id,
  name,
  gw_info_model_id,
  gw_things_id,
  multicast_id,
  sub_info_model_id,
  desc
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/zigbee/tenants/${tenant_id}/multicast/group`,
    method: "post",
    data: {
      name,
      gw_info_model_id,
      gw_things_id,
      multicast_id,
      sub_info_model_id,
      desc
    }
  });
}
function getSingleSingleZigbeeGroup({
  tenant_id,
  multicast_zigbee_group_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/zigbee/tenants/${tenant_id}/multicast/group/${multicast_zigbee_group_id}`,
    method: "get"
  });
}
function updateSingleSingleZigbeeGroup({
  tenant_id,
  multicast_zigbee_group_id,
  name,
  gw_info_model_id,
  gw_things_id,
  multicast_id,
  desc,
  sub_info_model_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/zigbee/tenants/${tenant_id}/multicast/group/${multicast_zigbee_group_id}`,
    method: "put",
    data: {
      name,
      gw_info_model_id,
      gw_things_id,
      multicast_id,
      sub_info_model_id,
      desc
    }
  });
}
function deleteSingleSingleZigbeeGroup({
  tenant_id,
  multicast_zigbee_group_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/zigbee/tenants/${tenant_id}/multicast/group/${multicast_zigbee_group_id}`,
    method: "delete"
  });
}
function issueSingleSingleZigbeeGroupMessage({
  tenant_id,
  multicast_zigbee_group_id,
  payload
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/zigbee/tenants/${tenant_id}/multicast/group/${multicast_zigbee_group_id}/messages`,
    method: "put",
    data: payload
  });
}
function getSingleBatchZigbeeMembers({
  tenant_id,
  sub_things_id,
  zigbee_group_id,
  page_size,
  current_page
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/zigbee/tenants/${tenant_id}/multicast/member`,
    method: "get",
    params: {
      sub_things_id,
      zigbee_group_id,
      page_size,
      current_page
    }
  });
}
function addSingleSingleZigbeeMember({
  tenant_id,
  sub_things_id,
  zigbee_group_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/zigbee/tenants/${tenant_id}/multicast/member`,
    method: "post",
    data: {
      sub_things_id,
      zigbee_group_id
    }
  });
}
function deleteSingleSingleZigbeeMember({
  tenant_id,
  sub_things_id,
  zigbee_group_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/single/zigbee/tenants/${tenant_id}/multicast/member`,
    method: "delete",
    params: {
      sub_things_id,
      zigbee_group_id
    }
  });
}
var Zigbee = {
  getSingleBatchZigbeeGroups,
  addSingleSingleZigbeeGroup,
  getSingleSingleZigbeeGroup,
  updateSingleSingleZigbeeGroup,
  deleteSingleSingleZigbeeGroup,
  issueSingleSingleZigbeeGroupMessage,
  getSingleBatchZigbeeMembers,
  addSingleSingleZigbeeMember,
  deleteSingleSingleZigbeeMember
};

function addSingleTenantLabel({
  tenant_id,
  label,
  description
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/labels`,
    method: "post",
    data: {
      label,
      description
    }
  }, "tenant:label:create");
}
function deleteBatchTenantLabels({
  tenant_id,
  ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/labels/${ids}`,
    method: "delete",
    params: {
      ids
    }
  }, "tenant:label:delete");
}
function getBatchTenantLabels({
  tenant_id,
  current_page,
  page_size,
  prefix,
  scope
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/labels`,
    method: "get",
    params: {
      current_page,
      page_size,
      prefix,
      scope
    }
  });
}
function updateSingleTenantLabel({
  tenant_id,
  id,
  label,
  description
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/labels/${id}`,
    method: "put",
    data: {
      label,
      description
    }
  }, "tenant:label:update");
}
function getSingleTenantLabel({
  tenant_id,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/labels/${id}`,
    method: "get"
  });
}
function getBatchLabelByIds({
  tenant_id,
  ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/labels/batch`,
    method: "get",
    params: {
      ids
    }
  });
}
var Labels = {
  addSingleTenantLabel,
  deleteBatchTenantLabels,
  getBatchTenantLabels,
  updateSingleTenantLabel,
  getSingleTenantLabel,
  getBatchLabelByIds
};

function getBatchSimPoolList({
  tenant_id,
  current_page,
  page_size
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/third/sim-pool/${tenant_id}`,
    method: "get",
    params: {
      current_page,
      page_size
    }
  });
}
function addSingleSimPool({
  tenant_id,
  app_id,
  app_key,
  group_id,
  sim_type,
  remark
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/third/sim-pool/${tenant_id}`,
    method: "post",
    data: {
      app_id,
      app_key,
      group_id,
      sim_type,
      remark
    }
  });
}
function updateBatchSimPool({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/third/sim-pool/${tenant_id}`,
    method: "put"
  });
}
function updateSingleSimPool({
  tenant_id,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/third/sim-pool/${tenant_id}/${id}`,
    method: "put"
  });
}
function deleteSingleSimPool({
  tenant_id,
  id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/third/sim-pool/${tenant_id}/${id}`,
    method: "delete"
  });
}
var Simpool = {
  deleteSingleSimPool,
  updateSingleSimPool,
  updateBatchSimPool,
  addSingleSimPool,
  getBatchSimPoolList
};

function downloadTenantCsvFile({
  audited,
  current_page,
  name,
  page_size,
  status
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/tenants-csv-file",
    method: "get",
    params: {
      audited,
      current_page,
      name,
      page_size,
      status
    }
  });
}
var TenantExport = {
  downloadTenantCsvFile
};

function getBatchTenantMenu({
  platform,
  menu_name,
  menu_name_key,
  show
}) {
  return fetch({
    url: "/tenant/menu",
    method: "get",
    params: {
      platform,
      menu_name,
      menu_name_key,
      show
    }
  });
}
function addSingleTenantMenu({
  platform,
  group,
  icon,
  link_address,
  link_type,
  menu_field,
  menu_name,
  menu_type,
  show
}) {
  return fetch({
    url: "/tenant/menu",
    method: "post",
    params: {
      platform
    },
    data: {
      group,
      icon,
      link_address,
      link_type,
      menu_field,
      menu_name,
      menu_type,
      show
    }
  });
}
function updateSingleTenantMenu({
  platform,
  group,
  icon,
  link_address,
  link_type,
  menu_field,
  menu_name,
  menu_type,
  show
}) {
  return fetch({
    url: "/tenant/menu",
    method: "put",
    params: {
      platform,
      menu_field
    },
    data: {
      group,
      icon,
      link_address,
      link_type,
      menu_name,
      menu_type,
      show
    }
  });
}
function deleteSingleTenantMenu({
  menu_field,
  platform
}) {
  return fetch({
    url: "/tenant/menu",
    method: "delete",
    params: {
      platform,
      menu_field
    }
  });
}
function updateSingleTenantMenuMove({
  index,
  menu_field,
  platform,
  targetGroup
}) {
  return fetch({
    url: "/tenant/menu/move",
    method: "put",
    params: {
      platform,
      menu_field,
      index,
      targetGroup
    }
  });
}
var TenantMenu = {
  getBatchTenantMenu,
  addSingleTenantMenu,
  updateSingleTenantMenu,
  deleteSingleTenantMenu,
  updateSingleTenantMenuMove
};

function getSingleAllTenantSpecification(fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/tenants/all/specification",
    method: "get"
  });
}
function getSingleTenantSpecification({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/specification`,
    method: "get"
  });
}
function getSingleAllUsageStatistics(fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/tenants/all/usage-statistics",
    method: "get"
  });
}
function getSingleCustomization({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/customization`,
    method: "get"
  });
}
function updateSingleCustomization({
  tenant_id,
  body
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/customization`,
    method: "put",
    data: body
  }, "tenant:system-set:update");
}
function getBatchTenants({
  audited,
  current_page = 1,
  email,
  ids,
  mobile,
  name,
  page_size = 20,
  status
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants`,
    method: "get",
    params: {
      audited,
      current_page,
      email,
      ids,
      mobile,
      name,
      page_size,
      status
    }
  });
}
function updateSingleTenants({
  tenant_id,
  tenant_info
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}`,
    method: "put",
    data: tenant_info
  });
}
function getSingleTenantByIdOrName({
  id,
  name
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenant-detail`,
    method: "get",
    params: {
      id,
      name
    }
  });
}
function updateSingleTenantAudit({
  tenant_id,
  pass,
  notify,
  remark
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/audit/${pass}`,
    method: "put",
    params: {
      notify,
      remark
    }
  });
}
function getTenantAuditStatistic(fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/tenant-audit-statistic",
    method: "get"
  });
}
function getBatchTenantAudit({
  current_page,
  email,
  mobile,
  name,
  page_size,
  platform,
  status
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/tenant-audits",
    method: "get",
    params: {
      current_page,
      email,
      mobile,
      name,
      page_size,
      platform,
      status
    }
  });
}
var Tenants = {
  getSingleAllTenantSpecification,
  getSingleTenantSpecification,
  getSingleAllUsageStatistics,
  getSingleCustomization,
  updateSingleCustomization,
  getBatchTenants,
  getSingleTenantByIdOrName,
  updateSingleTenantAudit,
  getTenantAuditStatistic,
  getBatchTenantAudit,
  updateSingleTenants
};

function getBatchSubUsers({
  current_page,
  page_size,
  search,
  status,
  tenant_id,
  name,
  only_sub_user,
  parent_id,
  type,
  mobile,
  user_flag
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/users`,
    method: "get",
    params: {
      current_page,
      page_size,
      search,
      status,
      name,
      only_sub_user,
      parent_id,
      type,
      mobile,
      user_flag
    }
  });
}
function getSingleSubUsersById({
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/users/${user_id}`,
    method: "get"
  });
}
function addSingleSubUser({
  tenant_id,
  name,
  mobile,
  department,
  description,
  email,
  gender,
  job,
  nick_name,
  user_flag,
  parent_user_id,
  last_login_ip,
  last_login_time
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/users`,
    method: "post",
    data: {
      department,
      description,
      email,
      mobile,
      name,
      nick_name,
      gender,
      job,
      user_flag,
      parent_user_id,
      last_login_ip,
      last_login_time
    }
  }, "tenant:user:create");
}
function updateSingleSubUser({
  tenant_id,
  user_id,
  name,
  mobile,
  department,
  description,
  email,
  gender,
  job,
  nick_name,
  type,
  user_flag,
  parent_user_id,
  last_login_ip,
  last_login_time
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/users/${user_id}`,
    method: "put",
    data: {
      name,
      mobile,
      department,
      description,
      email,
      gender,
      job,
      nick_name,
      type,
      user_flag,
      parent_user_id,
      last_login_ip,
      last_login_time
    }
  });
}
function updateSingleUserPassword({
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/users/${user_id}/reset-password`,
    method: "post"
  });
}
function deleteSingleSubUser({
  tenant_id,
  user_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/users/${user_id}`,
    method: "delete"
  });
}
function deleteBatchSubUsers({
  tenant_id,
  ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/users`,
    method: "delete",
    params: {
      ids
    }
  });
}
function getSingleSubUserTree({
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/users-tree`,
    method: "get"
  });
}
function getUserPublicProfile({
  tenant_id,
  ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/users/public-profile`,
    params: {
      ids
    },
    method: "get"
  });
}
function getBatchSubUsersWithAuth({
  tenant_id,
  user_id,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/users/${user_id}/all-subusers-with-auth`,
    method: "get",
    params: {
      type
    }
  });
}
var TenantUsers = {
  getBatchSubUsers,
  getSingleSubUsersById,
  addSingleSubUser,
  updateSingleSubUser,
  updateSingleUserPassword,
  deleteSingleSubUser,
  deleteBatchSubUsers,
  getSingleSubUserTree,
  getUserPublicProfile
};

function getUserAttr({
  attribute_key,
  attribute_type,
  attribute_value,
  begin_time,
  current_page,
  end_time,
  page_size,
  tenant_id,
  tenant_name,
  user_id,
  user_name
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/user/attr",
    method: "get",
    params: {
      attribute_key,
      attribute_type,
      attribute_value,
      begin_time,
      current_page,
      end_time,
      page_size,
      tenant_id,
      tenant_name,
      user_id,
      user_name
    }
  });
}
function getTryLoginLog({
  attribute_type,
  begin_time,
  current_page,
  end_time,
  page_size
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/user/attr/try-login-log",
    method: "get",
    params: {
      attribute_type,
      begin_time,
      current_page,
      end_time,
      page_size
    }
  });
}
function uploadUserAttrFile({
  attribute_type,
  file_name,
  platform,
  upload_file
}, fetchParams) {
  let formData = new FormData();
  formData.append("upload_file", upload_file, upload_file.name);
  return fetch({ ...fetchParams,
    url: "/tenant/user/attr/file",
    method: "post",
    params: {
      attribute_type,
      file_name,
      platform
    },
    data: formData
  });
}
var UserAttr = {
  getUserAttr,
  getTryLoginLog
};

function getUserMessageByUser({
  tenant_id,
  user_id,
  platform,
  read_status,
  current_page,
  page_size
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/users/${user_id}/message`,
    method: "get",
    params: {
      platform,
      read_status,
      current_page,
      page_size
    }
  });
}
function updateUserMessageByUser({
  tenant_id,
  user_id,
  read_status,
  update_all,
  user_message_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/tenants/${tenant_id}/users/${user_id}/message`,
    method: "put",
    params: {
      read_status,
      update_all,
      user_message_id
    }
  });
}
function getUserMessage({
  current_page,
  message_type,
  page_size,
  platform,
  status,
  title
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/user-message",
    method: "get",
    params: {
      current_page,
      message_type,
      page_size,
      platform,
      status,
      title
    }
  });
}
function postUserMessage({
  messageContent,
  messageTargetType,
  messageTitle,
  messageType,
  platform,
  reminderMode,
  send_time,
  status,
  tenantUserIdList
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/user-message",
    method: "post",
    data: {
      messageContent,
      messageTargetType,
      messageTitle,
      messageType,
      platform,
      reminderMode,
      send_time,
      status,
      tenantUserIdList
    }
  });
}
function deleteUserMessage({
  user_message_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/user-message/${user_message_id}`,
    method: "delete"
  });
}
function updateUserMessageStatus({
  status,
  user_message_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/user-message/${user_message_id}/status`,
    method: "put",
    params: {
      status
    }
  });
}
var UserMessage = {
  getUserMessageByUser,
  updateUserMessageByUser,
  getUserMessage,
  postUserMessage,
  deleteUserMessage,
  updateUserMessageStatus
};

function updateResetPassword({
  type,
  source,
  verification_code,
  new_password,
  user_type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/reset-password",
    method: "post",
    data: {
      type,
      source,
      verification_code,
      new_password,
      user_type
    }
  });
}
function getUsersInfo({
  name,
  ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/tenants/users-info",
    method: "get",
    params: {
      name,
      ids
    }
  });
}
function updateUserSelfCurrentPassword({
  password,
  code,
  mobile
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/users/self/password",
    method: "put",
    data: {
      password,
      code,
      mobile
    }
  });
}
function updateUserSelfMobile({
  new_mobile,
  new_code,
  old_mobile
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/users/self/mobile",
    method: "put",
    data: {
      new_mobile,
      new_code,
      old_mobile
    }
  });
}
function updateUserSelfEmail({
  new_email,
  new_code,
  old_email
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/users/self/email",
    method: "put",
    data: {
      new_email,
      new_code,
      old_email
    }
  });
}
function updateUserSelfAvatar({
  file
}, fetchParams) {
  let uploadFile = file.target.files[0];
  let imgFormdata = new FormData();
  imgFormdata.append("avatar", uploadFile, file.name);
  return fetch({ ...fetchParams,
    url: "/tenant/users/self/avatar",
    method: "put",
    data: imgFormdata
  });
}
function getUserSelfConfig({
  keys
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/users/self/config",
    method: "get",
    params: {
      keys
    }
  });
}
function addSingleUserSelfConfig({
  key,
  value
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/users/self/config?key=${key}`,
    method: "post",
    data: {
      value
    }
  });
}
function deleteUserSelfConfig({
  keys
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/users/self/config",
    method: "delete",
    params: {
      keys
    }
  });
}
function getSelfUserInfo(fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/users/self",
    method: "get"
  });
}
function updateSelfUserInfo({
  department,
  description,
  gender,
  job,
  nick_name,
  customization
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/users/self",
    method: "put",
    data: {
      department,
      description,
      gender,
      job,
      nick_name,
      customization
    }
  });
}
function getSingleUserCustomization(data, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/users/self/customization`,
    method: "get",
    params: data
  });
}
function updateSingleUserCustomization(data, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/users/self/customization`,
    method: "put",
    data: {
      "customization": data
    }
  }, "tenant:user:system-set:update");
}
function checkTenantIsManager({
  type,
  username
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/is-manager",
    method: "get",
    params: {
      type,
      username
    }
  });
}
function getUsersSelfTenant(fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/users/self/tenant",
    method: "get"
  });
}
function updateUsersSelfTenant({
  address,
  auto_circle_delete_data,
  city,
  country,
  description,
  industry,
  organization_name,
  platform,
  province
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/users/self/tenant",
    method: "put",
    data: {
      address,
      auto_circle_delete_data,
      city,
      country,
      description,
      industry,
      organization_name,
      platform,
      province
    }
  });
}
function updateUsersSelfTenantSpec({
  max_reserves_duration,
  reclaim_policy
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/users/self/tenant-spec",
    method: "put",
    data: {
      max_reserves_duration,
      reclaim_policy
    }
  });
}
var Users = {
  updateResetPassword,
  updateUserSelfCurrentPassword,
  updateUserSelfMobile,
  updateUserSelfEmail,
  updateUserSelfAvatar,
  updateSelfUserInfo,
  checkTenantIsManager,
  getSelfUserInfo,
  getUsersSelfTenant,
  updateUsersSelfTenant,
  updateUsersSelfTenantSpec,
  addSingleUserSelfConfig,
  deleteUserSelfConfig,
  getUserSelfConfig,
  getUsersInfo,
  getSingleUserCustomization,
  updateSingleUserCustomization
};

function checkUserTenantValidate({
  field,
  value
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/user-tenant-validate",
    method: "get",
    params: {
      field,
      value
    },
    headers: {}
  });
}
function checkUserTenantValidateZWS({
  field,
  value
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/user-tenant-validate-zws",
    method: "get",
    params: {
      field,
      value
    }
  });
}
function addSingleUserTenants({
  address,
  city,
  country,
  department,
  description,
  email,
  email_verification_code,
  gender,
  industry,
  job,
  mobile,
  mobile_verification_code,
  name,
  namespace,
  nick_name,
  organization_name,
  password,
  province,
  username,
  platform
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/user-tenants",
    method: "post",
    data: {
      address,
      city,
      country,
      department,
      description,
      email,
      email_verification_code,
      gender,
      industry,
      job,
      mobile,
      mobile_verification_code,
      name,
      namespace,
      nick_name,
      organization_name,
      password,
      province,
      username,
      platform
    },
    headers: {}
  });
}
function addSingleSubUserTenents({
  department,
  description,
  email,
  email_verification_code,
  extension_code,
  gender,
  job,
  mobile,
  mobile_verification_code,
  nick_name,
  password,
  username
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/user-tenants/sub-user",
    method: "post",
    data: {
      department,
      description,
      email,
      email_verification_code,
      extension_code,
      gender,
      job,
      mobile,
      mobile_verification_code,
      nick_name,
      password,
      username
    }
  });
}
var UserTenants = {
  checkUserTenantValidate,
  addSingleUserTenants,
  addSingleSubUserTenents
};

function getBatchVerificationCodes({
  current_page,
  destination,
  page_size
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/verification-codes",
    method: "get",
    params: {
      current_page,
      destination,
      page_size
    }
  });
}
function getVerificationCodes({
  type,
  destination,
  purpose
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: "/tenant/verification-codes",
    method: "post",
    data: {
      type,
      destination,
      purpose
    },
    headers: ""
  });
}
var VerificationCodes = {
  getBatchVerificationCodes,
  getVerificationCodes
};

function getThirdLoginAuth({
  redirect_url,
  third_type,
  platform
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/zwsthird-login/auth`,
    method: "post",
    data: {
      redirect_url,
      third_type,
      platform
    }
  });
}
function bindThirdLoginUser({
  account,
  bind_token,
  bind_type,
  pwd
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/zwsthird-login/bind`,
    method: "post",
    data: {
      account,
      bind_token,
      bind_type,
      pwd
    }
  });
}
function bindThirdLoginUCUser({
  account,
  third_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/zwsthird-login/bind-from-uc`,
    method: "post",
    data: {
      account,
      third_id
    }
  });
}
function checkThirdLoginAuth({
  auth_code,
  is_web,
  third_type,
  platform
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/tenant/zwsthird-login/check`,
    method: "post",
    data: {
      auth_code,
      is_web,
      third_type,
      platform
    }
  });
}
var ZwsThirdLogin = {
  getThirdLoginAuth,
  bindThirdLoginUser,
  bindThirdLoginUCUser,
  checkThirdLoginAuth
};

function getBatchDigitalTwinThings({
  tenant_id,
  status_name,
  status_value,
  info_model_ids,
  current_page,
  page_size,
  things_ids
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/digital-twin-things`,
    method: "get",
    params: {
      status_name,
      status_value,
      info_model_ids,
      current_page,
      page_size,
      things_ids
    }
  });
}
function updateBatchAttributes({
  info_model_id,
  third_things_id,
  body
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/info-models/${info_model_id}/digital-twin-things/${third_things_id}/batch-update`,
    method: "post",
    data: body
  });
}
function updateSingleThingAttributes({
  tenant_id,
  things_id,
  api_update_digital_twin_device
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/digital-twin-things/${things_id}`,
    method: "post",
    data: api_update_digital_twin_device
  });
}
var DigitalTwinThings = {
  getBatchDigitalTwinThings,
  updateBatchAttributes,
  updateSingleThingAttributes
};

function getBatchInfomodelByValue({
  tenant_id,
  label_id,
  label_value
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/info-model-list`,
    method: "get",
    params: {
      label_id,
      label_value
    }
  });
}
var InfoModel = {
  getBatchInfomodelByValue
};

function sendMessagesToDevice({
  tenant_id,
  things_id,
  info
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/things/${things_id}/messages`,
    method: "post",
    data: info
  });
}
function sendBatchMessagesByThingsSelector({
  tenant_id,
  headers,
  payload,
  things_selector
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/messages`,
    method: "post",
    data: {
      headers,
      payload,
      things_selector
    }
  });
}
function getBatchMessagesData({
  tenant_id,
  batch_no,
  current_page = 1,
  page_size = 100
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/message-batches/${batch_no}/messages`,
    method: "get",
    params: {
      current_page,
      page_size
    }
  });
}
function getMessagesResponse({
  tenant_id,
  message_ids,
  start_date,
  file_index,
  offset
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/messages/${message_ids}/response`,
    method: "get",
    params: {
      startDate: start_date,
      file_index,
      offset
    }
  });
}
function getBatchMessagesResponse({
  message_ids,
  start_date
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/messages/response`,
    method: "get",
    params: {
      startDate: start_date,
      messageIds: message_ids
    }
  });
}
function getMessagesResponseByCorrelation({
  correlation_id,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/correlation-id/${correlation_id}/message`,
    method: "get"
  });
}
var Messages = {
  sendMessagesToDevice,
  sendBatchMessagesByThingsSelector,
  getBatchMessagesData,
  getMessagesResponse,
  getBatchMessagesResponse,
  getMessagesResponseByCorrelation
};

function addSingleThings({
  tenant_id,
  api_base_things_request
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/things`,
    method: "post",
    data: api_base_things_request
  });
}
function getBatchThings({
  tenant_id,
  current_page,
  info_model_ids,
  label_id,
  label_value,
  is_online,
  namespace,
  page_size,
  prefix,
  things_type,
  third_things_id,
  connection_status,
  order_type,
  order_param
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/things`,
    method: "get",
    params: {
      current_page,
      info_model_ids,
      label_id,
      label_value,
      is_online,
      namespace,
      page_size,
      prefix,
      things_type,
      third_things_id,
      connection_status,
      order_type,
      order_param
    }
  });
}
function getSingleThing({
  id,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/things/${id}`,
    method: "get"
  });
}
function getBatchThingsWithoutPage({
  query_label,
  tenant_id,
  things_ids,
  type
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/things/without-page`,
    method: "get",
    params: {
      query_label,
      things_ids,
      type
    }
  });
}
function getBatchSubThings({
  info_model_id,
  third_things_id,
  page_size,
  current_page
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/info-models/${info_model_id}/things/${third_things_id}/children-things`,
    method: "get",
    params: {
      page_size,
      current_page
    }
  });
}
function getBatchSubThingsByParents({
  tenant_id,
  parent_things_ids,
  current_page,
  page_size
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/parent-things/${parent_things_ids}/children-things`,
    method: "get",
    params: {
      page_size,
      current_page
    }
  });
}
function getSingleThingParents({
  third_things_id,
  info_model_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/info-models/${info_model_id}/things/${third_things_id}/parents`,
    method: "get"
  });
}
function getBatchThingsOfGateway({
  tenant_id,
  things_id,
  page_size,
  current_page
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/things/gw-tings/${things_id}`,
    method: "get",
    params: {
      page_size,
      current_page
    }
  });
}
function getOutPutAllThings({
  tenant_id,
  info_model_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/things/download-things-file`,
    method: "get",
    responseType: "arraybuffer",
    params: {
      infoModelId: info_model_id
    },
    header: {
      Accept: "*/*"
    }
  });
}
function getOutPutThings({
  tenant_id,
  info_model_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/things/${info_model_id}/download-things-file`,
    method: "get",
    responseType: "arraybuffer",
    header: {
      Accept: "*/*"
    }
  });
}
function addImportThings({
  tenant_id,
  file
}, fetchParams) {
  let formData = new FormData();
  formData.append("file", file, file.name);
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/import-things`,
    method: "post",
    data: formData
  });
}
function updateSingleThings({
  tenant_id,
  id,
  api_base_things_request
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/things/${id}`,
    method: "put",
    data: api_base_things_request
  });
}
function updateBatchThingsAttr({
  tenant_id,
  info_model_id,
  api_batch_update_things_request
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/things/${info_model_id}/batch-update`,
    method: "post",
    data: api_batch_update_things_request
  });
}
function updateBatchThingsConfiguration({
  tenant_id,
  info_model_id,
  api_batch_update_things_request
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/things/${info_model_id}/batch-update-configuration`,
    method: "post",
    data: api_batch_update_things_request
  });
}
function deleteBatchThings({
  ids,
  tenant_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/things/${ids}`,
    method: "delete"
  });
}
function getBatchThingsNumByDevtype({
  tenant_id,
  info_model_ids,
  show_hidden_device
}, fetchParams) {
  if (Array.isArray(info_model_ids)) {
    info_model_ids = info_model_ids.toString();
  }

  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/info-model-ids/${info_model_ids}/things/number`,
    method: "get",
    params: {
      show_hidden_device
    }
  });
}
function getBatchThingsInfoByThirdThingsIdOrInfoModelId({
  current_page = 1,
  info_model_id,
  page_size = 20,
  third_things_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/things/${third_things_id}/things-info`,
    method: "get",
    params: {
      current_page,
      info_model_id,
      page_size
    }
  });
}
function updateSingleThingsConnectionStatus({
  connection_status,
  tenant_id,
  things_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/things/${things_id}/connection-status/${connection_status}`,
    method: "put"
  });
}
function checkSingleThingIsExisted({
  info_model_id,
  third_things_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/info-models/${info_model_id}/things/${third_things_id}/check`,
    method: "get",
    params: {
      info_model_id,
      third_things_id
    }
  });
}
function bindSingleThingRole({
  tenant_id,
  user_id,
  third_things_id,
  info_model_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/user/${user_id}/things/auto-bind`,
    method: "put",
    params: {
      infoModelId: info_model_id,
      thirdThingsId: third_things_id
    }
  });
}
var Things = {
  addSingleThings,
  getBatchThings,
  getSingleThing,
  getBatchThingsWithoutPage,
  getBatchSubThings,
  getBatchSubThingsByParents,
  getSingleThingParents,
  getBatchThingsOfGateway,
  getOutPutAllThings,
  getOutPutThings,
  addImportThings,
  updateSingleThings,
  updateBatchThingsAttr,
  updateBatchThingsConfiguration,
  deleteBatchThings,
  getBatchThingsNumByDevtype,
  getBatchThingsInfoByThirdThingsIdOrInfoModelId,
  updateSingleThingsConnectionStatus,
  checkSingleThingIsExisted,
  bindSingleThingRole
};

function addSingleThingsLabels({
  tenant_id,
  things_id,
  label_id,
  labels
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/things/${things_id}/labels/${label_id}/relations`,
    method: "post",
    data: labels
  });
}
function getThingsLabelValuesByLabelId({
  tenant_id,
  label_id,
  page_size,
  current_page,
  fuzzy
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/labels/${label_id}/things-label-values`,
    method: "get",
    params: {
      page_size,
      current_page,
      fuzzy
    }
  });
}
function getBatchThingsLabels({
  tenant_id,
  things_id,
  page_size,
  label_id,
  label_value,
  current_page
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/things/${things_id}/labels`,
    method: "get",
    params: {
      page_size,
      current_page,
      labelId: label_id,
      labelValue: label_value,
      things_id
    }
  });
}
function deleteAllThingsLabels({
  tenant_id,
  things_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/things/${things_id}/labels`,
    method: "delete"
  });
}
var ThingsLabel = {
  addSingleThingsLabels,
  getThingsLabelValuesByLabelId,
  getBatchThingsLabels,
  deleteAllThingsLabels
};

function getMaintenanceThings({
  current_page = 1,
  end_date,
  info_model_id,
  info_model_keywords,
  is_online,
  label_id,
  label_value,
  namespace,
  offline_reasons,
  page_size = 20,
  prefix,
  start_date,
  tenant_id,
  tenant_name,
  things_type,
  third_things_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/maintance/things`,
    method: "get",
    params: {
      current_page,
      end_date,
      info_model_id,
      info_model_keywords,
      is_online,
      label_id,
      label_value,
      namespace,
      offline_reasons,
      page_size,
      prefix,
      start_date,
      tenant_id,
      tenant_name,
      things_type,
      third_things_id
    }
  });
}
function getBatchLogoutHistory({
  current_page = 1,
  page_size = 20,
  start_date,
  end_date,
  offline_reason,
  things_id
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/maintance/${things_id}/logout-history`,
    method: "get",
    params: {
      current_page,
      end_date,
      offline_reason,
      page_size,
      start_date
    }
  });
}
var ThingsMaintenance = {
  getMaintenanceThings,
  getBatchLogoutHistory
};

function getAllThingsUsageStatistics(fetchParams) {
  return fetch({ ...fetchParams,
    url: "/things/tenants/all/usage-statistics",
    method: "get"
  });
}
var ThingsUsageStatistics = {
  getAllThingsUsageStatistics
};

function getSingleUserBindThings({
  tenant_id,
  user_id,
  include_create,
  is_manager
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/users/${user_id}/things`,
    method: "get",
    params: {
      include_create,
      is_manager
    }
  }, "things:user-things:query");
}
function updateSingleUserBindThings({
  tenant_id,
  user_id,
  data
}, fetchParams) {
  return fetch({ ...fetchParams,
    url: `/things/tenants/${tenant_id}/users/${user_id}/things`,
    method: "put",
    data
  }, "things:user-things:update");
}
var ThingsUserResource = {
  getSingleUserBindThings,
  updateSingleUserBindThings
};

var ZWSCom = {};

var ZWSPagination = {};

var api = {
  ZWSHttpErrorsModule: controllers,
  ZWSBaseModule,
  AlertEvents,
  AlertMgmtTenants,
  EdgeComputiong,
  RuleActions,
  RuleActionsRecovery,
  ThingsForwardRules,
  TriggerRules,
  TwinsRules,
  ConnectionController,
  ConnectionLabelController,
  ConnectionTargetController,
  ThingsMessageController,
  MyPrivilege,
  Organization,
  Session,
  TenantAPI,
  TenantRole,
  Usercenter,
  UserPrivilege,
  CustomDataDownloadTemplate,
  DashboardController,
  DataCleaning,
  DataMgmtUsageStatistics,
  DataMgmtUserResource,
  DataTransform,
  DataUserResource,
  OpLog,
  Statistics,
  StatisticsExportTransform,
  StatisticsMethods,
  StatisticsTask,
  StatisticsTaskJrnl,
  StatisticSync,
  TenantUsage,
  ThingsDataController,
  HandlerAction,
  Job,
  JobLog,
  Category,
  CategoryTemplate,
  DBC,
  InfoModelMapping,
  IotEntity,
  IotFunctionBlock,
  iotInfoModel,
  MappingRuleInfo,
  Message,
  PushLogs,
  SMS,
  CouponSys,
  CouponTenant,
  Order,
  Package,
  PackageItem,
  StageDiscount,
  Tools,
  Component,
  File,
  FileManagerPackage,
  Plan,
  Download,
  Firmware,
  Device,
  Group,
  GroupPlus,
  GroupPrice,
  GroupStatistics,
  GroupStrategy,
  GroupUserResource,
  Hmi,
  HmiUserResource,
  Web,
  Project,
  ProjectResource,
  Config,
  Deploy,
  Log,
  Notice,
  ServerConfig,
  User,
  Behavior,
  IndustryES,
  Repair,
  WorkOrder,
  WrapperGroup,
  WrapperMessages,
  WrapperThings,
  binding,
  CandtuThings,
  dtc,
  ecu,
  LorawanThings,
  MulticastGroup,
  OpcuaThings,
  ZigbeeGroup,
  ZigbeeMember,
  Binding,
  Dtc,
  Ecu,
  Lorawan,
  Opcua,
  Work,
  Zigbee,
  Labels,
  Simpool,
  TenantExport,
  TenantMenu,
  Tenants,
  TenantUsers,
  UserAttr,
  UserMessage,
  Users,
  UserTenants,
  VerificationCodes,
  ZwsThirdLogin,
  DigitalTwinThings,
  InfoModel,
  Messages,
  Things,
  ThingsLabel,
  ThingsMaintenance,
  ThingsUsageStatistics,
  ThingsUserResource,
  ZWSCom,
  ZWSPagination
};

const apiModule = {};

for (const key in api) {
  for (const apiKey in api[key]) {
    apiModule[apiKey] = api[key][apiKey];
  }
}

function registerApi(target) {
  if (!Array.isArray(target)) target = [target];
  target.forEach(item => {
    apiModule[item.apiName] = data => item.apiFunc(data, fetch);
  });
}

let _http = axios__default["default"].create({
  headers: {
    "Accept": "application/json",
    "Content-Type": "application/json"
  }
});
function setRequestIntercepter(callback) {
  _http.interceptors.request.use(callback, (error) => {
    return Promise.reject(error);
  });
}
function setResponseIntercepter(callback) {
  _http.interceptors.response.use(callback, (error) => {
    var _a;
    if (((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) === 401) {
      window.location.replace(`${window.location.origin}${window.location.pathname}#/Login`);
    }
    return Promise.reject(error);
  });
}
setResponseIntercepter((response) => {
  return response;
});
setFetch(function({
  url,
  method,
  data,
  params,
  timeout,
  responseType = void 0,
  abortController,
  header
}) {
  if (!header)
    header = generateHttpHeader();
  else
    header = Object.assign(header, generateHttpHeader());
  if (!header.Authorization)
    header.Authorization = generateHttpAuthorization();
  return _http.request({
    url: getBaseUrl() + url,
    method,
    data,
    params,
    timeout: timeout || getGlobalTimeout(),
    responseType,
    headers: header,
    signal: abortController == null ? void 0 : abortController.signal
  }).then((res) => {
    if (responseType) {
      return res;
    }
    return res.data;
  }).catch((error) => {
    let result = {};
    if (axios__default["default"].isCancel(error)) {
      result = {
        status: "(canceled)",
        errorMsg: error.message
      };
    } else if (error.response) {
      result = {
        status: error.response.status,
        errorMsg: error.response.statusText,
        data: error.response.data
      };
    } else if (error.request) {
      result = {
        status: "NO_RESPONSE",
        errorMsg: "NO_RESPONSE"
      };
    } else {
      result.errorMsg = "Something happened in setting up the request that triggered an Error";
    }
    return Promise.reject(result);
  });
});
setGetStorage((key) => {
  return localStorage.getItem(key);
});
setSetStorage((key, value) => {
  return localStorage.setItem(key, value);
});
setRemoveStorage((key) => {
  return localStorage.removeItem(key);
});

exports.addBatchAlertAction = addBatchAlertAction;
exports.addBatchAlertActionRecovery = addBatchAlertActionRecovery;
exports.addBatchDevicesBindToGroup = addBatchDevicesBindToGroup;
exports.addBatchMulticastGroupDevices = addBatchMulticastGroupDevices;
exports.addBatchUsersBindBatchGroups = addBatchUsersBindBatchGroups;
exports.addComponentConfig = addComponentConfig;
exports.addConnection = addConnection;
exports.addConnectionLabel = addConnectionLabel;
exports.addCustomDownloadTemplate = addCustomDownloadTemplate;
exports.addFunctionBlockAndInfoModel = addFunctionBlockAndInfoModel;
exports.addImportFunctionBlock = addImportFunctionBlock;
exports.addImportThings = addImportThings;
exports.addImportWrapperThings = addImportWrapperThings;
exports.addInfoModelMappingWithItem = addInfoModelMappingWithItem;
exports.addPlans = addPlans;
exports.addServerConfig = addServerConfig;
exports.addSessions = addSessions;
exports.addSessionsForTenantManager = addSessionsForTenantManager;
exports.addSingleAdminUser = addSingleAdminUser;
exports.addSingleAlertRule = addSingleAlertRule;
exports.addSingleBatchMulticastGroupDevices = addSingleBatchMulticastGroupDevices;
exports.addSingleCandtuDTCConfig = addSingleCandtuDTCConfig;
exports.addSingleCandtuECU = addSingleCandtuECU;
exports.addSingleCandtuECUBinding = addSingleCandtuECUBinding;
exports.addSingleCandtuThings = addSingleCandtuThings;
exports.addSingleCoupon = addSingleCoupon;
exports.addSingleDTCConfig = addSingleDTCConfig;
exports.addSingleDataDashbord = addSingleDataDashbord;
exports.addSingleDataDashbordPanel = addSingleDataDashbordPanel;
exports.addSingleDataDashbordPanelThingsMetrics = addSingleDataDashbordPanelThingsMetrics;
exports.addSingleDeviceCategory = addSingleDeviceCategory;
exports.addSingleECU = addSingleECU;
exports.addSingleECUBinding = addSingleECUBinding;
exports.addSingleEdgeRule = addSingleEdgeRule;
exports.addSingleEntity = addSingleEntity;
exports.addSingleFirmware = addSingleFirmware;
exports.addSingleFunctionBlock = addSingleFunctionBlock;
exports.addSingleGroup = addSingleGroup;
exports.addSingleGroupCollect = addSingleGroupCollect;
exports.addSingleGroupPrice = addSingleGroupPrice;
exports.addSingleGroupStrategy = addSingleGroupStrategy;
exports.addSingleInfoModel = addSingleInfoModel;
exports.addSingleJob = addSingleJob;
exports.addSingleLorawanThings = addSingleLorawanThings;
exports.addSingleMappingRuleInfos = addSingleMappingRuleInfos;
exports.addSingleMulticastGroup = addSingleMulticastGroup;
exports.addSingleNotice = addSingleNotice;
exports.addSingleOpcuaThings = addSingleOpcuaThings;
exports.addSingleOrder = addSingleOrder;
exports.addSingleOrganization = addSingleOrganization;
exports.addSingleOrganizationUser = addSingleOrganizationUser;
exports.addSinglePackageContentItem = addSinglePackageContentItem;
exports.addSingleProject = addSingleProject;
exports.addSingleReceipt = addSingleReceipt;
exports.addSingleRepair = addSingleRepair;
exports.addSingleReport = addSingleReport;
exports.addSingleRole = addSingleRole;
exports.addSingleSimPool = addSingleSimPool;
exports.addSingleSingleLorawanThings = addSingleSingleLorawanThings;
exports.addSingleSingleMulticastGroup = addSingleSingleMulticastGroup;
exports.addSingleSingleOpcuaThings = addSingleSingleOpcuaThings;
exports.addSingleSingleWorkOrder = addSingleSingleWorkOrder;
exports.addSingleSingleZigbeeGroup = addSingleSingleZigbeeGroup;
exports.addSingleSingleZigbeeMember = addSingleSingleZigbeeMember;
exports.addSingleStatisticsExportTransformPlugin = addSingleStatisticsExportTransformPlugin;
exports.addSingleStatisticsMethod = addSingleStatisticsMethod;
exports.addSingleStatisticsTask = addSingleStatisticsTask;
exports.addSingleStatisticsTimerTask = addSingleStatisticsTimerTask;
exports.addSingleSubUser = addSingleSubUser;
exports.addSingleSubUserTenents = addSingleSubUserTenents;
exports.addSingleTenantCoupons = addSingleTenantCoupons;
exports.addSingleTenantLabel = addSingleTenantLabel;
exports.addSingleTenantMenu = addSingleTenantMenu;
exports.addSingleThings = addSingleThings;
exports.addSingleThingsForwardRule = addSingleThingsForwardRule;
exports.addSingleThingsLabels = addSingleThingsLabels;
exports.addSingleTwinsRule = addSingleTwinsRule;
exports.addSingleUserBehavior = addSingleUserBehavior;
exports.addSingleUserSelfConfig = addSingleUserSelfConfig;
exports.addSingleUserTenants = addSingleUserTenants;
exports.addSingleWorkOrder = addSingleWorkOrder;
exports.addSingleWrapperThings = addSingleWrapperThings;
exports.addSingleZigbeeGroup = addSingleZigbeeGroup;
exports.addSingleZigbeeMember = addSingleZigbeeMember;
exports.addTarget = addTarget;
exports.addThingsForwardAction = addThingsForwardAction;
exports.adminLogout = adminLogout;
exports.adminlogin = adminlogin;
exports.apiModule = apiModule;
exports.bindSingleThingRole = bindSingleThingRole;
exports.bindThirdLoginUCUser = bindThirdLoginUCUser;
exports.bindThirdLoginUser = bindThirdLoginUser;
exports.cancelSingleOrder = cancelSingleOrder;
exports.checkPermissionWithApiNames = checkPermissionWithApiNames;
exports.checkSingleThingIsExisted = checkSingleThingIsExisted;
exports.checkTenantIsManager = checkTenantIsManager;
exports.checkThirdLoginAuth = checkThirdLoginAuth;
exports.checkUserTenantValidate = checkUserTenantValidate;
exports.checkUserTenantValidateZWS = checkUserTenantValidateZWS;
exports.cleanFiles = cleanFiles;
exports.createQuickDeleteTask = createQuickDeleteTask;
exports.createSingleHmis = createSingleHmis;
exports.createSinglePlugin = createSinglePlugin;
exports["default"] = api;
exports.deleteAllAlertEvents = deleteAllAlertEvents;
exports.deleteAllJobLog = deleteAllJobLog;
exports.deleteAllThingsLabels = deleteAllThingsLabels;
exports.deleteBatchAlertActions = deleteBatchAlertActions;
exports.deleteBatchAlertActionsRecovery = deleteBatchAlertActionsRecovery;
exports.deleteBatchAlertEvents = deleteBatchAlertEvents;
exports.deleteBatchComponentByAdmin = deleteBatchComponentByAdmin;
exports.deleteBatchDataDashbordPanelThingsMetrics = deleteBatchDataDashbordPanelThingsMetrics;
exports.deleteBatchDevicesOfGroup = deleteBatchDevicesOfGroup;
exports.deleteBatchFunctionBlockEvent = deleteBatchFunctionBlockEvent;
exports.deleteBatchGroups = deleteBatchGroups;
exports.deleteBatchJobLogs = deleteBatchJobLogs;
exports.deleteBatchLog = deleteBatchLog;
exports.deleteBatchMulticastGroupDevices = deleteBatchMulticastGroupDevices;
exports.deleteBatchMulticastGroupIds = deleteBatchMulticastGroupIds;
exports.deleteBatchRoles = deleteBatchRoles;
exports.deleteBatchSubUsers = deleteBatchSubUsers;
exports.deleteBatchTenantLabels = deleteBatchTenantLabels;
exports.deleteBatchThings = deleteBatchThings;
exports.deleteComponentConfig = deleteComponentConfig;
exports.deleteConnectionLabels = deleteConnectionLabels;
exports.deleteConnections = deleteConnections;
exports.deleteCustomDownloadTemplateById = deleteCustomDownloadTemplateById;
exports.deleteDataLogs = deleteDataLogs;
exports.deleteEdgeIssuanceHistories = deleteEdgeIssuanceHistories;
exports.deleteFiles = deleteFiles;
exports.deletePackage = deletePackage;
exports.deletePlans = deletePlans;
exports.deleteProjectResourcesRelation = deleteProjectResourcesRelation;
exports.deleteSessions = deleteSessions;
exports.deleteSingleAdminUser = deleteSingleAdminUser;
exports.deleteSingleBatchMulticastGroupDevices = deleteSingleBatchMulticastGroupDevices;
exports.deleteSingleBatchMulticastGroupIds = deleteSingleBatchMulticastGroupIds;
exports.deleteSingleCandtuDTCConfig = deleteSingleCandtuDTCConfig;
exports.deleteSingleCandtuECU = deleteSingleCandtuECU;
exports.deleteSingleCoupon = deleteSingleCoupon;
exports.deleteSingleDBCFile = deleteSingleDBCFile;
exports.deleteSingleDTCConfig = deleteSingleDTCConfig;
exports.deleteSingleDataDashbord = deleteSingleDataDashbord;
exports.deleteSingleDataDashbordPanel = deleteSingleDataDashbordPanel;
exports.deleteSingleDataDashbordPanelThingsMetrics = deleteSingleDataDashbordPanelThingsMetrics;
exports.deleteSingleDeviceCategory = deleteSingleDeviceCategory;
exports.deleteSingleECU = deleteSingleECU;
exports.deleteSingleEdgeRule = deleteSingleEdgeRule;
exports.deleteSingleEntity = deleteSingleEntity;
exports.deleteSingleFirmware = deleteSingleFirmware;
exports.deleteSingleFunctionBlock = deleteSingleFunctionBlock;
exports.deleteSingleGroupCollect = deleteSingleGroupCollect;
exports.deleteSingleGroupPrice = deleteSingleGroupPrice;
exports.deleteSingleInfoModel = deleteSingleInfoModel;
exports.deleteSingleJob = deleteSingleJob;
exports.deleteSingleJobLog = deleteSingleJobLog;
exports.deleteSingleMappingRuleInfos = deleteSingleMappingRuleInfos;
exports.deleteSingleOrganization = deleteSingleOrganization;
exports.deleteSingleOrganizationUser = deleteSingleOrganizationUser;
exports.deleteSinglePackageContentItem = deleteSinglePackageContentItem;
exports.deleteSinglePlugin = deleteSinglePlugin;
exports.deleteSingleProjectById = deleteSingleProjectById;
exports.deleteSingleRepair = deleteSingleRepair;
exports.deleteSingleRule = deleteSingleRule;
exports.deleteSingleSimPool = deleteSingleSimPool;
exports.deleteSingleSingleWorkOrder = deleteSingleSingleWorkOrder;
exports.deleteSingleSingleZigbeeGroup = deleteSingleSingleZigbeeGroup;
exports.deleteSingleSingleZigbeeMember = deleteSingleSingleZigbeeMember;
exports.deleteSingleStatisticsExportTransformPlugin = deleteSingleStatisticsExportTransformPlugin;
exports.deleteSingleStatisticsMethod = deleteSingleStatisticsMethod;
exports.deleteSingleStatisticsTask = deleteSingleStatisticsTask;
exports.deleteSingleSubUser = deleteSingleSubUser;
exports.deleteSingleTenantMenu = deleteSingleTenantMenu;
exports.deleteSingleThingsForwardRule = deleteSingleThingsForwardRule;
exports.deleteSingleTwinsRule = deleteSingleTwinsRule;
exports.deleteSingleUserFromGroup = deleteSingleUserFromGroup;
exports.deleteSingleWorkOrder = deleteSingleWorkOrder;
exports.deleteSingleZigbeeGroup = deleteSingleZigbeeGroup;
exports.deleteSingleZigbeeMember = deleteSingleZigbeeMember;
exports.deleteSpecialStorage = deleteSpecialStorage;
exports.deleteTargets = deleteTargets;
exports.deleteThingsData = deleteThingsData;
exports.deleteThingsForwardAction = deleteThingsForwardAction;
exports.deleteUserMessage = deleteUserMessage;
exports.deleteUserSelfConfig = deleteUserSelfConfig;
exports.deleteWebInfo = deleteWebInfo;
exports.deviceUploadPart = deviceUploadPart;
exports.downloadBatchTenantAlertEventData = downloadBatchTenantAlertEventData;
exports.downloadCandtuDTCTemplate = downloadCandtuDTCTemplate;
exports.downloadDTCTemplate = downloadDTCTemplate;
exports.downloadFile = downloadFile;
exports.downloadTenantCsvFile = downloadTenantCsvFile;
exports.downloadTenantStatisticsDataResult = downloadTenantStatisticsDataResult;
exports.executeSingleStatisticsTask = executeSingleStatisticsTask;
exports.fetch = fetch;
exports.generateHttpAuthorization = generateHttpAuthorization;
exports.generateHttpHeader = generateHttpHeader;
exports.getAdminLogList = getAdminLogList;
exports.getAllPackages = getAllPackages;
exports.getAllTenantUsageStatistics = getAllTenantUsageStatistics;
exports.getAllThingsUsageStatistics = getAllThingsUsageStatistics;
exports.getAllUsageBytesCountStatistics = getAllUsageBytesCountStatistics;
exports.getBaseUrl = getBaseUrl;
exports.getBatchAdminUserList = getBatchAdminUserList;
exports.getBatchAlertEvents = getBatchAlertEvents;
exports.getBatchBindDashbord = getBatchBindDashbord;
exports.getBatchBindGroupIds = getBatchBindGroupIds;
exports.getBatchCanReceiveCoupons = getBatchCanReceiveCoupons;
exports.getBatchCandtuDTCConfig = getBatchCandtuDTCConfig;
exports.getBatchCandtuECU = getBatchCandtuECU;
exports.getBatchCleanTaskDocumentRemaining = getBatchCleanTaskDocumentRemaining;
exports.getBatchComponentByAdmin = getBatchComponentByAdmin;
exports.getBatchComponentConfig = getBatchComponentConfig;
exports.getBatchCoupons = getBatchCoupons;
exports.getBatchDBCFileList = getBatchDBCFileList;
exports.getBatchDTCConfig = getBatchDTCConfig;
exports.getBatchDashbords = getBatchDashbords;
exports.getBatchDeviceCategory = getBatchDeviceCategory;
exports.getBatchDigitalTwinThings = getBatchDigitalTwinThings;
exports.getBatchECU = getBatchECU;
exports.getBatchEdgeComputingRules = getBatchEdgeComputingRules;
exports.getBatchEdgeRuleIssuanceHistory = getBatchEdgeRuleIssuanceHistory;
exports.getBatchEntities = getBatchEntities;
exports.getBatchFirmwares = getBatchFirmwares;
exports.getBatchFunctionBlockEvent = getBatchFunctionBlockEvent;
exports.getBatchFunctionBlocks = getBatchFunctionBlocks;
exports.getBatchGroupBindDevices = getBatchGroupBindDevices;
exports.getBatchGroupDatas = getBatchGroupDatas;
exports.getBatchGroupDatasWithMultiCondition = getBatchGroupDatasWithMultiCondition;
exports.getBatchGroupDeviceStatisticsDatas = getBatchGroupDeviceStatisticsDatas;
exports.getBatchGroupList = getBatchGroupList;
exports.getBatchGroupListByIds = getBatchGroupListByIds;
exports.getBatchGroupOnlineStatusPlus = getBatchGroupOnlineStatusPlus;
exports.getBatchGroupOrderedListByIds = getBatchGroupOrderedListByIds;
exports.getBatchGroupPlusList = getBatchGroupPlusList;
exports.getBatchGroupPrices = getBatchGroupPrices;
exports.getBatchGroupWithDevDatas = getBatchGroupWithDevDatas;
exports.getBatchGroupsByGroupIds = getBatchGroupsByGroupIds;
exports.getBatchHandlerActions = getBatchHandlerActions;
exports.getBatchHmis = getBatchHmis;
exports.getBatchHmisByAdmin = getBatchHmisByAdmin;
exports.getBatchHmisWeb = getBatchHmisWeb;
exports.getBatchHmisWebByAdmin = getBatchHmisWebByAdmin;
exports.getBatchHmisWebRelease = getBatchHmisWebRelease;
exports.getBatchInfoModelByIds = getBatchInfoModelByIds;
exports.getBatchInfoModelByName = getBatchInfoModelByName;
exports.getBatchInfoModelByNameForTenant = getBatchInfoModelByNameForTenant;
exports.getBatchInfoModels = getBatchInfoModels;
exports.getBatchInfomodelByValue = getBatchInfomodelByValue;
exports.getBatchJobLogs = getBatchJobLogs;
exports.getBatchJobs = getBatchJobs;
exports.getBatchLabelByIds = getBatchLabelByIds;
exports.getBatchLatestTwinsRules = getBatchLatestTwinsRules;
exports.getBatchLog = getBatchLog;
exports.getBatchLogoutHistory = getBatchLogoutHistory;
exports.getBatchMappingRuleInfos = getBatchMappingRuleInfos;
exports.getBatchMessagesData = getBatchMessagesData;
exports.getBatchMessagesResponse = getBatchMessagesResponse;
exports.getBatchMulticastGroupDevices = getBatchMulticastGroupDevices;
exports.getBatchMulticastGroupIds = getBatchMulticastGroupIds;
exports.getBatchMulticastGroups = getBatchMulticastGroups;
exports.getBatchMyMessages = getBatchMyMessages;
exports.getBatchNotice = getBatchNotice;
exports.getBatchOrdersAdmin = getBatchOrdersAdmin;
exports.getBatchOrdersCloud = getBatchOrdersCloud;
exports.getBatchOrganizationTree = getBatchOrganizationTree;
exports.getBatchOrganizationUsers = getBatchOrganizationUsers;
exports.getBatchOrganizations = getBatchOrganizations;
exports.getBatchPackageItem = getBatchPackageItem;
exports.getBatchPackagesAdmin = getBatchPackagesAdmin;
exports.getBatchPackagesCloud = getBatchPackagesCloud;
exports.getBatchPlugins = getBatchPlugins;
exports.getBatchProject = getBatchProject;
exports.getBatchProjectResources = getBatchProjectResources;
exports.getBatchPublicEntities = getBatchPublicEntities;
exports.getBatchRepairs = getBatchRepairs;
exports.getBatchRolesList = getBatchRolesList;
exports.getBatchRuleActionRecovery = getBatchRuleActionRecovery;
exports.getBatchRuleActions = getBatchRuleActions;
exports.getBatchRules = getBatchRules;
exports.getBatchSimPoolList = getBatchSimPoolList;
exports.getBatchSingleWorkOrders = getBatchSingleWorkOrders;
exports.getBatchSms = getBatchSms;
exports.getBatchStatisticsResultExportTransformPlugins = getBatchStatisticsResultExportTransformPlugins;
exports.getBatchSubThings = getBatchSubThings;
exports.getBatchSubThingsByParents = getBatchSubThingsByParents;
exports.getBatchSubUsers = getBatchSubUsers;
exports.getBatchSubUsersWithAuth = getBatchSubUsersWithAuth;
exports.getBatchSubuserRoles = getBatchSubuserRoles;
exports.getBatchTaskAggStatisticsByDimension = getBatchTaskAggStatisticsByDimension;
exports.getBatchTenantAlertEventData = getBatchTenantAlertEventData;
exports.getBatchTenantApis = getBatchTenantApis;
exports.getBatchTenantAudit = getBatchTenantAudit;
exports.getBatchTenantCoupons = getBatchTenantCoupons;
exports.getBatchTenantInfomodels = getBatchTenantInfomodels;
exports.getBatchTenantLabels = getBatchTenantLabels;
exports.getBatchTenantMenu = getBatchTenantMenu;
exports.getBatchTenantStatisticsMethods = getBatchTenantStatisticsMethods;
exports.getBatchTenantStatisticsTasks = getBatchTenantStatisticsTasks;
exports.getBatchTenantUsageByTime = getBatchTenantUsageByTime;
exports.getBatchTenants = getBatchTenants;
exports.getBatchThingDatasByModel = getBatchThingDatasByModel;
exports.getBatchThings = getBatchThings;
exports.getBatchThingsByIds = getBatchThingsByIds;
exports.getBatchThingsForwardRules = getBatchThingsForwardRules;
exports.getBatchThingsInfoByThirdThingsIdOrInfoModelId = getBatchThingsInfoByThirdThingsIdOrInfoModelId;
exports.getBatchThingsLabels = getBatchThingsLabels;
exports.getBatchThingsMessageTraces = getBatchThingsMessageTraces;
exports.getBatchThingsNumByDevtype = getBatchThingsNumByDevtype;
exports.getBatchThingsOfGateway = getBatchThingsOfGateway;
exports.getBatchThingsWithoutPage = getBatchThingsWithoutPage;
exports.getBatchThirdSupport = getBatchThirdSupport;
exports.getBatchToDoCleanTasks = getBatchToDoCleanTasks;
exports.getBatchTwinsRules = getBatchTwinsRules;
exports.getBatchUnbindGroupUsers = getBatchUnbindGroupUsers;
exports.getBatchUserAlertStatistics = getBatchUserAlertStatistics;
exports.getBatchUserBehaviors = getBatchUserBehaviors;
exports.getBatchUserBehaviorsSortByAction = getBatchUserBehaviorsSortByAction;
exports.getBatchUserBehaviorsSortByModule = getBatchUserBehaviorsSortByModule;
exports.getBatchUserBehaviorsSortByTenant = getBatchUserBehaviorsSortByTenant;
exports.getBatchUsersByGroupId = getBatchUsersByGroupId;
exports.getBatchVerificationCodes = getBatchVerificationCodes;
exports.getBatchWorkOrders = getBatchWorkOrders;
exports.getBatchZigbeeGroups = getBatchZigbeeGroups;
exports.getBatchZigbeeMembers = getBatchZigbeeMembers;
exports.getBindDashbord = getBindDashbord;
exports.getBindHmis = getBindHmis;
exports.getCommonRoles = getCommonRoles;
exports.getComponentConfigAggregation = getComponentConfigAggregation;
exports.getComponentConfigOrder = getComponentConfigOrder;
exports.getConfigInfo = getConfigInfo;
exports.getConnection = getConnection;
exports.getConnectionLabel = getConnectionLabel;
exports.getConnectionLabels = getConnectionLabels;
exports.getCustomDownloadTemplate = getCustomDownloadTemplate;
exports.getDBCMessageList = getDBCMessageList;
exports.getDataDownloadList = getDataDownloadList;
exports.getDataLogs = getDataLogs;
exports.getDeviceGlobalTemplate = getDeviceGlobalTemplate;
exports.getDeviceGpsHistoryData = getDeviceGpsHistoryData;
exports.getDownloadUrl = getDownloadUrl;
exports.getExportFunctionBlock = getExportFunctionBlock;
exports.getFileList = getFileList;
exports.getFiles = getFiles;
exports.getGlobalTimeout = getGlobalTimeout;
exports.getHistory = getHistory;
exports.getLastPackage = getLastPackage;
exports.getMaintenanceThings = getMaintenanceThings;
exports.getMessage = getMessage;
exports.getMessageStatistics = getMessageStatistics;
exports.getMessagesResponse = getMessagesResponse;
exports.getMessagesResponseByCorrelation = getMessagesResponseByCorrelation;
exports.getOpLog = getOpLog;
exports.getOriginHistory = getOriginHistory;
exports.getOutPutAllThings = getOutPutAllThings;
exports.getOutPutThings = getOutPutThings;
exports.getPackageInfo = getPackageInfo;
exports.getPlans = getPlans;
exports.getPluginsByType = getPluginsByType;
exports.getPrivilegeSelf = getPrivilegeSelf;
exports.getQueryDownloadDeviceData = getQueryDownloadDeviceData;
exports.getSelfUserInfo = getSelfUserInfo;
exports.getServerConfig = getServerConfig;
exports.getSingleAlertEvents = getSingleAlertEvents;
exports.getSingleAlertEventsDownloadRecord = getSingleAlertEventsDownloadRecord;
exports.getSingleAlertRule = getSingleAlertRule;
exports.getSingleAllTenantSpecification = getSingleAllTenantSpecification;
exports.getSingleAllUsageStatistics = getSingleAllUsageStatistics;
exports.getSingleAssessDeploy = getSingleAssessDeploy;
exports.getSingleAssessTps = getSingleAssessTps;
exports.getSingleBatchMulticastGroupDevices = getSingleBatchMulticastGroupDevices;
exports.getSingleBatchMulticastGroupIds = getSingleBatchMulticastGroupIds;
exports.getSingleBatchMulticastGroups = getSingleBatchMulticastGroups;
exports.getSingleBatchZigbeeGroups = getSingleBatchZigbeeGroups;
exports.getSingleBatchZigbeeMembers = getSingleBatchZigbeeMembers;
exports.getSingleCandtuDTCConfig = getSingleCandtuDTCConfig;
exports.getSingleCandtuECUFirmwareUrl = getSingleCandtuECUFirmwareUrl;
exports.getSingleComponentConfig = getSingleComponentConfig;
exports.getSingleCurrentCleanTask = getSingleCurrentCleanTask;
exports.getSingleCurrentCleanTaskDocumentRemaining = getSingleCurrentCleanTaskDocumentRemaining;
exports.getSingleCurrentSystemTimestamp = getSingleCurrentSystemTimestamp;
exports.getSingleCustomization = getSingleCustomization;
exports.getSingleDBCFile = getSingleDBCFile;
exports.getSingleDTCConfig = getSingleDTCConfig;
exports.getSingleDashboard = getSingleDashboard;
exports.getSingleDataDashbordPanel = getSingleDataDashbordPanel;
exports.getSingleDataDashbordPanelThingsMetrics = getSingleDataDashbordPanelThingsMetrics;
exports.getSingleDeviceCategoryTemplate = getSingleDeviceCategoryTemplate;
exports.getSingleECUFirmwareUrl = getSingleECUFirmwareUrl;
exports.getSingleEdgeRule = getSingleEdgeRule;
exports.getSingleEntity = getSingleEntity;
exports.getSingleEntityInfo = getSingleEntityInfo;
exports.getSingleFirmwareDescription = getSingleFirmwareDescription;
exports.getSingleFnDataGroupDisplay = getSingleFnDataGroupDisplay;
exports.getSingleFunctionBlock = getSingleFunctionBlock;
exports.getSingleGroupDetails = getSingleGroupDetails;
exports.getSingleGroupFieldData = getSingleGroupFieldData;
exports.getSingleGroupPlus = getSingleGroupPlus;
exports.getSingleGroupPrice = getSingleGroupPrice;
exports.getSingleGroupStrategys = getSingleGroupStrategys;
exports.getSingleIncomePrediction = getSingleIncomePrediction;
exports.getSingleIndustryESStationStatisticsCount = getSingleIndustryESStationStatisticsCount;
exports.getSingleInfoModel = getSingleInfoModel;
exports.getSingleInfoModelInfo = getSingleInfoModelInfo;
exports.getSingleInfoModelMapping = getSingleInfoModelMapping;
exports.getSingleInfoModelPassword = getSingleInfoModelPassword;
exports.getSingleJobDetails = getSingleJobDetails;
exports.getSingleMappingRuleInfos = getSingleMappingRuleInfos;
exports.getSingleMappingRuleInfosByName = getSingleMappingRuleInfosByName;
exports.getSingleNewFirmwareInfo = getSingleNewFirmwareInfo;
exports.getSingleNoticeById = getSingleNoticeById;
exports.getSingleOrderAmount = getSingleOrderAmount;
exports.getSinglePackageTenant = getSinglePackageTenant;
exports.getSingleProject = getSingleProject;
exports.getSingleProjectResources = getSingleProjectResources;
exports.getSingleRepair = getSingleRepair;
exports.getSingleRole = getSingleRole;
exports.getSingleRoleMenu = getSingleRoleMenu;
exports.getSingleSignalPeriod = getSingleSignalPeriod;
exports.getSingleSingleWorkOrder = getSingleSingleWorkOrder;
exports.getSingleSingleZigbeeGroup = getSingleSingleZigbeeGroup;
exports.getSingleStationOverviewData = getSingleStationOverviewData;
exports.getSingleStatisticsExportTransformPlugin = getSingleStatisticsExportTransformPlugin;
exports.getSingleStatisticsMethod = getSingleStatisticsMethod;
exports.getSingleStatisticsSyncData = getSingleStatisticsSyncData;
exports.getSingleSubUserTree = getSingleSubUserTree;
exports.getSingleSubUsersById = getSingleSubUsersById;
exports.getSingleSubuserMenus = getSingleSubuserMenus;
exports.getSingleTenantBmsWithBcuMapping = getSingleTenantBmsWithBcuMapping;
exports.getSingleTenantByIdOrName = getSingleTenantByIdOrName;
exports.getSingleTenantLabel = getSingleTenantLabel;
exports.getSingleTenantSpecification = getSingleTenantSpecification;
exports.getSingleTenantStatisticsTask = getSingleTenantStatisticsTask;
exports.getSingleThing = getSingleThing;
exports.getSingleThingParents = getSingleThingParents;
exports.getSingleThingsData = getSingleThingsData;
exports.getSingleThingsDataAggregation = getSingleThingsDataAggregation;
exports.getSingleThingsForwardRule = getSingleThingsForwardRule;
exports.getSingleThingsInfoByTimeRange = getSingleThingsInfoByTimeRange;
exports.getSingleTwinsRule = getSingleTwinsRule;
exports.getSingleUsageStatistics = getSingleUsageStatistics;
exports.getSingleUserAlertStatistics = getSingleUserAlertStatistics;
exports.getSingleUserBindThings = getSingleUserBindThings;
exports.getSingleUserCustomization = getSingleUserCustomization;
exports.getSingleUserGroupOnlineStatus = getSingleUserGroupOnlineStatus;
exports.getSingleUserIndustryEsStatisticsCount = getSingleUserIndustryEsStatisticsCount;
exports.getSingleUserTopGroups = getSingleUserTopGroups;
exports.getSingleUserTopIndustryGroups = getSingleUserTopIndustryGroups;
exports.getSingleWorkOrder = getSingleWorkOrder;
exports.getSingleZigbeeGroup = getSingleZigbeeGroup;
exports.getSpecialStorageIndexList = getSpecialStorageIndexList;
exports.getTarget = getTarget;
exports.getTargets = getTargets;
exports.getTenantAuditStatistic = getTenantAuditStatistic;
exports.getTenantBatchStatisticReportSummary = getTenantBatchStatisticReportSummary;
exports.getTenantBatchStatisticTaskDimensionResult = getTenantBatchStatisticTaskDimensionResult;
exports.getTenantBatchTaskResult = getTenantBatchTaskResult;
exports.getTenantDatamgmtUsageLatest = getTenantDatamgmtUsageLatest;
exports.getTenantDeviceOriginRanking = getTenantDeviceOriginRanking;
exports.getTenantDeviceRanking = getTenantDeviceRanking;
exports.getTenantFlow = getTenantFlow;
exports.getTenantOriginFlow = getTenantOriginFlow;
exports.getTenantStatisticsDataResultDownloadInfo = getTenantStatisticsDataResultDownloadInfo;
exports.getTenantUsagePercentage = getTenantUsagePercentage;
exports.getThingsLabelValuesByLabelId = getThingsLabelValuesByLabelId;
exports.getThirdLoginAuth = getThirdLoginAuth;
exports.getTryLoginLog = getTryLoginLog;
exports.getUCVerificationCodes = getUCVerificationCodes;
exports.getUserAttr = getUserAttr;
exports.getUserHmiResourceTree = getUserHmiResourceTree;
exports.getUserMessage = getUserMessage;
exports.getUserMessageByUser = getUserMessageByUser;
exports.getUserNoticeByUser = getUserNoticeByUser;
exports.getUserPublicProfile = getUserPublicProfile;
exports.getUserSelfConfig = getUserSelfConfig;
exports.getUsersInfo = getUsersInfo;
exports.getUsersSelfTenant = getUsersSelfTenant;
exports.getVerificationCodes = getVerificationCodes;
exports.getWebInfo = getWebInfo;
exports.getWebList = getWebList;
exports.getbBatchStageDiscount = getbBatchStageDiscount;
exports.handleSingleSingleWorkOrder = handleSingleSingleWorkOrder;
exports.hasPermission = hasPermission;
exports.init = init;
exports.issueAsyncMessage = issueAsyncMessage;
exports.issueGroupDeviceCommand = issueGroupDeviceCommand;
exports.issueRequestDownloadDeviceData = issueRequestDownloadDeviceData;
exports.issueSingleEdgeComputingRule = issueSingleEdgeComputingRule;
exports.issueSingleMulticastGroupMessage = issueSingleMulticastGroupMessage;
exports.issueSingleSingleMulticastGroupMessage = issueSingleSingleMulticastGroupMessage;
exports.issueSingleSingleZigbeeGroupMessage = issueSingleSingleZigbeeGroupMessage;
exports.issueSingleZigbeeGroupMessage = issueSingleZigbeeGroupMessage;
exports.issueSpecialStorageDataBackup = issueSpecialStorageDataBackup;
exports.issueWebInfo = issueWebInfo;
exports.patchBatchFunctionBlockEvent = patchBatchFunctionBlockEvent;
exports.paySingleOrder = paySingleOrder;
exports.postUserMessage = postUserMessage;
exports.queryConnectionPage = queryConnectionPage;
exports.refundSingleOrder = refundSingleOrder;
exports.registerApi = registerApi;
exports.registerErrorCode = registerErrorCode;
exports.relatedBatchProjectResources = relatedBatchProjectResources;
exports.relatedSingleProjectResource = relatedSingleProjectResource;
exports.removeRoles = removeRoles;
exports.sendBatchMessagesByThingsSelector = sendBatchMessagesByThingsSelector;
exports.sendMessagesToDevice = sendMessagesToDevice;
exports.setBaseUrl = setBaseUrl;
exports.setErrorHandler = setErrorHandler;
exports.setFetch = setFetch;
exports.setFetchLocale = setFetchLocale;
exports.setFetchToken = setFetchToken;
exports.setGetStorage = setGetStorage;
exports.setGlobalTimeout = setGlobalTimeout;
exports.setRemoveStorage = setRemoveStorage;
exports.setRequestIntercepter = setRequestIntercepter;
exports.setResponseIntercepter = setResponseIntercepter;
exports.setRoles = setRoles;
exports.setSetStorage = setSetStorage;
exports.updateAdminUserPwd = updateAdminUserPwd;
exports.updateAllMyMessagesReadStatus = updateAllMyMessagesReadStatus;
exports.updateBatchAttributes = updateBatchAttributes;
exports.updateBatchBindDashbord = updateBatchBindDashbord;
exports.updateBatchBindGroupIds = updateBatchBindGroupIds;
exports.updateBatchBindPrivileges = updateBatchBindPrivileges;
exports.updateBatchEventsStatus = updateBatchEventsStatus;
exports.updateBatchFunctionBlockEvent = updateBatchFunctionBlockEvent;
exports.updateBatchMyMessagesReadStatus = updateBatchMyMessagesReadStatus;
exports.updateBatchSimPool = updateBatchSimPool;
exports.updateBatchTenantStatisticsTasksName = updateBatchTenantStatisticsTasksName;
exports.updateBatchThingsAttr = updateBatchThingsAttr;
exports.updateBatchThingsConfiguration = updateBatchThingsConfiguration;
exports.updateBindDashbord = updateBindDashbord;
exports.updateBindHmis = updateBindHmis;
exports.updateComponentConfig = updateComponentConfig;
exports.updateComponentConfigMove = updateComponentConfigMove;
exports.updateConfigInfo = updateConfigInfo;
exports.updateConnection = updateConnection;
exports.updateCustomDownloadTemplateById = updateCustomDownloadTemplateById;
exports.updateDataDownloadStatus = updateDataDownloadStatus;
exports.updateDeviceGlobalTemplate = updateDeviceGlobalTemplate;
exports.updateFunctionBlockAndInfoModel = updateFunctionBlockAndInfoModel;
exports.updateProjectResourcesRelation = updateProjectResourcesRelation;
exports.updateResetPassword = updateResetPassword;
exports.updateRuleStatus = updateRuleStatus;
exports.updateSelfUserInfo = updateSelfUserInfo;
exports.updateSingleAlertAction = updateSingleAlertAction;
exports.updateSingleAlertActionRecovery = updateSingleAlertActionRecovery;
exports.updateSingleAlertRule = updateSingleAlertRule;
exports.updateSingleBindRoles = updateSingleBindRoles;
exports.updateSingleCandtuDTCConfig = updateSingleCandtuDTCConfig;
exports.updateSingleCandtuECU = updateSingleCandtuECU;
exports.updateSingleCustomization = updateSingleCustomization;
exports.updateSingleDBCFile = updateSingleDBCFile;
exports.updateSingleDTCConfig = updateSingleDTCConfig;
exports.updateSingleDataDashbord = updateSingleDataDashbord;
exports.updateSingleDataDashbordPanel = updateSingleDataDashbordPanel;
exports.updateSingleDataDashbordPanelThingsMetrics = updateSingleDataDashbordPanelThingsMetrics;
exports.updateSingleDeviceCategory = updateSingleDeviceCategory;
exports.updateSingleDeviceCategoryTemplate = updateSingleDeviceCategoryTemplate;
exports.updateSingleDeviceDataStatus = updateSingleDeviceDataStatus;
exports.updateSingleECU = updateSingleECU;
exports.updateSingleEdgeRule = updateSingleEdgeRule;
exports.updateSingleEntity = updateSingleEntity;
exports.updateSingleEventsStatus = updateSingleEventsStatus;
exports.updateSingleFirmwareToPublic = updateSingleFirmwareToPublic;
exports.updateSingleFirmwareVersionByNotify = updateSingleFirmwareVersionByNotify;
exports.updateSingleFunctionBlock = updateSingleFunctionBlock;
exports.updateSingleGroup = updateSingleGroup;
exports.updateSingleGroupPrice = updateSingleGroupPrice;
exports.updateSingleGroupStatusPlus = updateSingleGroupStatusPlus;
exports.updateSingleGroupStrategy = updateSingleGroupStrategy;
exports.updateSingleInfoModel = updateSingleInfoModel;
exports.updateSingleInfoModelMapping = updateSingleInfoModelMapping;
exports.updateSingleInfoModelPassword = updateSingleInfoModelPassword;
exports.updateSingleJob = updateSingleJob;
exports.updateSingleJobStatus = updateSingleJobStatus;
exports.updateSingleMappingRuleInfos = updateSingleMappingRuleInfos;
exports.updateSingleMulticastGroup = updateSingleMulticastGroup;
exports.updateSingleOrganization = updateSingleOrganization;
exports.updateSinglePackageContentItem = updateSinglePackageContentItem;
exports.updateSinglePlugin = updateSinglePlugin;
exports.updateSingleProject = updateSingleProject;
exports.updateSingleRepair = updateSingleRepair;
exports.updateSingleRole = updateSingleRole;
exports.updateSingleSimPool = updateSingleSimPool;
exports.updateSingleSingleMulticastGroup = updateSingleSingleMulticastGroup;
exports.updateSingleSingleWorkOrder = updateSingleSingleWorkOrder;
exports.updateSingleSingleZigbeeGroup = updateSingleSingleZigbeeGroup;
exports.updateSingleStatisticsExportTransformPlugin = updateSingleStatisticsExportTransformPlugin;
exports.updateSingleStatisticsMethod = updateSingleStatisticsMethod;
exports.updateSingleStatisticsTask = updateSingleStatisticsTask;
exports.updateSingleStatisticsTaskStatus = updateSingleStatisticsTaskStatus;
exports.updateSingleSubUser = updateSingleSubUser;
exports.updateSingleTenantAudit = updateSingleTenantAudit;
exports.updateSingleTenantLabel = updateSingleTenantLabel;
exports.updateSingleTenantMenu = updateSingleTenantMenu;
exports.updateSingleTenantMenuMove = updateSingleTenantMenuMove;
exports.updateSingleTenants = updateSingleTenants;
exports.updateSingleThingAttributes = updateSingleThingAttributes;
exports.updateSingleThings = updateSingleThings;
exports.updateSingleThingsConnectionStatus = updateSingleThingsConnectionStatus;
exports.updateSingleThingsForwardRule = updateSingleThingsForwardRule;
exports.updateSingleThingsForwardRuleStatus = updateSingleThingsForwardRuleStatus;
exports.updateSingleTwinsRule = updateSingleTwinsRule;
exports.updateSingleUserBindMenus = updateSingleUserBindMenus;
exports.updateSingleUserBindThings = updateSingleUserBindThings;
exports.updateSingleUserCustomization = updateSingleUserCustomization;
exports.updateSingleUserGroupAuth = updateSingleUserGroupAuth;
exports.updateSingleUserPassword = updateSingleUserPassword;
exports.updateSingleWorkOrder = updateSingleWorkOrder;
exports.updateSingleZigbeeGroup = updateSingleZigbeeGroup;
exports.updateTarget = updateTarget;
exports.updateThingsForwardAction = updateThingsForwardAction;
exports.updateThingsForwardActionStatus = updateThingsForwardActionStatus;
exports.updateUserMessageByUser = updateUserMessageByUser;
exports.updateUserMessageStatus = updateUserMessageStatus;
exports.updateUserNotice = updateUserNotice;
exports.updateUserSelfAvatar = updateUserSelfAvatar;
exports.updateUserSelfCurrentPassword = updateUserSelfCurrentPassword;
exports.updateUserSelfEmail = updateUserSelfEmail;
exports.updateUserSelfMobile = updateUserSelfMobile;
exports.updateUsersSelfTenant = updateUsersSelfTenant;
exports.updateUsersSelfTenantSpec = updateUsersSelfTenantSpec;
exports.updateWebInfo = updateWebInfo;
exports.uploadFile = uploadFile;
exports.uploadPackage = uploadPackage;
exports.uploadPart = uploadPart;
exports.uploadSingleCandtuECUUpgradePatch = uploadSingleCandtuECUUpgradePatch;
exports.uploadSingleDBCFile = uploadSingleDBCFile;
exports.uploadSingleECUUpgradePatch = uploadSingleECUUpgradePatch;
exports.uploadUserAttrFile = uploadUserAttrFile;
